/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export type paths = {
  '/generic/is-australian': {
    /**
     * Is Australian
     * @description Returns True if equest has been verified by CloudFlare - otherwise not reachable - John Vesey
     */
    get: operations['is_australian_generic_is_australian_get'];
  };
  '/generic/livez': {
    /**
     * Livez
     * @description Returns Http status 200 OK
     */
    get: operations['livez_generic_livez_get'];
  };
  '/generic/config/{select_value}': {
    /** Config */
    get: operations['config_generic_config__select_value__get'];
  };
  '/bookie/account': {
    /**
     * Bookie Account
     * @description Uses a firebase token to either grab an existing account, or create and return one - Matt Balshaw
     */
    get: operations['bookie_account_bookie_account_get'];
    /**
     * Update Bookie
     * @description Updates a bookies profile - Matt Balshaw
     */
    post: operations['update_bookie_bookie_account_post'];
  };
  '/bookie/account/update_roles': {
    /**
     * Update Bookie Roles
     * @description Updates a bookies profile - Matt Balshaw
     */
    post: operations['update_bookie_roles_bookie_account_update_roles_post'];
  };
  '/bookie/account/record-reset-password': {
    /**
     * Record Reset Password
     * @description Record if a Bookie logs in or logs out. --- Samuel Mcilwain.
     */
    post: operations['record_reset_password_bookie_account_record_reset_password_post'];
  };
  '/bookie/account/record-action': {
    /** Record Punter Action */
    post: operations['record_punter_action_bookie_account_record_action_post'];
  };
  '/bookie/account/authz': {
    /** Get Authorisation Token */
    get: operations['get_authorisation_token_bookie_account_authz_get'];
  };
  '/bookie/bank/deposits': {
    /**
     * Get Deposits
     * @description Get a list of deposits for a punter.
     */
    get: operations['get_deposits_bookie_bank_deposits_get'];
  };
  '/bookie/bank/deposits/reconcile': {
    /**
     * Reconcile Deposit
     * @description Reconcile deposits for a punter.
     * Bookie can change the amount of the deposit.
     */
    post: operations['reconcile_deposit_bookie_bank_deposits_reconcile_post'];
  };
  '/bookie/bank/deposits/sync': {
    /** Sync Deposits */
    post: operations['sync_deposits_bookie_bank_deposits_sync_post'];
  };
  '/bookie/bank/deposits/fz/list': {
    /** Get Fz Deposit List */
    get: operations['get_fz_deposit_list_bookie_bank_deposits_fz_list_get'];
  };
  '/bookie/bank/deposits/fz/{reference}': {
    /** Get Fz Deposit */
    get: operations['get_fz_deposit_bookie_bank_deposits_fz__reference__get'];
  };
  '/bookie/bank/withdrawals/status': {
    /**
     * Get Pending Withdrawals
     * @description returns a list of pending withdrawals for a bookies platform - Ginger Bread Sam
     */
    get: operations['get_pending_withdrawals_bookie_bank_withdrawals_status_get'];
    /** Update Withdrawal Status */
    patch: operations['update_withdrawal_status_bookie_bank_withdrawals_status_patch'];
  };
  '/bookie/bank/withdrawals/download': {
    /**
     * Download Specified Withdrawals
     * @description Given a list of withdrawal ids, generates and returns an aba of the requested withdrawals
     *
     * [File format information](https://www.cemtexaba.com/aba-format/cemtex-aba-file-format-details)
     *
     * *Matt Balshaw*
     */
    post: operations['download_specified_withdrawals_bookie_bank_withdrawals_download_post'];
  };
  '/bookie/bank/withdrawals/history': {
    /** History */
    get: operations['history_bookie_bank_withdrawals_history_get'];
  };
  '/bookie/bank/withdrawals/stats': {
    /** Stats */
    get: operations['stats_bookie_bank_withdrawals_stats_get'];
  };
  '/bookie/bet-approvals': {
    /** Get Bet Approvals Pending */
    get: operations['get_bet_approvals_pending_bookie_bet_approvals_get'];
  };
  '/bookie/bet-approvals/history': {
    /** Get Bet Approvals History */
    get: operations['get_bet_approvals_history_bookie_bet_approvals_history_get'];
  };
  '/bookie/bet-approvals/claim': {
    /**
     * Claim Bet Request
     * @description Claims a specific bet request for a single bookie
     *
     * *Matt Balshaw*
     */
    post: operations['claim_bet_request_bookie_bet_approvals_claim_post'];
  };
  '/bookie/bet-approvals/status': {
    /** Change Bet Request Status */
    post: operations['change_bet_request_status_bookie_bet_approvals_status_post'];
  };
  '/bookie/bet-approvals/settle-bet': {
    /** Settle Bet Manually */
    post: operations['settle_bet_manually_bookie_bet_approvals_settle_bet_post'];
  };
  '/bookie/bet-approvals/download': {
    /**
     * Download Bet Approvals
     * @description Returns a csv of formatted bet approval rows for a given list of ids
     * orders the csv by bet request created date
     *
     * *Matt Balshaw*
     */
    post: operations['download_bet_approvals_bookie_bet_approvals_download_post'];
  };
  '/bookie/bet-approvals/remote-update-status': {
    /**
     * Remote Change Bet Request Status
     * @description Accepts a bet approval request from the global bet approvals system
     */
    post: operations['remote_change_bet_request_status_bookie_bet_approvals_remote_update_status_post'];
  };
  '/bookie/offerings/race-offerings': {
    /**
     * Get Platform Race Offerings
     * @description Returns a data structure representing all the race types that each venue offers.
     * Uses the platform of whichever bookie is requesting the data.
     *
     * *Matt Balshaw*
     */
    get: operations['get_platform_race_offerings_bookie_offerings_race_offerings_get'];
    /**
     * Update Venue Offering
     * @description Given a list of venue IDs, if they are to be offered or not, and optionally a specific race type, changes the bookie race venue offering - Matt Balshaw
     */
    post: operations['update_venue_offering_bookie_offerings_race_offerings_post'];
  };
  '/bookie/offerings/sport-offerings': {
    /** Get Platform Sport Offering */
    get: operations['get_platform_sport_offering_bookie_offerings_sport_offerings_get'];
    /** Update Sport Offering */
    post: operations['update_sport_offering_bookie_offerings_sport_offerings_post'];
  };
  '/bookie/placed-bets': {
    /**
     * Platform Bets
     * @description Returns a list of bets made on this platform
     * Default order by bet created_at desc
     * Supports offset paginated retrieval
     * *Matt Balshaw*
     */
    get: operations['platform_bets_bookie_placed_bets_get'];
  };
  '/bookie/promos/bonus/bonus-bet': {
    /** Bonus Award */
    get: operations['bonus_award_bookie_promos_bonus_bonus_bet_get'];
  };
  '/bookie/promos/bonus-bets/bulk-bonus-award': {
    /**
     * Bulk Bonus Award
     * @description Bulk award punters some bonus balance.
     * Bonus balance will be added onto punters existing bonus balance.
     * Bonus amount must be greater than zero.
     *
     * *Matt Balshaw*
     */
    post: operations['bulk_bonus_award_bookie_promos_bonus_bets_bulk_bonus_award_post'];
  };
  '/bookie/promos/bonus-bets/bonus-award': {
    /**
     * Bonus Award
     * @description Revoke and existing bonus transaction
     * Existing bonus_balance of the related punter will be deducted.
     */
    post: operations['bonus_award_bookie_promos_bonus_bets_bonus_award_post'];
  };
  '/bookie/promos/bonus-bets/bonus-revoke': {
    /**
     * Bonus Revoke
     * @description Revoke a bonus award
     */
    post: operations['bonus_revoke_bookie_promos_bonus_bets_bonus_revoke_post'];
  };
  '/bookie/promos/token/token': {
    /** Add Punter Token */
    post: operations['add_punter_token_bookie_promos_token_token_post'];
  };
  '/bookie/promos/token/token-history': {
    /**
     * Get Token History
     * @description Returns token history for a given token type and punter
     */
    get: operations['get_token_history_bookie_promos_token_token_history_get'];
  };
  '/bookie/promos/token/token-summary': {
    /**
     * Get Token Summary
     * @description Returns summary of available and used tokens for punter.
     * If no token_type is specified, will return data for all token types
     */
    get: operations['get_token_summary_bookie_promos_token_token_summary_get'];
  };
  '/bookie/promos/promo/bulk-promo-upload': {
    /**
     * Bulk Promo Upload
     * @description Bulk create promotion for punters
     */
    post: operations['bulk_promo_upload_bookie_promos_promo_bulk_promo_upload_post'];
  };
  '/bookie/promos/promo/promo-summary': {
    /**
     * Get Promo Summary
     * @description Return summary info for promotions
     */
    get: operations['get_promo_summary_bookie_promos_promo_promo_summary_get'];
  };
  '/bookie/promos/promo/promo-punters': {
    /**
     * Get Promo Punters
     * @description Return the punter list for a promotion
     */
    get: operations['get_promo_punters_bookie_promos_promo_promo_punters_get'];
  };
  '/bookie/promos/promo/promo-punters-csv': {
    /**
     * Get Promo Punters Csv
     * @description Return the punter list for a promotion as a CSV
     */
    get: operations['get_promo_punters_csv_bookie_promos_promo_promo_punters_csv_get'];
  };
  '/bookie/promos/promo/promotion': {
    /**
     * Add Punter Promo
     * @description Add a promotion to an individual punter
     */
    post: operations['add_punter_promo_bookie_promos_promo_promotion_post'];
  };
  '/bookie/promos/promo/cancel': {
    /**
     * Cancel Punter Promo
     * @description Cancel a promo
     */
    post: operations['cancel_punter_promo_bookie_promos_promo_cancel_post'];
  };
  '/bookie/punters/activity/statements': {
    /** Upsert Statements */
    post: operations['upsert_statements_bookie_punters_activity_statements_post'];
  };
  '/bookie/punters/adjustments': {
    /** Punter Account Adjustment */
    post: operations['punter_account_adjustment_bookie_punters_adjustments_post'];
  };
  '/bookie/punters/bets/{punter_id}': {
    /**
     * Punter Bets
     * @description Returns all matching events for a given Punter,
     * with default order by bet created_at desc
     * support for offset paginated retrieval
     * *Matt Balshaw*
     */
    get: operations['punter_bets_bookie_punters_bets__punter_id__get'];
  };
  '/bookie/punters/bets/cancel': {
    /**
     * Cancel Bet
     * @description Bookie refunds the stake of the specified bet
     */
    post: operations['cancel_bet_bookie_punters_bets_cancel_post'];
  };
  '/bookie/punters/incentives/bonus-bets': {
    /** Get Incentives */
    get: operations['get_incentives_bookie_punters_incentives_bonus_bets_get'];
  };
  '/bookie/punters/incentives/promotions': {
    /** Get Punter Promotions */
    get: operations['get_punter_promotions_bookie_punters_incentives_promotions_get'];
  };
  '/bookie/punters/limits/deposit-limit/{punter_id}': {
    /**
     * Get Deposit Limits
     * @description Given a punter id, gets all deposit limit history for that punter,
     * including optional bookie id if bookie set deposit limit - *Daniel Morley*
     */
    get: operations['get_deposit_limits_bookie_punters_limits_deposit_limit__punter_id__get'];
    /**
     * Set Deposit Limit
     * @description Sets a deposit limit by the bookie on behalf of a punter - *Daniel Morley*
     */
    post: operations['set_deposit_limit_bookie_punters_limits_deposit_limit__punter_id__post'];
  };
  '/bookie/punters/limits/deposit-limit/current/{punter_id}': {
    /**
     * Get Deposit Limit
     * @description Given a punter id, gets the deposit limit for that punter,
     * including optional bookie id if bookie set deposit limit - *Daniel Morley*
     */
    get: operations['get_deposit_limit_bookie_punters_limits_deposit_limit_current__punter_id__get'];
  };
  '/bookie/punters/notes/attachments/{note_id}': {
    /**
     * Add Attachment
     * @description Adds attachment to specified note - Daniel Morley
     */
    post: operations['add_attachment_bookie_punters_notes_attachments__note_id__post'];
  };
  '/bookie/punters/notes': {
    /** Get Punter Notes */
    get: operations['get_punter_notes_bookie_punters_notes_get'];
    /**
     * Create Punter Note
     * @description Creates a punter note when sent a note in NewPunterNote format then returns that note --Aneurin Hall
     */
    post: operations['create_punter_note_bookie_punters_notes_post'];
    /**
     * Delete Punter Note
     * @description Deletes a punter note given a punter id --Aneurin Hall
     */
    delete: operations['delete_punter_note_bookie_punters_notes_delete'];
  };
  '/bookie/punters/notes/attachment/{attachment_id}': {
    /**
     * Delete Attachment
     * @description When given an attachment id, attachment deleted from db
     */
    delete: operations['delete_attachment_bookie_punters_notes_attachment__attachment_id__delete'];
  };
  '/bookie/punters/notes/{note_id}': {
    /**
     * Update Punter Note
     * @description Updates a punter note when sent a note in NewPunterNote format then returns that note - Daniel Morley
     */
    post: operations['update_punter_note_bookie_punters_notes__note_id__post'];
  };
  '/bookie/punters/punter-sticky-note/{punter_id}': {
    /** Get Punter Sticky Note */
    get: operations['get_punter_sticky_note_bookie_punters_punter_sticky_note__punter_id__get'];
    /**
     * Update Punter Sticky Note
     * @description Upserts a punter profile sticky note when sent a note in StickyNoteUpdateSchema format then returns that note in StickyNoteSchema format
     */
    post: operations['update_punter_sticky_note_bookie_punters_punter_sticky_note__punter_id__post'];
    /**
     * Delete Punter Sticky Note
     * @description If such exists, sets the subject punter sticky note text to None (NULL), otherwise has no
     * effect if the punter does not have a sticky note.
     */
    delete: operations['delete_punter_sticky_note_bookie_punters_punter_sticky_note__punter_id__delete'];
  };
  '/bookie/punters/profile/add-flag': {
    /**
     * Add Punter Flag
     * @description Flags the subject Punter by where necessary adding a new flag table entry with a unique value of (punter_id, label)
     */
    post: operations['add_punter_flag_bookie_punters_profile_add_flag_post'];
  };
  '/bookie/punters/profile/delete-flag': {
    /**
     * Delete Punter Flag
     * @description UnFlags the subject Punter removing an existing flag table entry with the unique value of (bookie_id, label)
     */
    delete: operations['delete_punter_flag_bookie_punters_profile_delete_flag_delete'];
  };
  '/bookie/punters/profile/{punter_id}': {
    /**
     * Get Punter Profile
     * @description Checks to see if bookie on same platform as punter, if so, returns punter profile - Daniel Morley
     */
    get: operations['get_punter_profile_bookie_punters_profile__punter_id__get'];
  };
  '/bookie/punters/profile': {
    /**
     * Update Punter
     * @description Updates a punter profile as a bookie - Daniel Morley
     */
    post: operations['update_punter_bookie_punters_profile_post'];
  };
  '/bookie/punters/profile/status/exclude-permanently': {
    /** Update Punter Status Exclude Permanently */
    put: operations['update_punter_status_exclude_permanently_bookie_punters_profile_status_exclude_permanently_put'];
  };
  '/bookie/punters/profile/{punter_id}/meta': {
    /**
     * Get Punter Metadata
     * @description Checks to see if bookie on same platform as punter, if so, returns punter metadata - Daniel Morley
     */
    get: operations['get_punter_metadata_bookie_punters_profile__punter_id__meta_get'];
  };
  '/bookie/punters/search': {
    /** Punter Search */
    get: operations['punter_search_bookie_punters_search_get'];
  };
  '/bookie/punters/blacklist': {
    /**
     * Blacklist
     * @description Generate the Blacklist records from the supplied list of blacklisted punters
     * All existing blacklist records will be replaced by this new list
     */
    post: operations['blacklist_bookie_punters_blacklist_post'];
  };
  '/bookie/punters/stats/{punter_id}': {
    /**
     * Punter Stats
     * @description For the procurement of Stats for a given punter - Craig Ryan
     */
    get: operations['punter_stats_bookie_punters_stats__punter_id__get'];
  };
  '/bookie/punters/transactions': {
    /**
     * Get Punter Transactions
     * @description Get a list of transactions for a punter
     *     Notes:
     *         - If offset_timestamp is provided, it will be used instead of offset.
     */
    get: operations['get_punter_transactions_bookie_punters_transactions_get'];
  };
  '/bookie/punters/transactions/download-all': {
    /**
     * Download Punter Transactions
     * @description For the punter requesting, returns a csv with all their transaction history.
     *
     * *Matt Balshaw*
     */
    get: operations['download_punter_transactions_bookie_punters_transactions_download_all_get'];
  };
  '/bookie/punters/punter-settings/{punter_id}': {
    /**
     * Get Punter Settings
     * @description Checks to see if bookie on same platform as punter, if so, returns punter settings
     */
    get: operations['get_punter_settings_bookie_punters_punter_settings__punter_id__get'];
  };
  '/bookie/punters/punter-settings': {
    /**
     * Update Punter Settings
     * @description Updates a punters settings as a bookie
     */
    post: operations['update_punter_settings_bookie_punters_punter_settings_post'];
  };
  '/bookie/punters/deposits': {
    /**
     * Get Deposits
     * @description Get a list of deposits for a punter.
     */
    get: operations['get_deposits_bookie_punters_deposits_get'];
  };
  '/bookie/punters/deposits/reconcile': {
    /**
     * Reconcile Deposit
     * @description Reconcile deposits for a punter.
     * Bookie can change the amount of the deposit.
     */
    post: operations['reconcile_deposit_bookie_punters_deposits_reconcile_post'];
  };
  '/bookie/punters/deposits/sync': {
    /** Sync Deposits */
    post: operations['sync_deposits_bookie_punters_deposits_sync_post'];
  };
  '/bookie/punters/deposits/fz/list': {
    /** Get Fz Deposit List */
    get: operations['get_fz_deposit_list_bookie_punters_deposits_fz_list_get'];
  };
  '/bookie/punters/deposits/fz/{reference}': {
    /** Get Fz Deposit */
    get: operations['get_fz_deposit_bookie_punters_deposits_fz__reference__get'];
  };
  '/bookie/punters/cards/{punter_id}': {
    /**
     * Punters Cards
     * @description Get all the cards for the punter in the database.
     */
    get: operations['punters_cards_bookie_punters_cards__punter_id__get'];
  };
  '/bookie/punters/cards': {
    /** Update Card */
    post: operations['update_card_bookie_punters_cards_post'];
    /** Delete Card */
    delete: operations['delete_card_bookie_punters_cards_delete'];
  };
  '/bookie/punters/banks/{punter_id}': {
    /**
     * Get Banks
     * @description Returns all matching banks for a given Punter
     */
    get: operations['get_banks_bookie_punters_banks__punter_id__get'];
  };
  '/bookie/punters/banks': {
    /**
     * Delete Bank
     * @description Delete the matching Bank from a given Punter
     */
    delete: operations['delete_bank_bookie_punters_banks_delete'];
  };
  '/bookie/punters/myaffiliates': {
    /** Save Myaffiliates */
    post: operations['save_myaffiliates_bookie_punters_myaffiliates_post'];
  };
  '/bookie/settings/activity-log/punter-actions': {
    /** Punter Actions */
    get: operations['punter_actions_bookie_settings_activity_log_punter_actions_get'];
  };
  '/bookie/settings/activity-log/bookie-actions': {
    /** Bookie Actions */
    get: operations['bookie_actions_bookie_settings_activity_log_bookie_actions_get'];
  };
  '/bookie/settings/activity-log/bookies-for-platform': {
    /** Bookies For Platform */
    get: operations['bookies_for_platform_bookie_settings_activity_log_bookies_for_platform_get'];
  };
  '/bookie/settings/limits/global-exposure-limits': {
    /** Get Global Exposure Limits */
    get: operations['get_global_exposure_limits_bookie_settings_limits_global_exposure_limits_get'];
    /** Update Global Exposure Limits */
    post: operations['update_global_exposure_limits_bookie_settings_limits_global_exposure_limits_post'];
  };
  '/bookie/settings/profile': {
    /** Get Bookie Profile */
    get: operations['get_bookie_profile_bookie_settings_profile_get'];
    /**
     * Update Profile
     * @description Update the bookie profile,
     */
    patch: operations['update_profile_bookie_settings_profile_patch'];
  };
  '/bookie/settings/system/terms': {
    /**
     * Get Terms Of Service
     * @description Retreives the terms of service for a platform from the database and returns them - Daniel Morley
     */
    get: operations['get_terms_of_service_bookie_settings_system_terms_get'];
    /**
     * Update Terms Of Service
     * @description Updates the terms of service for a platform - Daniel Morley
     */
    post: operations['update_terms_of_service_bookie_settings_system_terms_post'];
  };
  '/bookie/settings/system/privacy': {
    /**
     * Get Privacy Policy
     * @description Retreives the privacy policy for a platform from the database and returns them - Daniel Morley
     */
    get: operations['get_privacy_policy_bookie_settings_system_privacy_get'];
    /**
     * Update Privacy Policy
     * @description Updates the privacy policy for a platform - Daniel Morley
     */
    post: operations['update_privacy_policy_bookie_settings_system_privacy_post'];
  };
  '/bookie/settings/system/bank': {
    /**
     * Get Bank Details
     * @description Retreives the bank details for the bookie's platform from the database and returns them - *Daniel Morley*
     */
    get: operations['get_bank_details_bookie_settings_system_bank_get'];
    /**
     * Update Platform Bank Details
     * @description Updates the bank details for a platform - *Daniel Morley*
     */
    post: operations['update_platform_bank_details_bookie_settings_system_bank_post'];
  };
  '/bookie/settings/system/contact': {
    /** Get Platform Contact Details */
    get: operations['get_platform_contact_details_bookie_settings_system_contact_get'];
    /**
     * Update Platform Contact Details
     * @description Updates the contact details for a platform - *Daniel Morley*
     */
    post: operations['update_platform_contact_details_bookie_settings_system_contact_post'];
  };
  '/bookie/settings/system/update_permission_roles': {
    /**
     * Update Permission Roles
     * @description Updates the roles that have a permission
     */
    post: operations['update_permission_roles_bookie_settings_system_update_permission_roles_post'];
  };
  '/bookie/settings/system/permissions': {
    /**
     * Get All Permissions
     * @description Retrieves all permissions and their assigned roles
     */
    get: operations['get_all_permissions_bookie_settings_system_permissions_get'];
  };
  '/bookie/settings/system/offerings': {
    /**
     * Get System Offerings
     * @description Retrieves system offerings
     */
    get: operations['get_system_offerings_bookie_settings_system_offerings_get'];
    /**
     * Update System Offerings
     * @description Updates system offerings
     */
    post: operations['update_system_offerings_bookie_settings_system_offerings_post'];
  };
  '/bookie/settings/system/offerings/srm': {
    /** Get Offerings Srm */
    get: operations['get_offerings_srm_bookie_settings_system_offerings_srm_get'];
    /** Update Offerings Srm */
    post: operations['update_offerings_srm_bookie_settings_system_offerings_srm_post'];
  };
  '/bookie/options/punter-categories': {
    /** Get Bookie Profile */
    get: operations['get_bookie_profile_bookie_options_punter_categories_get'];
  };
  '/bookie/storm/load': {
    /**
     * Update Storm Settings
     * @description Endpoint to ingest storm punter settings
     *
     * Its an all or nothing affair. To ensure absolute certainty of affected Punter Settings the return
     * verifies the mods by returning a list of punter_id
     *
     * Returns: a list of the supplied Punter_id values as list[str]
     */
    post: operations['update_storm_settings_bookie_storm_load_post'];
  };
  '/bookie/storm/tokens': {
    /**
     * Update Storm Tokens
     * @description Endpoint to ingest tokens from storm
     *
     * Returns: a list of the supplied Punter_id values as list[str]
     */
    post: operations['update_storm_tokens_bookie_storm_tokens_post'];
  };
  '/bookie/storm/promotions': {
    /**
     * Update Storm Promos
     * @description Endpoint to ingest promotions from storm
     *
     * Returns: a list of the supplied Punter_id values as list[str]
     */
    post: operations['update_storm_promos_bookie_storm_promotions_post'];
  };
  '/bookie/scoreboard/tableau-token': {
    /** Get Tableau Token */
    get: operations['get_tableau_token_bookie_scoreboard_tableau_token_get'];
  };
  '/bookie/trade-manager/by-racing/locations': {
    /**
     * Get Country And States
     * @description Given a race type (optional) return all locations (country and state) offered by the bookies platform - Craig
     * Ryan
     */
    get: operations['get_country_and_states_bookie_trade_manager_by_racing_locations_get'];
  };
  '/bookie/trade-manager/by-racing/venues': {
    /**
     * Get Venue Name And Notifications
     * @description Given a race type, state, and country, return all the venues which the bookies' platform offers,
     * and indicate if the venue has any races - Matt Balshaw
     */
    get: operations['get_venue_name_and_notifications_bookie_trade_manager_by_racing_venues_get'];
  };
  '/bookie/trade-manager/by-racing': {
    /**
     * By Racing
     * @description Generic endpoint for grabbing data for the by racing tab -- Aneurin Hall
     * params:
     * - race_type: (optional) filter by race_type
     * - state: (optional) filter by venue state (domestic only)
     * - country: (optional) filter by country (international only)
     * - venue_id: (optional) filter by a given venue UUID
     * - resulted: (optional) filter by whether results have been announced
     * - period_start: (optional) get dates after a certain datetime
     * - period_end: (optional) get dates before a certain datetime, if period_start not set defaults to now
     * - offset: the record to start from, default 0
     * - limit: the number of records to show on each page, default 20
     * - sort_by: the key to sort records by ("start_time" or "event_title")
     * - sort_direction: the direction to sort records by ("asc" or "desc"), default asc
     */
    get: operations['by_racing_bookie_trade_manager_by_racing_get'];
  };
  '/bookie/trade-manager/by-sport/sport-list': {
    /**
     * Get All Sports
     * @description Returns all sports where the bookie offers at least one competition -- Matt Balshaw
     */
    get: operations['get_all_sports_bookie_trade_manager_by_sport_sport_list_get'];
  };
  '/bookie/trade-manager/by-sport/competitions-tournaments-for-sport': {
    /**
     * Get Competitions Tournaments For Sport
     * @description Given a sport id, returns all competitions and tournaments  -- Aneurin Hall
     */
    get: operations['get_competitions_tournaments_for_sport_bookie_trade_manager_by_sport_competitions_tournaments_for_sport_get'];
  };
  '/bookie/trade-manager/by-sport': {
    /**
     * Get By Sport
     * @description Returns all matching events with default order by start_time asc with support for
     * offset paginated retrieval -- Dean Brown
     */
    get: operations['get_by_sport_bookie_trade_manager_by_sport_get'];
  };
  '/bookie/trade-manager/find-an-event': {
    /**
     * Find An Event
     * @description Endpoint to grab events for the find an event tab
     *
     * - event_name: (optional) fulltext search the event name
     * - sport_id: (optional) filter by the UUID of a sport
     * - race_type: (optional) filter by race_type
     * - competition_id: (optional) filter by the UUID of a competition
     * - tournament_id: (optional) filter by the UUID of a tournament
     * - resulted: (optional) filter by whether results have been announced
     * - start_date: (optional) filter by a given date in YYYY-MM-DD format
     * - end_date: (optional) upper bound to get a date slice in YYYY-MM-DD format
     * - offset: the record to start from, default 0
     * - limit: the number of records to show on each page, default 20
     * - sort_by: the key to sort records by ("start_time" or "event_title")
     * - sort_direction: the direction to sort records by ("asc" or "desc"), default asc
     *
     * *Matt Balshaw*
     */
    get: operations['find_an_event_bookie_trade_manager_find_an_event_get'];
  };
  '/bookie/trade-manager/global-margins/global-sport-margin': {
    /**
     * Get Global Sport Margin
     * @description Gets the global margin from the platform table - Matt Balshaw
     */
    get: operations['get_global_sport_margin_bookie_trade_manager_global_margins_global_sport_margin_get'];
    /**
     * Change Global Sport Margin
     * @description Updates the global sport margin on the platform table - Matt Balshaw
     */
    post: operations['change_global_sport_margin_bookie_trade_manager_global_margins_global_sport_margin_post'];
  };
  '/bookie/trade-manager/global-margins/global-race-margin': {
    /**
     * Get Global Race Margin
     * @description Gets the global race from the platform table - Matt Balshaw
     */
    get: operations['get_global_race_margin_bookie_trade_manager_global_margins_global_race_margin_get'];
    /**
     * Change Global Race Margin
     * @description Updates the global race margin on the platform table - Matt Balshaw
     */
    post: operations['change_global_race_margin_bookie_trade_manager_global_margins_global_race_margin_post'];
  };
  '/bookie/trade-manager/global-margins/sport-margins': {
    /**
     * Get Sport Margins
     * @description Returns a list of all modified sports for the bookies platform, with modified competitions nested into each
     * sport - Matt Balshaw
     */
    get: operations['get_sport_margins_bookie_trade_manager_global_margins_sport_margins_get'];
    /**
     * Edit Sport And Competition Margins
     * @description Frontend is going to send us a flat list of sports and competitions, and anything missing should be deleted -
     * Matt Balshaw
     */
    post: operations['edit_sport_and_competition_margins_bookie_trade_manager_global_margins_sport_margins_post'];
  };
  '/bookie/trade-manager/global-margins/race-margins': {
    /**
     * Get Race Margins
     * @description Returns a list of all modified race types for the bookies platform, with modified venues nested into each race
     * type - Matt Balshaw
     */
    get: operations['get_race_margins_bookie_trade_manager_global_margins_race_margins_get'];
    /**
     * Edit Race Type And Venue Margins
     * @description Frontend is going to send us a flat list of race types and venues with race type, and anything missing should
     * be deleted - Matt Balshaw
     */
    post: operations['edit_race_type_and_venue_margins_bookie_trade_manager_global_margins_race_margins_post'];
  };
  '/bookie/trade-manager/multi': {
    /** Get Multi View */
    get: operations['get_multi_view_bookie_trade_manager_multi_get'];
  };
  '/bookie/trade-manager/next-to-jump': {
    /**
     * Get Next To Jump
     * @description Returns all matching events with default order by start_time asc with support for
     * cursor paginated retrieval from a next_start_time, optionally only for
     * one specific event type.
     *
     * Filters out any events not on this bookies platform.
     *
     * Ascending sort, so last_value is MIN value
     *
     * *Dean Brown*
     */
    get: operations['get_next_to_jump_bookie_trade_manager_next_to_jump_get'];
  };
  '/bookie/trade-manager/next-to-jump/races': {
    /**
     * Get Next Jump Races
     * @deprecated
     * @description Returns all the races ordered by next to jump first, optionally only for one specific race type.
     * Filters out any races not on this bookies platform, and any races that don't have the "normal" status
     *
     * *Matt Balshaw*
     */
    get: operations['get_next_jump_races_bookie_trade_manager_next_to_jump_races_get'];
  };
  '/bookie/trade-manager/race-details': {
    /**
     * Get Race Data
     * @description Given a race id, returns all the data for that race including runners - Matt Balshaw
     */
    get: operations['get_race_data_bookie_trade_manager_race_details_get'];
  };
  '/bookie/trade-manager/race-details/race-numbers-for-venue': {
    /**
     * Race Numbers For Venue
     * @description Given a race id get the venue its offered at and return the race numbers -- Samuel Flynn.
     */
    get: operations['race_numbers_for_venue_bookie_trade_manager_race_details_race_numbers_for_venue_get'];
  };
  '/bookie/trade-manager/race-details/runner-margins': {
    /** Edit Multiple Race Runner Margins */
    post: operations['edit_multiple_race_runner_margins_bookie_trade_manager_race_details_runner_margins_post'];
  };
  '/bookie/trade-manager/race-details/bets-for-runner': {
    /**
     * Get Bets For Runner
     * @description Given a race_runner UUID returns a list of bets associated with that RaceRunner -- Matt Balshaw
     */
    get: operations['get_bets_for_runner_bookie_trade_manager_race_details_bets_for_runner_get'];
  };
  '/bookie/trade-manager/race-details/runners': {
    /**
     * Get Runners For Race
     * @description Given a race_id returns a formatted list of runners, ordered by barrier number -- Matt Balshaw
     */
    get: operations['get_runners_for_race_bookie_trade_manager_race_details_runners_get'];
  };
  '/bookie/trade-manager/race-details/race-result': {
    /**
     * Race Results
     * @description Given a race id, returns the runners who resulted in the race with their final odds
     *
     * Note: This is legit duplicated code from the endpoint punter/races/race-details/race-results
     *
     * I decided to duplicate the code to keep bookie & punter decoupled,
     * also because we may change this endpoint to return some bookie specific info
     *
     * *Matt Balshaw*
     */
    get: operations['race_results_bookie_trade_manager_race_details_race_result_get'];
  };
  '/bookie/trade-manager/race-details/settle-race': {
    /** Settle Race */
    post: operations['settle_race_bookie_trade_manager_race_details_settle_race_post'];
  };
  '/bookie/trade-manager/race-details/race-markets': {
    /** Race Markets */
    get: operations['race_markets_bookie_trade_manager_race_details_race_markets_get'];
  };
  '/bookie/trade-manager/race-details/bets-for-exotics': {
    /**
     * Get Exotic Bets For Race
     * @description Given a race_id UUID returns a list of exotic bets associated with that Race
     */
    get: operations['get_exotic_bets_for_race_bookie_trade_manager_race_details_bets_for_exotics_get'];
  };
  '/bookie/trade-manager/race-details/fptp-protest-override': {
    /** Fptp Protest Override */
    post: operations['fptp_protest_override_bookie_trade_manager_race_details_fptp_protest_override_post'];
  };
  '/bookie/trade-manager/race-details/lock-price': {
    /** Lock Price */
    post: operations['lock_price_bookie_trade_manager_race_details_lock_price_post'];
  };
  '/bookie/trade-manager/race-details/force-price-type-approval': {
    /** Force Price Type Approvals */
    post: operations['force_price_type_approvals_bookie_trade_manager_race_details_force_price_type_approval_post'];
  };
  '/bookie/trade-manager/race-details/update-price-types': {
    /** Update Price Types */
    post: operations['update_price_types_bookie_trade_manager_race_details_update_price_types_post'];
  };
  '/bookie/trade-manager/race-details/manual-runner-status-update': {
    /** Runner Status Update */
    post: operations['runner_status_update_bookie_trade_manager_race_details_manual_runner_status_update_post'];
  };
  '/bookie/trade-manager/race-details/refresh-winter-race': {
    /** Refresh Winter Race */
    get: operations['refresh_winter_race_bookie_trade_manager_race_details_refresh_winter_race_get'];
  };
  '/bookie/trade-manager/race-details/refresh-winter-meets': {
    /** Refresh Winter Meets */
    get: operations['refresh_winter_meets_bookie_trade_manager_race_details_refresh_winter_meets_get'];
  };
  '/bookie/trade-manager/race-details/manual-race-status-update': {
    /** Race Status Update */
    post: operations['race_status_update_bookie_trade_manager_race_details_manual_race_status_update_post'];
  };
  '/bookie/trade-manager/race-details/races/{race_id}/settings': {
    /** Update Match Settings */
    patch: operations['update_match_settings_bookie_trade_manager_race_details_races__race_id__settings_patch'];
  };
  '/bookie/trade-manager/sport-details/matches-of-same-competition-tournament': {
    /**
     * Matches Of Same Competition Tournament
     * @description Given a match UUID returns all matches in the same competition, or tournament if match has tournament -- Craig Ryan
     */
    get: operations['matches_of_same_competition_tournament_bookie_trade_manager_sport_details_matches_of_same_competition_tournament_get'];
  };
  '/bookie/trade-manager/sport-details/match': {
    /**
     * Get Match Data
     * @description Given a match id, returns all the data for that match - Craig Ryan
     */
    get: operations['get_match_data_bookie_trade_manager_sport_details_match_get'];
  };
  '/bookie/trade-manager/sport-details/refresh-winter-match': {
    /** Refresh Winter Match */
    get: operations['refresh_winter_match_bookie_trade_manager_sport_details_refresh_winter_match_get'];
  };
  '/bookie/trade-manager/sport-details/match-margin': {
    /**
     * Match Margin
     * @description Given a market id, update the margin --- Samuel Flynn.
     */
    post: operations['match_margin_bookie_trade_manager_sport_details_match_margin_post'];
  };
  '/bookie/trade-manager/sport-details/market-margin': {
    /**
     * Market Margin
     * @description Given a market id and modifier, update the margin on the market - Samuel Flynn.
     */
    post: operations['market_margin_bookie_trade_manager_sport_details_market_margin_post'];
  };
  '/bookie/trade-manager/sport-details/proposition-margin': {
    /**
     * Proposition Margin
     * @description Given a proposition id and modifier, update the margin on the proposition - Samuel Flynn.
     */
    post: operations['proposition_margin_bookie_trade_manager_sport_details_proposition_margin_post'];
  };
  '/bookie/trade-manager/sport-details/market-types-for-match': {
    /**
     * Get Market Types For Match
     * @deprecated
     * @description Given a match UUID returns list containing market types (no order guarantees) -- Aneurin Hall
     */
    get: operations['get_market_types_for_match_bookie_trade_manager_sport_details_market_types_for_match_get'];
  };
  '/bookie/trade-manager/sport-details/markets-for-match-market-type': {
    /**
     * Get Markets For Match Market Type
     * @deprecated
     * @description given a match and a market type returns all markets and propositions -- Aneurin Hall
     */
    get: operations['get_markets_for_match_market_type_bookie_trade_manager_sport_details_markets_for_match_market_type_get'];
  };
  '/bookie/trade-manager/sport-details/proposition-for-market': {
    /** Get Propositions For Market Id */
    get: operations['get_propositions_for_market_id_bookie_trade_manager_sport_details_proposition_for_market_get'];
  };
  '/bookie/trade-manager/sport-details/bets-for-market': {
    /**
     * Get Bets For Market
     * @description Given a market UUID returns a list of details for each bets in the market.
     * This includes details of the punter that made the bet, the proposition type and the odds,
     * stake and status of the bet. - *Daniel Morley*
     */
    get: operations['get_bets_for_market_bookie_trade_manager_sport_details_bets_for_market_get'];
  };
  '/bookie/trade-manager/sport-details/market-groups/{match_id}': {
    /**
     * Get Market Groups
     * @description Given a match id returns all of the market groups - *Daniel Morley*
     */
    get: operations['get_market_groups_bookie_trade_manager_sport_details_market_groups__match_id__get'];
  };
  '/bookie/trade-manager/sport-details/markets': {
    /**
     * Get Markets For Group Id
     * @description Given a match id and a market group id returns all of the markets in that group.
     * This endpoint replaces markets-for-match-market-type - *Daniel Morley*
     */
    get: operations['get_markets_for_group_id_bookie_trade_manager_sport_details_markets_get'];
  };
  '/bookie/trade-manager/sport-details/void-match': {
    /** Void Match */
    post: operations['void_match_bookie_trade_manager_sport_details_void_match_post'];
  };
  '/bookie/trade-manager/sport-details/void-market': {
    /** Void Market */
    post: operations['void_market_bookie_trade_manager_sport_details_void_market_post'];
  };
  '/bookie/trade-manager/sport-details/void-proposition': {
    /** Void Proposition */
    post: operations['void_proposition_bookie_trade_manager_sport_details_void_proposition_post'];
  };
  '/bookie/trade-manager/sport-details/settle-sport-market-propositions': {
    /** Settle Sport Market */
    post: operations['settle_sport_market_bookie_trade_manager_sport_details_settle_sport_market_propositions_post'];
  };
  '/bookie/trade-manager/sport-details/suspend-match': {
    /** Suspend Match */
    patch: operations['suspend_match_bookie_trade_manager_sport_details_suspend_match_patch'];
  };
  '/bookie/trade-manager/sport-details/suspend-proposition': {
    /** Suspend Proposition */
    patch: operations['suspend_proposition_bookie_trade_manager_sport_details_suspend_proposition_patch'];
  };
  '/bookie/trade-manager/sport-details/open-close-market': {
    /** Open Close Market */
    post: operations['open_close_market_bookie_trade_manager_sport_details_open_close_market_post'];
  };
  '/bookie/trade-manager/sport-details/open-close-proposition': {
    /** Open Close Proposition */
    post: operations['open_close_proposition_bookie_trade_manager_sport_details_open_close_proposition_post'];
  };
  '/bookie/trade-manager/sport-details/match-markets': {
    /** Match Markets */
    get: operations['match_markets_bookie_trade_manager_sport_details_match_markets_get'];
  };
  '/bookie/trade-manager/sport-details/set-ignore-winter-settlement': {
    /** Set Ignore Winter Settlement For Sports */
    post: operations['set_ignore_winter_settlement_for_sports_bookie_trade_manager_sport_details_set_ignore_winter_settlement_post'];
  };
  '/bookie/trade-manager/sport-details/matches/{match_id}/settings': {
    /** Update Match Settings */
    patch: operations['update_match_settings_bookie_trade_manager_sport_details_matches__match_id__settings_patch'];
  };
  '/bookie/trade-manager/market-creation/add-sport': {
    /** Add Sport */
    post: operations['add_sport_bookie_trade_manager_market_creation_add_sport_post'];
  };
  '/bookie/trade-manager/market-creation/get-sport': {
    /**
     * Get Sports
     * @description Pagination is not applied because the whole result needs to be returned to FE
     */
    get: operations['get_sports_bookie_trade_manager_market_creation_get_sport_get'];
  };
  '/bookie/trade-manager/market-creation/add-competition': {
    /** Add Competition */
    post: operations['add_competition_bookie_trade_manager_market_creation_add_competition_post'];
  };
  '/bookie/trade-manager/market-creation/update-competition': {
    /** Update Competition */
    post: operations['update_competition_bookie_trade_manager_market_creation_update_competition_post'];
  };
  '/bookie/trade-manager/market-creation/get-competition': {
    /**
     * Get Competitions
     * @description Pagination is not applied because the whole result needs to be returned to FE
     */
    get: operations['get_competitions_bookie_trade_manager_market_creation_get_competition_get'];
  };
  '/bookie/trade-manager/market-creation/add-match': {
    /** Add Match */
    post: operations['add_match_bookie_trade_manager_market_creation_add_match_post'];
  };
  '/bookie/trade-manager/market-creation/update-match': {
    /** Update Match */
    post: operations['update_match_bookie_trade_manager_market_creation_update_match_post'];
  };
  '/bookie/trade-manager/market-creation/get-match': {
    /**
     * Get Matches
     * @description Pagination is not applied because the whole result needs to be returned to FE
     */
    get: operations['get_matches_bookie_trade_manager_market_creation_get_match_get'];
  };
  '/bookie/trade-manager/market-creation/add-market-group': {
    /** Add Market Group */
    post: operations['add_market_group_bookie_trade_manager_market_creation_add_market_group_post'];
  };
  '/bookie/trade-manager/market-creation/update-market-group': {
    /** Update Market Group */
    post: operations['update_market_group_bookie_trade_manager_market_creation_update_market_group_post'];
  };
  '/bookie/trade-manager/market-creation/get-market-group': {
    /**
     * Get Market Group
     * @description Pagination is not applied because the whole result needs to be returned to FE
     */
    get: operations['get_market_group_bookie_trade_manager_market_creation_get_market_group_get'];
  };
  '/bookie/trade-manager/market-creation/add-market': {
    /** Add Market */
    post: operations['add_market_bookie_trade_manager_market_creation_add_market_post'];
  };
  '/bookie/trade-manager/market-creation/update-market': {
    /** Update Market */
    post: operations['update_market_bookie_trade_manager_market_creation_update_market_post'];
  };
  '/bookie/trade-manager/market-creation/get-market': {
    /**
     * Get Market
     * @description Pagination is not applied because the whole result needs to be returned to FE
     */
    get: operations['get_market_bookie_trade_manager_market_creation_get_market_get'];
  };
  '/bookie/trade-manager/market-creation/delete-market': {
    /** Delete Market */
    delete: operations['delete_market_bookie_trade_manager_market_creation_delete_market_delete'];
  };
  '/bookie/trade-manager/market-creation/add-proposition': {
    /** Add Proposition */
    post: operations['add_proposition_bookie_trade_manager_market_creation_add_proposition_post'];
  };
  '/bookie/trade-manager/market-creation/update-proposition': {
    /** Update Proposition */
    post: operations['update_proposition_bookie_trade_manager_market_creation_update_proposition_post'];
  };
  '/bookie/trade-manager/market-creation/get-proposition': {
    /**
     * Get Proposition
     * @description Pagination is not applied because the whole result needs to be returned to FE
     */
    get: operations['get_proposition_bookie_trade_manager_market_creation_get_proposition_get'];
  };
  '/bookie/trade-manager/market-creation/get-sport-market': {
    /**
     * Get Sport Market
     * @description Pagination is not applied because the whole result needs to be returned to FE
     */
    get: operations['get_sport_market_bookie_trade_manager_market_creation_get_sport_market_get'];
  };
  '/bookie/trade-manager/sgmultis': {
    /** Get Sgmultis Monitor Stats */
    get: operations['get_sgmultis_monitor_stats_bookie_trade_manager_sgmultis_get'];
  };
  '/bookie/trade-manager/sgmultis/bets': {
    /** Get Match Bets */
    get: operations['get_match_bets_bookie_trade_manager_sgmultis_bets_get'];
  };
  '/bookie/trade-manager/sgmultis/propositions': {
    /** Get Match Propositions */
    get: operations['get_match_propositions_bookie_trade_manager_sgmultis_propositions_get'];
  };
  '/bookie/trade-manager/sgmultis/combinations': {
    /** Get Match Combinations */
    get: operations['get_match_combinations_bookie_trade_manager_sgmultis_combinations_get'];
  };
  '/bookie/trade-manager/srmultis': {
    /** Get Srmultis Monitor Stats */
    get: operations['get_srmultis_monitor_stats_bookie_trade_manager_srmultis_get'];
  };
  '/bookie/trade-manager/srmultis/bets': {
    /** Get Race Bets */
    get: operations['get_race_bets_bookie_trade_manager_srmultis_bets_get'];
  };
  '/bookie/trade-manager/srmultis/runners': {
    /** Get Race Runners */
    get: operations['get_race_runners_bookie_trade_manager_srmultis_runners_get'];
  };
  '/bookie/trade-manager/srmultis/combinations': {
    /** Get Race Combinations */
    get: operations['get_race_combinations_bookie_trade_manager_srmultis_combinations_get'];
  };
  '/bookie/trade-manager/srmultis/combination-punters': {
    /** Get Race Combination Punters */
    get: operations['get_race_combination_punters_bookie_trade_manager_srmultis_combination_punters_get'];
  };
  '/bookie/trade-manager/blended/all-bets': {
    /** Get All Bets */
    get: operations['get_all_bets_bookie_trade_manager_blended_all_bets_get'];
  };
  '/bookie/trade-manager/blended/runners': {
    /** Get Runners */
    get: operations['get_runners_bookie_trade_manager_blended_runners_get'];
  };
  '/bookie/trade-manager/blended/combinations': {
    /** Get Combinations */
    get: operations['get_combinations_bookie_trade_manager_blended_combinations_get'];
  };
  '/bookie/trade-manager/blended/combination-punters': {
    /** Get Combination Punters */
    get: operations['get_combination_punters_bookie_trade_manager_blended_combination_punters_get'];
  };
  '/bookie/uploads/policies/': {
    /**
     * Get Policies
     * @description Returns terms and conditions upload information
     */
    get: operations['get_policies_bookie_uploads_policies__get'];
    /**
     * Upsert Policy
     * @description Returns terms and conditions upload information
     */
    post: operations['upsert_policy_bookie_uploads_policies__post'];
  };
  '/bookie/uploads/policies/{upload_id}': {
    /**
     * Delete Policy
     * @description Returns terms and conditions upload information
     */
    delete: operations['delete_policy_bookie_uploads_policies__upload_id__delete'];
  };
  '/bookie/regulator/bets': {
    /** Get Bets */
    get: operations['get_bets_bookie_regulator_bets_get'];
  };
  '/bookie/regulator/download-bets': {
    /** Download Bets */
    get: operations['download_bets_bookie_regulator_download_bets_get'];
  };
  '/bookie/regulator/transactions': {
    /** Get Transactions */
    get: operations['get_transactions_bookie_regulator_transactions_get'];
  };
  '/bookie/regulator/download-transactions': {
    /**
     * Download Aud Transactions
     * @description Returns a csv with all their transaction history.
     */
    get: operations['download_aud_transactions_bookie_regulator_download_transactions_get'];
  };
  '/bookie/banners/state': {
    /**
     * Upsert State
     * @description Uploads the banner's state into the blob store
     */
    put: operations['upsert_state_bookie_banners_state_put'];
  };
  '/bookie/banners/images': {
    /**
     * Upsert Images
     * @description Uploads the banner images into the blob store
     */
    put: operations['upsert_images_bookie_banners_images_put'];
  };
  '/bookie/cms/side_nav': {
    /**
     * Upsert Side Nav
     * @description Uploads the side nav settings into the blob store
     */
    put: operations['upsert_side_nav_bookie_cms_side_nav_put'];
  };
  '/punter/account/record-reset-password': {
    /**
     * Record Reset Password
     * @description Record if a Bookie logs in or logs out. --- Samuel Mcilwain.
     */
    post: operations['record_reset_password_punter_account_record_reset_password_post'];
  };
  '/punter/account/record-action': {
    /** Record Punter Action */
    post: operations['record_punter_action_punter_account_record_action_post'];
  };
  '/punter/account': {
    /**
     * Punter Account Status
     * @description Uses a firebase token to either grab an existing punter account, or create and return one - Daniel Morley
     */
    get: operations['punter_account_status_punter_account_get'];
    /**
     * Update Punter
     * @description Updates a punter's profile - Daniel Morley
     */
    post: operations['update_punter_punter_account_post'];
  };
  '/punter/account/supported-bets': {
    /** Get Punter Supported Bets */
    get: operations['get_punter_supported_bets_punter_account_supported_bets_get'];
  };
  '/punter/account/deposit-limit': {
    /**
     * Get Deposit Limit
     * @description Returns the current deposit limit for the punter, along with the frequency and when it was last updated.
     * If there is a cooldown period active, this will also be returned along with the future limit - *Daniel Morley*
     */
    get: operations['get_deposit_limit_punter_account_deposit_limit_get'];
    /**
     * Set Deposit Limit
     * @description Sets a deposit limit for the punter is also the last onboarding step - Daniel Morley
     */
    post: operations['set_deposit_limit_punter_account_deposit_limit_post'];
  };
  '/punter/account/verify': {
    /**
     * Verify Punter
     * @description Initiates a verification session from the punter endpoint --Aneurin Hall
     */
    get: operations['verify_punter_punter_account_verify_get'];
  };
  '/punter/account/overview': {
    /** Punter Overview */
    get: operations['punter_overview_punter_account_overview_get'];
  };
  '/punter/account/bets-for-race': {
    /**
     * Get Bets For Race
     * @description Given a race_id UUID returns a list of bets associated with that Race for a specific punter
     */
    get: operations['get_bets_for_race_punter_account_bets_for_race_get'];
  };
  '/punter/account/my-bets': {
    /** My Bets */
    get: operations['my_bets_punter_account_my_bets_get'];
  };
  '/punter/account/my-bets-counts': {
    /** My Bets Counts */
    get: operations['my_bets_counts_punter_account_my_bets_counts_get'];
  };
  '/punter/account/bet-requests': {
    /** Get Bet Approvals Pending */
    get: operations['get_bet_approvals_pending_punter_account_bet_requests_get'];
  };
  '/punter/account/withdraw': {
    /**
     * Withdraw Balance
     * @description Create a withdrawal request on the punter's account - Daniel Morley
     */
    post: operations['withdraw_balance_punter_account_withdraw_post'];
  };
  '/punter/account/withdrawal/{request_id}': {
    /**
     * Delete Punter Withdrawal Request
     * @description Cancels/deletes a withdrawal request for the punter
     * but only if the request is still pending - *Daniel Morley*
     */
    delete: operations['delete_punter_withdrawal_request_punter_account_withdrawal__request_id__delete'];
  };
  '/punter/account/requested-withdrawals': {
    /**
     * View Requested Withdrawals
     * @description Gets all of the current (not completely processed) withdrawal requests, ordered by date, most recent first - *Daniel Morley*
     */
    get: operations['view_requested_withdrawals_punter_account_requested_withdrawals_get'];
  };
  '/punter/account/self-exclusion': {
    /**
     * Update Self Exclusion
     * @description Set self exclusion for the punter
     */
    post: operations['update_self_exclusion_punter_account_self_exclusion_post'];
  };
  '/punter/account/close': {
    /**
     * Close Account
     * @description Close customer account
     */
    post: operations['close_account_punter_account_close_post'];
  };
  '/punter/account/zoho-token': {
    /** Generate Zoho Token */
    get: operations['generate_zoho_token_punter_account_zoho_token_get'];
  };
  '/punter/account/preference': {
    /**
     * Get Preference
     * @description Retrieve punter preferencs
     */
    get: operations['get_preference_punter_account_preference_get'];
    /**
     * Update Preference
     * @description Insert or update the punter preference
     */
    post: operations['update_preference_punter_account_preference_post'];
  };
  '/punter/bank': {
    /**
     * Get Banks
     * @description Returns all matching banks for a given Punter
     */
    get: operations['get_banks_punter_bank_get'];
    /** Add New Bank */
    post: operations['add_new_bank_punter_bank_post'];
  };
  '/punter/transactions/download-all': {
    /**
     * Download Punter Transactions
     * @description For the punter requesting, returns a csv with all their transaction history.
     *
     * *Matt Balshaw*
     */
    get: operations['download_punter_transactions_punter_transactions_download_all_get'];
  };
  '/punter/transactions': {
    /**
     * Get Punter Transactions
     * @description For the punter requesting, returns a list of their transactions.
     */
    get: operations['get_punter_transactions_punter_transactions_get'];
  };
  '/punter/deposit/limit': {
    /**
     * Get Limit Remaining
     * @description Return the punters remaning limit in cents. --- Samuel Mcilwain.
     */
    get: operations['get_limit_remaining_punter_deposit_limit_get'];
  };
  '/punter/deposit/zebra-token': {
    /**
     * Get Fat Zebra Token
     * @description Return an oauth token for the frontend from fatzebra -- Samuel Flynn.
     */
    get: operations['get_fat_zebra_token_punter_deposit_zebra_token_get'];
  };
  '/punter/deposit/card': {
    /**
     * Punters Cards
     * @description Get all the cards for the punter in the database.
     */
    get: operations['punters_cards_punter_deposit_card_get'];
    /** Delete Card */
    delete: operations['delete_card_punter_deposit_card_delete'];
  };
  '/punter/deposit/create': {
    /**
     * Create Deposit
     * @description Create a deposit in the database in which id is passed in from the frontend.
     */
    post: operations['create_deposit_punter_deposit_create_post'];
  };
  '/punter/deposit/update': {
    /**
     * Update Deposit
     * @description Update a deposit in the database in which id is passed in from the frontend.
     * This will do an extra confirmation with Fat Zebra to ensure the deposit is valid.
     */
    post: operations['update_deposit_punter_deposit_update_post'];
  };
  '/punter/deposit/pay': {
    /**
     * Pay
     * @description Attempt to pay with Fatzebra with a saved card_id
     *  and if successful then finalize the payment by crediting the punter account
     */
    post: operations['pay_punter_deposit_pay_post'];
  };
  '/punter/deposit/session': {
    /** Put Session */
    put: operations['put_session_punter_deposit_session_put'];
    /** Patch Session */
    patch: operations['patch_session_punter_deposit_session_patch'];
  };
  '/punter/deposit/status': {
    /** Get Payment Status */
    get: operations['get_payment_status_punter_deposit_status_get'];
  };
  '/punter/signup': {
    /**
     * Signup Punter
     * @description Signup a punter by creating the user in firebase, saving punter details in DB and initiating greenid check
     */
    post: operations['signup_punter_punter_signup_post'];
  };
  '/punter/marketing': {
    /**
     * Get Customer Marketing
     * @description Returns all matching banks for a given Punter
     */
    get: operations['get_customer_marketing_punter_marketing_get'];
    /** Create Or Update Customer Marketing */
    post: operations['create_or_update_customer_marketing_punter_marketing_post'];
  };
  '/punter/statements': {
    /** Get Activity Statements */
    get: operations['get_activity_statements_punter_statements_get'];
  };
  '/punter/promotions': {
    /** Get Promotions */
    get: operations['get_promotions_punter_promotions_get'];
  };
  '/punter/promotions/claim_token/{token_id}': {
    /**
     * Claim Token
     * @description Claim a pending promo token
     */
    post: operations['claim_token_punter_promotions_claim_token__token_id__post'];
  };
  '/punter/bet-slip/v2/submit': {
    /** Submit Bet Slip */
    post: operations['submit_bet_slip_punter_bet_slip_v2_submit_post'];
  };
  '/punter/bet-slip/v2/build': {
    /**
     * Build Bet Slip
     * @description Build a betslip
     */
    post: operations['build_bet_slip_punter_bet_slip_v2_build_post'];
  };
  '/punter/races/race-details/runner-list': {
    /**
     * Race Detail Runner List
     * @description given a race id returns a list of runners in RunnerListRow format --Aneurin Hall
     */
    get: operations['race_detail_runner_list_punter_races_race_details_runner_list_get'];
  };
  '/punter/races/race-details/other-races': {
    /**
     * Race Detail Other Races
     * @description given a race id returns a list of the other races at the same venue on the same day -- Matt Balshaw
     */
    get: operations['race_detail_other_races_punter_races_race_details_other_races_get'];
  };
  '/punter/races/race-details/race-meta': {
    /**
     * Race Detail Race Meta
     * @description given a race UUID returns the metadata for the race in RaceMetadata format  -- Aneurin Hall
     */
    get: operations['race_detail_race_meta_punter_races_race_details_race_meta_get'];
  };
  '/punter/races/race-details/race-result': {
    /**
     * Race Results
     * @description Given a race id, returns the runners who resulted in the race with their final odds
     *
     * *Matt Balshaw*
     */
    get: operations['race_results_punter_races_race_details_race_result_get'];
  };
  '/punter/races/race-details/specific-propositions': {
    /**
     * Get Specific Propositions
     * @description Given a list of race proposition ids, returns the data for these single propositions.
     *
     * Does not return any propositions if the platform does not offer the venue.
     *
     * Will not return sport propositions.
     *
     * *Matt Balshaw*
     */
    post: operations['get_specific_propositions_punter_races_race_details_specific_propositions_post'];
  };
  '/punter/races/race-details/markets': {
    /**
     * Get Markets
     * @description Return a list of markets for the specified race
     */
    get: operations['get_markets_punter_races_race_details_markets_get'];
  };
  '/punter/races/venue-list': {
    /**
     * Races Venue List
     * @description Given a race type returns all venues offered on a platform with races for today, you may optionally send a
     * date in YYYY-MM-DD format to get results for a specific day. -- Samuel Flynn
     */
    get: operations['races_venue_list_punter_races_venue_list_get'];
  };
  '/punter/races/next-to-jump': {
    /**
     * Next To Jump
     * @description Return the next to jump races. --- Samuel Flynn.
     */
    get: operations['next_to_jump_punter_races_next_to_jump_get'];
  };
  '/punter/races/next-to-jump-cursor': {
    /**
     * Next To Jump Cursor
     * @description Return the next to jump races with cursor pagination -- *Daniel Morley*
     */
    get: operations['next_to_jump_cursor_punter_races_next_to_jump_cursor_get'];
  };
  '/punter/sports/sport-details/market-groups': {
    /**
     * Get Market Groups
     * @description Given a match id returns all of the market groups for the match.
     */
    get: operations['get_market_groups_punter_sports_sport_details_market_groups_get'];
  };
  '/punter/sports/sport-details/markets': {
    /**
     * Get Markets
     * @description Given a match id, returns all the open markets for that match.
     *
     * Does not return markets if the platform does not offer the match.
     */
    get: operations['get_markets_punter_sports_sport_details_markets_get'];
  };
  '/punter/sports/sport-details/propositions': {
    /**
     * Get Propositions
     * @description Given a market id list, returns the propositions for that market with their odds.
     *
     * Does not return propositions if the platform does not offer the market.
     *
     * *Matt Balshaw*
     */
    get: operations['get_propositions_punter_sports_sport_details_propositions_get'];
  };
  '/punter/sports/sport-details/props': {
    /**
     * Get Props
     * @description Given a market id list, returns the propositions for that market with their odds.
     *
     * Does not return propositions if the platform does not offer the market.
     *
     * *Matt Balshaw*
     */
    get: operations['get_props_punter_sports_sport_details_props_get'];
  };
  '/punter/sports/sport-details/specific-propositions': {
    /**
     * Get Specific Propositions
     * @description Given a list of sport proposition ids, returns the data for these single propositions.
     *
     * Does not return any propositions if the platform does not offer the market.
     *
     * Will not return race propositions.
     *
     * *Matt Balshaw*
     */
    post: operations['get_specific_propositions_punter_sports_sport_details_specific_propositions_post'];
  };
  '/punter/sports/sport-list': {
    /**
     * Get All Sports
     * @description Returns all sports where the bookie offers at least one competition -- Aneurin Hall
     */
    get: operations['get_all_sports_punter_sports_sport_list_get'];
  };
  '/punter/sports/next-to-jump': {
    /**
     * Filter Sports
     * @description Returns all matches ordered based on how soon match starts, ascending.
     * Will not return resulted matches
     * Will not return matches without open markets
     * *Rob Mcnamara*
     */
    get: operations['filter_sports_punter_sports_next_to_jump_get'];
  };
  '/punter/sports/next-to-jump-cursor': {
    /**
     * Filter Sports Cursor
     * @description Returns all matches ordered based on how soon match starts, ascending with cursor pagination.
     * Will not return resulted matches -- *Daniel Morley*
     * Will not return matches without open markets
     */
    get: operations['filter_sports_cursor_punter_sports_next_to_jump_cursor_get'];
  };
  '/punter/sports/competitions-tournaments': {
    /**
     * Pp Competitions Tournaments
     * @description Returns list of competitions and matches for a given sport, with it's corresponding sport id, name and icon -- Aneurin Hall, Jake McClay, Daniel Morley
     */
    get: operations['pp_competitions_tournaments_punter_sports_competitions_tournaments_get'];
  };
  '/punter/sports/competition-markets': {
    /**
     * Get Markets For Competition
     * @deprecated
     * @description Given a competition returns all markets ordered by next to start --Aneurin Hall
     */
    get: operations['get_markets_for_competition_punter_sports_competition_markets_get'];
  };
  '/punter/sports/matches': {
    /**
     * Matches For Competition Or Tournament
     * @description Returns a list of matches in the future given either a competition or tournament id or both -- Matt Balshaw
     */
    get: operations['matches_for_competition_or_tournament_punter_sports_matches_get'];
  };
  '/punter/sports/upcoming-matches-by-time': {
    /** Get Upcoming Matches By Time */
    get: operations['get_upcoming_matches_by_time_punter_sports_upcoming_matches_by_time_get'];
  };
  '/punter/sports/upcoming-matches-group-by-sport': {
    /**
     * Upcoming Matches Sport Order
     * @description Returns a list of matches grouped by sport including the main market and props for that market for each match
     */
    get: operations['upcoming_matches_sport_order_punter_sports_upcoming_matches_group_by_sport_get'];
  };
  '/punter/general/offerings': {
    /**
     * Get Sport And Race Offerings
     * @description Returns all sport and racing types offered by the platform - Daniel Morley
     */
    get: operations['get_sport_and_race_offerings_punter_general_offerings_get'];
  };
  '/punter/general/terms': {
    /**
     * Get Terms Of Service
     * @description Returns the terms of service for a punter on the platform regardless of Punter singin - Daniel Morley
     */
    get: operations['get_terms_of_service_punter_general_terms_get'];
  };
  '/punter/general/privacy': {
    /**
     * Get Privacy Policy
     * @description Returns the privacy policy for a punter on the platform regardless of Punter singin - Daniel Morley
     */
    get: operations['get_privacy_policy_punter_general_privacy_get'];
  };
  '/punter/general/contact': {
    /** Get Bookie Contact */
    get: operations['get_bookie_contact_punter_general_contact_get'];
  };
  '/punter/content/{page}': {
    /**
     * Get Content
     * @description Returns bookie managed content for a given page e.g. homepage
     */
    get: operations['get_content_punter_content__page__get'];
  };
  '/punter/pricing/srm': {
    /**
     * Get Srm Selection Price
     * @description Gets the price of selected propositions. Currently supports SGM pricing.
     */
    post: operations['get_srm_selection_price_punter_pricing_srm_post'];
  };
  '/punter/pricing/sgm': {
    /**
     * Get Sgmulti Selection Price
     * @description Gets the price of selected propositions. Currently supports SGM pricing.
     */
    post: operations['get_sgmulti_selection_price_punter_pricing_sgm_post'];
  };
  '/punter/pricing/blended': {
    /**
     * Get Blended Selection Price
     * @description Gets the price of selected propositions.
     */
    post: operations['get_blended_selection_price_punter_pricing_blended_post'];
  };
  '/punter/pricing/even-shot': {
    /**
     * Get Even Shot Prop
     * @description Uses the even-shot algorithm to decide the closest prop to $2.
     */
    get: operations['get_even_shot_prop_punter_pricing_even_shot_get'];
  };
  '/external/forsport/odds': {
    /** Get Odds */
    get: operations['get_odds_external_forsport_odds_get'];
  };
};

export type webhooks = Record<string, never>;

export type components = {
  schemas: {
    /**
     * ActionTypes
     * @description Manages the action types that are recordable in the system
     * @enum {string}
     */
    ActionTypes: (typeof ActionTypes)[number];
    /** ActionsSchema */
    ActionsSchema: {
      /**
       * The ID of the action record.
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      id: string;
      /**
       * Title of action preformed
       * @example Logged in
       */
      action_type: string;
      /**
       * information about action
       * @example {
       *   "test": "test"
       * }
       */
      action_info?: Record<string, never>;
      /** summary of the action for display */
      action_summary: string;
      /**
       * The IP Address of the punter
       * @example 127.0.0.1
       */
      ip?: string;
      /**
       * Location the punter preformed this action
       * @example Melbourne/Australia
       */
      location?: string;
      /**
       * When was the record created.
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      created_at?: string;
      /**
       * fullname of the punter.
       * @example John
       */
      punter_name?: string;
      /**
       * fullname of the bookie
       * @example Jean
       */
      bookie_name?: string;
      /**
       * The ID of the punter
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id?: string;
    };
    /** ActivityStatementSchema */
    ActivityStatementSchema: {
      /**
       * year
       * @example 2023
       */
      year: number;
      /** The list of statement link */
      statements: components['schemas']['StatementLinkSchema'][];
    };
    /** AddCompetitionInput */
    AddCompetitionInput: {
      /**
       * The sport id of the competition.
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      sport_id: string;
      /**
       * the name of the competition
       * @example example
       */
      name: string;
      /**
       * the external_ref of the competition
       * @example example
       */
      external_ref?: string;
      /**
       * the sort order of the competition
       * @example 1
       */
      sort_order?: number;
      /**
       * The updated time of the competition
       * Format: date-time
       */
      updated_at?: string;
      /** the competition is offered or not */
      is_offered?: boolean;
    };
    /** AddMarketGroupInput */
    AddMarketGroupInput: {
      /**
       * The match id of the market group.
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      match_id: string;
      /**
       * the title of the market group
       * @example example
       */
      name: string;
      /**
       * the bet options of the market group
       * @example [
       *   "1"
       * ]
       */
      bet_options?: string[];
      /**
       * the sort order of the market group
       * @example 0
       */
      sort_order?: number;
      /**
       * The updated time of the market group
       * Format: date-time
       */
      updated_at?: string;
    };
    /** AddMarketInput */
    AddMarketInput: {
      /**
       * The match id of the market.
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      match_id: string;
      /**
       * the name of the market
       * @example example
       */
      name: string;
      /**
       * the market type of the market
       * @example example
       */
      market_type: string;
      /**
       * the bet option priority of the market
       * @example example
       */
      bet_option_priority?: string;
      /**
       * the bet option spectrum id of the market
       * @example example
       */
      bet_option_spectrum_id?: string;
      /**
       * the status of the market
       * @example Open
       */
      status?: components['schemas']['GeneralStatus'];
      /**
       * the external_ref of the market
       * @example example
       */
      external_ref?: string;
      /**
       * The updated time of the market
       * Format: date-time
       */
      updated_at?: string;
    };
    /** AddMatchInput */
    AddMatchInput: {
      /**
       * The competition id of the match.
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      competition_id: string;
      /**
       * the name of the match
       * @example example
       */
      name: string;
      /**
       * the start time of the match
       * @example 2021-11-29T06:00:35
       */
      start_time: string;
      /**
       * the status of the match
       * @example Open
       */
      status?: components['schemas']['GeneralStatus'];
      /**
       * The tournament id of the match.
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      tournament_id?: string;
      /**
       * the external_ref of the match
       * @example example
       */
      external_ref?: string;
      /**
       * The updated time of the match
       * Format: date-time
       */
      updated_at?: string;
    };
    /** AddPropositionInput */
    AddPropositionInput: {
      /**
       * The market id of the proposition.
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      market_id: string;
      /**
       * the name of the proposition
       * @example example
       */
      name: string;
      /**
       * the market type of the proposition
       * @example example
       */
      proposition_type?: string;
      /**
       * the max stake limit of the proposition
       * @example 100
       */
      max_stake_limit?: number;
      /**
       * the proposition allows multi or not
       * @example true
       */
      allow_multi?: boolean;
      /**
       * The odds of the proposition
       * @example 1.01
       */
      odds?: number;
      /**
       * The sort order of the proposition
       * @example 1
       */
      sort_order?: number;
      /**
       * the status of the proposition
       * @example Open
       */
      status?: components['schemas']['GeneralStatus'];
      /**
       * the external_ref of the proposition
       * @example example
       */
      external_ref?: string;
      /**
       * The updated time of the proposition
       * Format: date-time
       */
      updated_at?: string;
    };
    /** AddSportInput */
    AddSportInput: {
      /**
       * the name of the sport
       * @example example
       */
      name: string;
      /**
       * the external_ref of the sport
       * @example example
       */
      external_ref?: string;
      /**
       * the type of the sport
       * @example Promotional
       */
      sport_type?: string;
      /**
       * The updated time of the sport
       * Format: date-time
       */
      updated_at?: string;
      /**
       * the sort order of the sport
       * @example 1
       */
      sort_order?: number;
    };
    /** AddedAttachments */
    AddedAttachments: {
      /**
       * The id of the attachment
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      attachment_id: string;
      /**
       * The title of the attachment
       * @example Punter Driver's License
       */
      title: string;
      /**
       * The url that the attachment is stored
       * @example https://firebase.com/path-to-attachment
       */
      url: string;
    };
    /** ApprovalDownloadInput */
    ApprovalDownloadInput: {
      /**
       * The approvals to be downloaded
       * @example [
       *   "1bda22c9-a435-4be3-a831-697b24e8cae4"
       * ]
       */
      approval_ids: string[];
    };
    /** AttachmentSchema */
    AttachmentSchema: {
      /**
       * The ID of the Note
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      attachment_id: string;
      /**
       * The title of the attachment
       * @example This is an example attachment
       */
      title?: string;
      /**
       * The URL of the attachment
       * @example https://attachment.example.com
       */
      url?: string;
    };
    /** AttachmentsToAdd */
    AttachmentsToAdd: {
      /**
       * The url that the attachment is stored
       * @example https://firebase.com/path-to-attachment
       */
      url: string;
      /**
       * The title of the attachment
       * @example Punter Driver's License
       */
      title: string;
    };
    /**
     * AustralianStatesTerritories
     * @description An enumeration.
     * @enum {string}
     */
    AustralianStatesTerritories: (typeof AustralianStatesTerritories)[number];
    /** BankReturnSchema */
    BankReturnSchema: {
      /**
       * The 7 character BSB of the bank account, including the dash or empty string if no bank account is set
       * @example 123-456
       */
      bsb: string;
      /**
       * The 8-10 digit account number of the bank account or empty string if no bank account is set
       * @example 123456789
       */
      account_number: string;
      /**
       * The name of the account holder (max 26 characters) or empty string if no bank account is set
       * @example Farrokh Bulsara
       */
      account_name: string;
      /**
       * The approved financial institution code for the bank or empty string if no bank account is set
       * @example BAN
       */
      bank_code: string;
      /**
       * The APCA number for the bank account or empty string if no bank account is set
       * @example 123456
       */
      apca_number: string;
    };
    /** BetBuildBlendedInputItem */
    BetBuildBlendedInputItem: {
      /**
       * Front-end generated ID for this bet submission
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      request_id: string;
      /**
       * Whether this bet was generated by bet build.
       * @default false
       * @example true
       */
      builder_generated?: boolean;
      /** List of legs for this Blended bet */
      legs: components['schemas']['BetSlipBlendedProps'][];
      /**
       * Type
       * @default Blended
       * @enum {string}
       */
      type?: 'Blended';
      /**
       * The odds of the bet
       * @example 1.5
       */
      odds?: number;
    };
    /** BetBuildBlendedOutputItem */
    BetBuildBlendedOutputItem: {
      /**
       * Front-end generated ID for this bet submission
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      request_id: string;
      /**
       * Whether this bet was generated by bet build.
       * @default false
       * @example true
       */
      builder_generated?: boolean;
      /** List of legs for this Blended bet */
      legs: components['schemas']['BetSlipBlendedProps'][];
      /**
       * Type
       * @default Blended
       * @enum {string}
       */
      type?: 'Blended';
      /**
       * The odds of the bet
       * @example 1.5
       */
      odds?: number;
      /**
       * Error relating to the bet
       * @example InvalidProposition
       */
      error?: components['schemas']['BetPlaceRejectionReason'];
      /**
       * Is the Blended bet valid
       * @example True
       */
      valid_bet?: boolean;
    };
    /** BetBuildExoticsInputItem */
    BetBuildExoticsInputItem: {
      /**
       * Front-end generated ID for this bet submission
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      request_id: string;
      /**
       * Whether this bet was generated by bet build.
       * @default false
       * @example true
       */
      builder_generated?: boolean;
      sub_type: components['schemas']['BetSubType'];
      /**
       * Proposition id bet is being placed on
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      proposition_id?: string;
      /**
       * exotic selections: [[1st place selections], [2nd place selections], ...]
       * @example [
       *   [
       *     1,
       *     3
       *   ],
       *   [
       *     1,
       *     4
       *   ]
       * ]
       */
      selection: number[][];
      /**
       * Type
       * @default Exotics
       * @enum {string}
       */
      type?: 'Exotics';
    };
    /** BetBuildExoticsOutputItem */
    BetBuildExoticsOutputItem: {
      /**
       * Front-end generated ID for this bet submission
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      request_id: string;
      /**
       * Whether this bet was generated by bet build.
       * @default false
       * @example true
       */
      builder_generated?: boolean;
      sub_type: components['schemas']['BetSubType'];
      /**
       * Proposition id bet is being placed on
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      proposition_id?: string;
      /**
       * exotic selections: [[1st place selections], [2nd place selections], ...]
       * @example [
       *   [
       *     1,
       *     3
       *   ],
       *   [
       *     1,
       *     4
       *   ]
       * ]
       */
      selection: number[][];
      /**
       * Type
       * @default Exotics
       * @enum {string}
       */
      type?: 'Exotics';
      /**
       * Error relating to the bet
       * @example PropositionClosed
       */
      error?: components['schemas']['BetPlaceRejectionReason'];
    };
    /** BetBuildInput */
    BetBuildInput: {
      /**
       * List of bet items for bet building.
       * @default []
       * @example [BetBuildSingleInputItem]
       */
      bets?: (
        | components['schemas']['BetBuildSingleInputItem']
        | components['schemas']['BetBuildExoticsInputItem']
        | components['schemas']['BetBuildSGMultiInputItem']
        | components['schemas']['BetBuildBlendedInputItem']
      )[];
    };
    /** BetBuildMultiOutputItem */
    BetBuildMultiOutputItem: {
      /**
       * Front-end generated ID for this bet submission
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      request_id: string;
      /**
       * Whether this bet was generated by bet build.
       * @default false
       * @example true
       */
      builder_generated?: boolean;
      /** List of legs for this bet */
      legs: components['schemas']['BetSlipMultiProps'][];
      /**
       * Type
       * @default Multi
       * @enum {string}
       */
      type?: 'Multi';
      /**
       * The odds of the bet
       * @example 1.5
       */
      odds?: number;
    };
    /** BetBuildResponse */
    BetBuildResponse: {
      /** The available bets for this betslip */
      bets: (
        | components['schemas']['BetBuildSingleOutputItem']
        | components['schemas']['BetBuildMultiOutputItem']
        | components['schemas']['BetBuildExoticsOutputItem']
        | components['schemas']['BetBuildSGMultiOutputItem']
        | components['schemas']['BetBuildBlendedOutputItem']
      )[];
      /**
       * The reason multi is not available for this slip
       * @example MultipleLegsInEventForMulti
       */
      multi_unavailable_reason?: components['schemas']['BetPlaceRejectionReason'];
    };
    /** BetBuildSGMultiInputItem */
    BetBuildSGMultiInputItem: {
      /**
       * Front-end generated ID for this bet submission
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      request_id: string;
      /**
       * Whether this bet was generated by bet build.
       * @default false
       * @example true
       */
      builder_generated?: boolean;
      /** List of legs for this SGMulti bet */
      legs: components['schemas']['BetSlipSGMultiProps'][];
      /**
       * Type
       * @default SGMulti
       * @enum {string}
       */
      type?: 'SGMulti';
      /**
       * The odds of the bet
       * @example 1.5
       */
      odds?: number;
    };
    /** BetBuildSGMultiOutputItem */
    BetBuildSGMultiOutputItem: {
      /**
       * Front-end generated ID for this bet submission
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      request_id: string;
      /**
       * Whether this bet was generated by bet build.
       * @default false
       * @example true
       */
      builder_generated?: boolean;
      /** List of legs for this SGMulti bet */
      legs: components['schemas']['BetSlipSGMultiProps'][];
      /**
       * Type
       * @default SGMulti
       * @enum {string}
       */
      type?: 'SGMulti';
      /**
       * The odds of the bet
       * @example 1.5
       */
      odds?: number;
      /**
       * Error relating to the bet
       * @example InvalidProposition
       */
      error?: components['schemas']['BetPlaceRejectionReason'];
    };
    /** BetBuildSingleInputItem */
    BetBuildSingleInputItem: {
      /**
       * Front-end generated ID for this bet submission
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      request_id: string;
      /**
       * Whether this bet was generated by bet build.
       * @default false
       * @example true
       */
      builder_generated?: boolean;
      /**
       * Proposition id bet is being placed on
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      proposition_id: string;
      /**
       * The odds of the bet
       * @example 1.5
       */
      odds?: number;
      /**
       * The price type the bet is being struck against
       * @default fixed
       * @example fixed
       */
      price_type?: components['schemas']['PriceType'];
      /**
       * Type
       * @default Single
       * @enum {string}
       */
      type?: 'Single';
    };
    /** BetBuildSingleOutputItem */
    BetBuildSingleOutputItem: {
      /**
       * Front-end generated ID for this bet submission
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      request_id: string;
      /**
       * Whether this bet was generated by bet build.
       * @default false
       * @example true
       */
      builder_generated?: boolean;
      /**
       * Proposition id bet is being placed on
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      proposition_id: string;
      /**
       * The odds of the bet
       * @example 1.5
       */
      odds?: number;
      /**
       * The price type the bet is being struck against
       * @default fixed
       * @example fixed
       */
      price_type?: components['schemas']['PriceType'];
      /**
       * Type
       * @default Single
       * @enum {string}
       */
      type?: 'Single';
      /**
       * Error relating to the bet
       * @example PropositionClosed
       */
      error?: components['schemas']['BetPlaceRejectionReason'];
    };
    /** BetComboDividend */
    BetComboDividend: {
      /** Combo */
      combo: number[];
      /** Dividend */
      dividend: number;
    };
    /** BetMatchData */
    BetMatchData: {
      /**
       * The ID of the sport this match is in
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      sport_id: string;
      /**
       * The name of the competition this match is in
       * @example Grand Slams
       */
      competition_name: string;
      /**
       * The ID of the competition this match is in
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      competition_id: string;
      /**
       * The name of the tournament this match is in
       * @example Wimbledon
       */
      tournament_name?: string;
      /**
       * The ID of the tournament this match is in
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      tournament_id?: string;
      /**
       * The name of the match
       * @example Nadal vs Federer
       */
      match_name: string;
      /**
       * The name of the proposition
       * @example Nadal to win
       */
      proposition_name?: string;
      /**
       * The market name for this bet leg
       * @example AFW Gee-NMl ToPtOU
       */
      market_name?: string;
    };
    /**
     * BetPlaceRejectionReason
     * @description An enumeration.
     * @enum {string}
     */
    BetPlaceRejectionReason: (typeof BetPlaceRejectionReason)[number];
    /**
     * BetPlaceStatus
     * @description An enumeration.
     * @enum {string}
     */
    BetPlaceStatus: (typeof BetPlaceStatus)[number];
    /** BetRaceData */
    BetRaceData: {
      /**
       * The name of the venue that this bet was made at
       * @example Flemington
       */
      venue_name: string;
      /**
       * The ID of the venue this race is at
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      venue_id: string;
      /**
       * The name of the race that this bet was made at
       * @example RACE.COM LETS GO
       */
      race_name: string;
      /**
       * The number of the race that was bet on
       * @example 8
       */
      race_number: number;
      /**
       * The TAB meeting date for this race
       * Format: date
       * @example 2023-10-24
       */
      race_meeting_date: string;
      /**
       * The name of the runner
       * @example Ablaze
       */
      runner_name?: string;
      /**
       * The number of the runner that was bet on
       * @example 3
       */
      runner_number?: number;
      /**
       * The barrier number of the runner that was bet on
       * @example 2
       */
      runner_barrier_number?: number;
      /**
       * The market name for this bet leg
       * @example AFW Gee-NMl
       */
      market_name?: string;
      /**
       * The number of places for a place bet
       * @example 2
       */
      number_of_places?: number;
    };
    /**
     * BetRequestAction
     * @description An enumeration.
     * @enum {string}
     */
    BetRequestAction: (typeof BetRequestAction)[number];
    /** BetRequestClaimInput */
    BetRequestClaimInput: {
      /**
       * Bet Request Id
       * Format: uuid
       * @description The ID of the bet request to claim
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      bet_request_id: string;
    };
    /** BetRequestStatusInput */
    BetRequestStatusInput: {
      /**
       * Request Id
       * Format: uuid
       * @description The ID of the bet request to action
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      request_id: string;
      /**
       * The status to set the bet request to
       * @example Approved
       */
      action: components['schemas']['BetRequestAction'];
      /**
       * The approved amount (stake or payout) bet in cents
       * @example 10000
       */
      amount?: number;
      /**
       * The reason for the action
       * @example None
       */
      reason?: string;
      /**
       * Type of request
       * @default Placement
       * @example Placement
       */
      type?: components['schemas']['BetRequestType'];
    };
    /**
     * BetRequestType
     * @description An enumeration.
     * @enum {string}
     */
    BetRequestType: (typeof BetRequestType)[number];
    /**
     * BetRequestsSupportedSortColumns
     * @description An enumeration.
     * @enum {string}
     */
    BetRequestsSupportedSortColumns: (typeof BetRequestsSupportedSortColumns)[number];
    /**
     * BetResultSortField
     * @description An enumeration.
     * @enum {string}
     */
    BetResultSortField: (typeof BetResultSortField)[number];
    /**
     * BetResultSortOrder
     * @description An enumeration.
     * @enum {string}
     */
    BetResultSortOrder: (typeof BetResultSortOrder)[number];
    /** BetSlipBlendedInputItem */
    BetSlipBlendedInputItem: {
      /** Request Id */
      request_id: string;
      /** Stake */
      stake: number;
      /** Is Bonus Bet */
      is_bonus_bet: boolean;
      channel?: components['schemas']['ChannelType'];
      /** Odds */
      odds: number;
      /** Legs */
      legs: components['schemas']['BetSlipBlendedProps'][];
      /**
       * Type
       * @default Blended
       * @enum {string}
       */
      type?: 'Blended';
    };
    /** BetSlipBlendedProps */
    BetSlipBlendedProps: {
      /** Proposition Id */
      proposition_id: string;
    };
    /** BetSlipComboMultiInputItem */
    BetSlipComboMultiInputItem: {
      /** Request Id */
      request_id: string;
      /** Stake */
      stake: number;
      /** Is Bonus Bet */
      is_bonus_bet: boolean;
      channel?: components['schemas']['ChannelType'];
      /** Combos */
      combos: components['schemas']['BetSlipMultiProps'][][];
      /**
       * Type
       * @default ComboMulti
       * @enum {string}
       */
      type?: 'ComboMulti';
    };
    /** BetSlipExoticsInputItem */
    BetSlipExoticsInputItem: {
      /** Request Id */
      request_id: string;
      /** Stake */
      stake: number;
      /** Is Bonus Bet */
      is_bonus_bet: boolean;
      channel?: components['schemas']['ChannelType'];
      sub_type: components['schemas']['BetSubType'];
      /** Proposition Id */
      proposition_id: string;
      /** Selection */
      selection: number[][];
      /**
       * Type
       * @default Exotics
       * @enum {string}
       */
      type?: 'Exotics';
    };
    /** BetSlipMultiInputItem */
    BetSlipMultiInputItem: {
      /** Request Id */
      request_id: string;
      /** Stake */
      stake: number;
      /** Is Bonus Bet */
      is_bonus_bet: boolean;
      channel?: components['schemas']['ChannelType'];
      /** Legs */
      legs: components['schemas']['BetSlipMultiProps'][];
      /**
       * Type
       * @default Multi
       * @enum {string}
       */
      type?: 'Multi';
    };
    /** BetSlipMultiProps */
    BetSlipMultiProps: {
      /** Proposition Id */
      proposition_id: string;
      /** Odds */
      odds: number;
      /** Field Size */
      field_size?: number;
      /** @default fixed */
      price_type?: components['schemas']['PriceType'];
    };
    /** BetSlipSGMultiInputItem */
    BetSlipSGMultiInputItem: {
      /** Request Id */
      request_id: string;
      /** Stake */
      stake: number;
      /** Is Bonus Bet */
      is_bonus_bet: boolean;
      channel?: components['schemas']['ChannelType'];
      /** Odds */
      odds: number;
      /** Legs */
      legs: components['schemas']['BetSlipSGMultiProps'][];
      /**
       * Type
       * @default SGMulti
       * @enum {string}
       */
      type?: 'SGMulti';
    };
    /** BetSlipSGMultiProps */
    BetSlipSGMultiProps: {
      /** Proposition Id */
      proposition_id: string;
    };
    /** BetSlipSRMultiInputItem */
    BetSlipSRMultiInputItem: {
      /** Request Id */
      request_id: string;
      /** Stake */
      stake: number;
      /** Is Bonus Bet */
      is_bonus_bet: boolean;
      channel?: components['schemas']['ChannelType'];
      /** Race Id */
      race_id: string;
      /** Proposition Id */
      proposition_id?: string;
      /** Odds */
      odds: number;
      /** Selection */
      selection: number[][];
      /**
       * Type
       * @default SRMulti
       * @enum {string}
       */
      type?: 'SRMulti';
    };
    /** BetSlipSingleInputItem */
    BetSlipSingleInputItem: {
      /** Request Id */
      request_id: string;
      /** Stake */
      stake: number;
      /** Is Bonus Bet */
      is_bonus_bet: boolean;
      channel?: components['schemas']['ChannelType'];
      /** Proposition Id */
      proposition_id: string;
      /**
       * The odds of the bet
       * @example 1.5
       */
      odds?: number;
      /**
       * The price type the bet is being struck against
       * @default fixed
       * @example fixed
       */
      price_type?: components['schemas']['PriceType'];
      /**
       * Type
       * @default Single
       * @enum {string}
       */
      type?: 'Single';
    };
    /**
     * BetStatuses
     * @description Represents all valid states for a Bet
     *
     * Value                   Description
     *
     * pending                 This is the default state
     *                     of a confirmed Bet
     *
     * settled             All related Bet Propositions have been resulted
     *                     and final settlement has been applied.
     *
     * voided              Race Scratching (and such) lead to Voiding confirmed (Pending) Bets
     *
     * cashed_out          A Bet that has been cashed out "early".
     * @enum {string}
     */
    BetStatuses: (typeof BetStatuses)[number];
    /**
     * BetSubType
     * @description An enumeration.
     * @enum {string}
     */
    BetSubType: (typeof BetSubType)[number];
    /** BetSubmissionConfirmation */
    BetSubmissionConfirmation: {
      /**
       * The unique ID for the request
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      request_id?: string;
      /**
       * The status of the bet that was placed
       * @example Rejected
       */
      status?: components['schemas']['BetPlaceStatus'];
      /**
       * If bet was rejected, reason for rejection
       * @example OddsChange
       */
      rejection_reason?: components['schemas']['BetPlaceRejectionReason'];
      /**
       * Is there a betslip wide issue causing rejection of this request
       * @default false
       * @example true
       */
      is_betslip_rejection?: boolean;
      /** The list of propositions with changed odds */
      changed_odds?: components['schemas']['ChangedOddsSchema'][];
      /**
       * the size of the race field
       * @example 1
       */
      field_size?: number;
      /**
       * The reduced stake after reduction. Note: (reduced_stake + stake_reduction) = request stake
       * @example 100
       */
      reduced_stake?: number;
      /**
       * The reduction applied to the request stake. Note: (reduced_stake + stake_reduction) = request stake
       * @example 100
       */
      stake_reduction?: number;
      /**
       * The closed propositions casing bet request rejection
       * @example [
       *   "1bda22c9-a435-4be3-a831-697b24e8cae4"
       * ]
       */
      closed_propositions?: string[];
      /**
       * all errors on the betslip.
       * @example []
       */
      errors?: components['schemas']['BetValidationError'][];
      /** Game that the punter has triggered */
      gameplay?: components['schemas']['Gameplay'];
      /**
       * The maximum stake allowed on this bet
       * @example 100
       */
      max_stake_limit?: number;
      /** Type of promo token attached to bet */
      promo_token_type?: components['schemas']['BetTokenType'];
      /** Details of promo tokens attached to the bet */
      promo_tokens: components['schemas']['BetTokenSchema'][];
    };
    /** BetTokenSchema */
    BetTokenSchema: {
      /**
       * Id of the bet_token promo
       * Format: uuid
       */
      id?: string;
      /**
       * The type of the bet promo to display in transaction history
       * @example recovery
       */
      token_type?: components['schemas']['BetTokenType'];
      /**
       * Status of the promo token
       * @example claimed
       */
      status: components['schemas']['BetTokenStatus'];
      /**
       * Whether the token can be claimed or not
       * @example true
       */
      can_claim: boolean;
      /**
       * Bonus amount that was recovered
       * @example 1000
       */
      bonus_amount?: number;
      /**
       * Original odds for the bet
       * @example 2.0
       */
      original_odds?: number;
      /**
       * Boosted odds for the bet
       * @example 2.5
       */
      boosted_odds?: number;
    };
    /**
     * BetTokenStatus
     * @description An enumeration.
     * @enum {string}
     */
    BetTokenStatus: (typeof BetTokenStatus)[number];
    /**
     * BetTokenType
     * @description An enumeration.
     * @enum {string}
     */
    BetTokenType: (typeof BetTokenType)[number];
    /**
     * BetType
     * @description An enumeration.
     * @enum {string}
     */
    BetType: (typeof BetType)[number];
    /** BetValidationError */
    BetValidationError: {
      /**
       * Message for display
       * @example Odds have changed
       */
      message?: string;
      /**
       * Code
       * @example changed_odds
       */
      error_code: components['schemas']['BetValidationErrors'];
      /**
       * This value contains the OLD field value and can be return odds, a proposition name or something else (more to come)
       * @example 2.0
       */
      old_field_value?: string;
      /**
       * This value contains the NEW field value and can be return odds, a proposition name or something else (more to come)
       * @example 3.0
       */
      new_field_value?: string;
      /**
       * Field Name
       * @example odds
       */
      field_name?: string;
    };
    /**
     * BetValidationErrors
     * @description An enumeration.
     * @enum {string}
     */
    BetValidationErrors: (typeof BetValidationErrors)[number];
    /** BetcloudError */
    BetcloudError: {
      /**
       * An error message to display for the user
       * @default Invalid request to server
       * @example Invalid request to server
       */
      user_msg?: string;
      /**
       * An error message that may contain techincal jargon and be messy
       * @example Either an auto-generated error or a custom verbose error
       */
      msg?: number;
    };
    /** BetcloudErrorResponse */
    BetcloudErrorResponse: {
      detail: components['schemas']['BetcloudError'];
    };
    /**
     * BetsSupportedSortColumns
     * @description Manages the columns that our Bet query utils can sort by - critical that these columns match the bet columns
     * @enum {string}
     */
    BetsSupportedSortColumns: (typeof BetsSupportedSortColumns)[number];
    /** BlacklistPayload */
    BlacklistPayload: {
      /** Blacklisted Punters */
      blacklisted_punters: components['schemas']['BlacklistedPunter'][];
    };
    /** BlacklistedPunter */
    BlacklistedPunter: {
      /**
       * first name of punter to be blacklisted
       * @example Aaron
       */
      first_name: string;
      /**
       * last name of punter to be blacklisted
       * @example Smith
       */
      last_name: string;
      /**
       * birth date of punter to be blacklisted
       * @example 1990-01-01
       */
      date_of_birth?: string;
      /**
       * postcode of punter to be blacklisted
       * @example 3000
       */
      post_code?: string;
      /**
       * mobile phone number of punter to be blacklisted
       * @example 0401234567
       */
      mobile?: string;
      /**
       * email address of punter to be blacklisted
       * @example john.smith@gmail.com
       */
      email?: string;
    };
    /**
     * BlendedBetResponse
     * @description Response item for Blended Bets for a Race for risk management.
     */
    BlendedBetResponse: {
      /**
       * The bet id.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      bet_id: string;
      /**
       * The creation time of the bet in UTC.
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      created_at: string;
      /**
       * The punter's id.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * The punter's name.
       * @example Victoria
       */
      punter_name: string;
      /**
       * The punter's category name.
       * @example Newbie
       */
      punter_category: components['schemas']['PunterCategories'];
      /**
       * The bet's status.
       * @example pending
       */
      status: components['schemas']['BetStatuses'];
      /**
       * The stake value the bet is placed.
       * @default 0
       * @example 12
       */
      stake?: number;
      /**
       * The odds value the bet is placed.
       * @default 0
       * @example 3.61
       */
      odds?: number;
      /**
       * The exposure value of the bet.
       * @default 0
       * @example 100
       */
      exposure?: number;
      /**
       * The number of duplicate bets with the same Blended combination, excluding the current bet.
       * @default 0
       * @example 12
       */
      duplicate_bets?: number;
      /**
       * The list of selected runners.
       * @default []
       * @example list[BlendedRunnerResponse]
       */
      runners?: components['schemas']['BlendedRunnerResponse'][];
    };
    /** BlendedBetsResponse */
    BlendedBetsResponse: {
      /**
       * Paging information
       * @default {}
       */
      paging?: components['schemas']['api__meta__schemas__bookie_schemas__PagingResponse'];
      /**
       * List of Blended bets for a Race
       * @default []
       * @example list[BlendedBetResponse]
       */
      bets?: components['schemas']['BlendedBetResponse'][];
    };
    /** BlendedCombinationPunterStatsItemResponse */
    BlendedCombinationPunterStatsItemResponse: {
      /**
       * The Punter id.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      id: string;
      /**
       * The Punter's name.
       * @example Andrew V
       */
      name: string;
      /**
       * The Punter's Category.
       * @example Newbie
       */
      category: components['schemas']['PunterCategories'];
      /**
       * The number of bets made by this punter in an SGM combination.
       * @default 0
       * @example 12
       */
      bets_count?: number;
      /**
       * The bets stake.
       * @default 0
       * @example 12
       */
      stake?: number;
      /**
       * The average odds value the bet is placed.
       * @default 0
       * @example 3.6
       */
      odds?: number;
      /**
       * The exposure value of the bet.
       * @default 0
       * @example 100
       */
      exposure?: number;
    };
    /** BlendedCombinationPunterStatsResponse */
    BlendedCombinationPunterStatsResponse: {
      /**
       * Paging information
       * @default {}
       */
      paging?: components['schemas']['api__meta__schemas__bookie_schemas__PagingResponse'];
      /**
       * List of punters made bets on in this combination.
       * @default []
       * @example list[BlendedCombinationPunterStatsItemResponse]
       */
      punters?: components['schemas']['BlendedCombinationPunterStatsItemResponse'][];
    };
    /**
     * BlendedCombinationStatsItemResponse
     * @description Response item for Blended Combination Stat for a Race in risk management.
     */
    BlendedCombinationStatsItemResponse: {
      /**
       * The unique id of proposition.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      multi_uid: string;
      /**
       * The number of bets made in an Blended combination.
       * @default 0
       * @example 12
       */
      bets_count?: number;
      /**
       * The number of punters bet in an Blended combination.
       * @default 0
       * @example 12
       */
      punters_count?: number;
      /**
       * The total bets stake.
       * @default 0
       * @example 12
       */
      stake?: number;
      /**
       * The average odds.
       * @default 0
       * @example 3.6
       */
      odds?: number;
      /**
       * The total exposure.
       * @default 0
       * @example 100
       */
      exposure?: number;
      /**
       * The list of selected runners.
       * @default []
       * @example list[BlendedRunnerResponse]
       */
      runners?: components['schemas']['BlendedRunnerResponse'][];
    };
    /** BlendedCombinationStatsResponse */
    BlendedCombinationStatsResponse: {
      /**
       * Paging information
       * @default {}
       */
      paging?: components['schemas']['api__meta__schemas__bookie_schemas__PagingResponse'];
      /**
       * List of Blended combinations and their stats for a race
       * @default []
       * @example list[BlendedCombinationStatsItemResponse]
       */
      combinations?: components['schemas']['BlendedCombinationStatsItemResponse'][];
    };
    /**
     * BlendedPriceRequest
     * @description Request for price
     */
    BlendedPriceRequest: {
      /**
       * The Race Id
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      race_id: string;
      /**
       * List of propositions to be priced
       * @default []
       * @example ['1bda22c9-a435-4be3-a831-697b24e8cae4']
       */
      proposition_ids?: string[];
    };
    /**
     * BlendedPriceResponse
     * @description Response for price
     */
    BlendedPriceResponse: {
      /**
       * The price/odds of the propositions combo
       * @example 2.8
       */
      price?: number;
      /**
       * If the propositions make a valid blended bet
       * @example True
       */
      valid_bet?: boolean;
    };
    /**
     * BlendedRaceRunnerStatsItemResponse
     * @description Response item for Blended Runner Stats for a Race for risk management.
     */
    BlendedRaceRunnerStatsItemResponse: {
      /**
       * The unique id of the runner.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      id: string;
      /**
       * The runner number.
       * @example 12
       */
      number: number;
      /**
       * The runner name.
       * @example Man City | UTEP Miners | Over 50.5
       */
      name: string;
      /**
       * The number of bets made on this runner as part of Blended bets.
       * @default 0
       * @example 12
       */
      bets_count?: number;
      /**
       * The number of punters bet in on this runner as part of Blended bets.
       * @default 0
       * @example 12
       */
      punters_count?: number;
      /**
       * The total bets stake.
       * @default 0
       * @example 12
       */
      stake?: number;
      /**
       * The average odds value of the Blended bets
       * @default 0
       * @example 3.6
       */
      odds?: number;
      /**
       * The total exposure value for the runner as part of Blended bets
       * @default 0
       * @example 100
       */
      exposure?: number;
    };
    /** BlendedRaceRunnerStatsResponse */
    BlendedRaceRunnerStatsResponse: {
      /**
       * Paging information
       * @default {}
       */
      paging?: components['schemas']['api__meta__schemas__bookie_schemas__PagingResponse'];
      /**
       * List of Blended runner stats for a race
       * @default []
       * @example list[BlendedRaceRunnerStatsItemResponse]
       */
      runners?: components['schemas']['BlendedRaceRunnerStatsItemResponse'][];
    };
    /** BlendedRunnerResponse */
    BlendedRunnerResponse: {
      /**
       * The runner's number.
       * @example 5
       */
      number: number;
      /**
       * The runner name.
       * @example Dirty Weekend
       */
      name: string;
    };
    /** BonusAward */
    BonusAward: {
      /**
       * The unique ID of the punter
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter: string;
      /**
       * The amount to award the punter in cents
       * @example 100
       */
      amount: number;
    };
    /** BonusAwardInput */
    BonusAwardInput: {
      /**
       * The unique ID of the punter
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter: string;
      /**
       * The amount to award the punter in cents
       * @example 100
       */
      amount: number;
      /**
       * The reason why this award is being given to this punter
       * @example Grand final
       */
      reason: string;
      /**
       * Internal annotation for business use only
       * @example Problem customer
       */
      note?: string;
    };
    /** BonusAwardsResponse */
    BonusAwardsResponse: {
      /**
       * The name of the promotion
       * @example John Doe
       */
      name: string;
      /**
       * The reason for the promotion.
       * @example They asked for it.
       */
      reason: string;
      /**
       * the amount of punters this was applied to
       * @example 2
       */
      total_punters: number;
      /**
       * The credit admount
       * @example 6
       */
      total_credited: number;
      /**
       * Date the amount were credited
       * Format: date-time
       */
      promotion_date: string;
    };
    /** BonusBetPromoPunter */
    BonusBetPromoPunter: {
      /**
       * The unique ID of the punter
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * The bonus amount awarded to the punter
       * @example 100
       */
      bonus_amount?: number;
    };
    /** BonusBetPunterInput */
    BonusBetPunterInput: {
      /**
       * The unique ID of the punter
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * The amount to award the punter in cents
       * @example 100
       */
      amount: number;
    };
    /** BonusCreditResponse */
    BonusCreditResponse: {
      /**
       * The id of the revoking bonus transaction (a -ive Credit)
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      revocation_transaction_id?: string;
      /**
       * The id of the bonus transaction (a +ive Credit)
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      transaction_id: string;
      /**
       * When the credit was issued
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      date_issued: string;
      /**
       * the bookie responsible for issuing the credit bonus transaction
       * @example Dean Brown
       */
      issued_by?: string;
      /**
       * The amount awarded to the punter
       * @example 100000
       */
      issue_amount: number;
      /**
       * the reason for the credit
       * @example Promotion
       */
      issue_reason?: string;
      /**
       * the note accompanying the reason for the credit
       * @example Good Customer
       */
      issue_note?: string;
      /**
       * When the credit was issued
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      date_revoked?: string;
      /**
       * the bookie responsible for issuing the credit bonus transaction
       * @example Dean Brown
       */
      revoked_by?: string;
      /**
       * The amount awarded to the punter
       * @example 100000
       */
      revoke_amount?: number;
      /**
       * the reason for the credit
       * @example Promotion
       */
      revoke_reason?: string;
    };
    /** BonusRevokeInput */
    BonusRevokeInput: {
      /**
       * The unique ID of the bonus transaction
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      transaction_id: string;
      /**
       * The reason why this revoke is being issued to this transaction
       * @example Void Grand final
       */
      reason: string;
    };
    /** BookieBetRequestSchema */
    BookieBetRequestSchema: {
      /**
       * The id of the bet request
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      request_id: string;
      /**
       * The type of the bet request
       * @default Placement
       * @example Placement
       */
      request_type?: components['schemas']['BetRequestType'];
      /**
       * The time that the bet was requested
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      created_at: string;
      /**
       * The type of bet
       * @example single
       */
      type: string;
      /**
       * The sub-type of bet
       * @example Quinella, Exacta, Trifecta, First Four
       */
      sub_type?: string;
      /**
       * The UUID of the bet's proposition
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      proposition_id?: string;
      /**
       * The odds that the punter has requested to bed
       * @example 2
       */
      requested_odds?: number;
      /**
       * The amount of money that the punter has requested to bet
       * @example 420000
       */
      requested_stake: number;
      /**
       * Indicates whether or not it is a bonus bet
       * @example false
       */
      is_bonus_bet: boolean;
      /**
       * The status of the bet request
       * @example Pending
       */
      status: string;
      /**
       * The time that the bet request was last updated
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      actioned_at: string;
      /**
       * Actioned By
       * @description The full name of the bookie that actioned the bet request
       * @example Peter Parker
       */
      actioned_by?: string;
      /**
       * The punter id
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * The full name of the punter preformatted to '<first_name> <last_name>'
       * @example Rob Banks
       */
      punter_name: string;
      /**
       * Punter category generated by Storm and/or Bookie
       * @example Newbie
       */
      punter_category: string;
      /**
       * A punter rating (1-100) calculated by Storm (NOT YET IMPLEMENTED)
       * @example 0
       */
      punter_storm_score: number;
      /**
       * the id of the event in our database, race_id or match_id
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      event_id?: string;
      /**
       * The Race name or Match name for the event
       * @example Nadal vs Khachanov
       */
      event_title?: string;
      /**
       * The Competition or venue name for the event
       * @example Flemington
       */
      event_subtitle?: string;
      /**
       * The time that the event will start in UTC
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      event_start: string;
      /**
       * Denotes if the event is a race or match
       * @example Race
       */
      event_type?: string;
      /**
       * The SportName or race_type for an event to support icons
       * @example Horse Racing
       */
      event_icon?: string;
      /**
       * The status inferred from TAB that the event is in
       * @example Protest
       */
      event_status?: components['schemas']['GeneralStatus'];
      /**
       * The current odds of the proposition
       * @example 1.1
       */
      proposition_odds?: number;
      /**
       * The odds approved for the bet
       * @example 1.1
       */
      approved_odds?: number;
      /**
       * The stake approved for the bet
       * @example 420000
       */
      approved_stake?: number;
      /**
       * The amount paid out for the bet in cents
       * @example 420000
       */
      bet_payout?: number;
      /**
       * The status of the bet
       * @example cashed_out
       */
      bet_status?: string;
      /**
       * True if the bet is won
       * @example true
       */
      bet_won?: boolean;
      /** bet request selection */
      selection?: unknown;
      /**
       * The market name for this bet leg
       * @example AFW Gee-NMl
       */
      market_name?: string;
      /** If this bet is a multi, this will contain a list of the legs */
      bet_legs?: components['schemas']['MultiLegSchema'][];
      /**
       * The MBL stake reduction if applicable
       * @example 255
       */
      mbl_stake?: number;
      /**
       * The MBL threshold if one was in plat at time of intercept - eg $500
       * @example 50000
       */
      mbl_threshold?: number;
      /**
       * The Exposure Threshold breached during intercept
       * @example pcel_greyhound
       */
      intercept_reason?: string;
      /**
       * Punter category generated by Storm and/or Bookie
       * @example Newbie
       */
      punter_category_at_placement?: string;
      /**
       * The name of the punter category limit at time of intercept
       * @example thoroughbred_exposure
       */
      punter_category_limit_name?: string;
      /**
       * The punter category limit at time of intercept
       * @example 5000
       */
      punter_category_limit?: number;
      /**
       * The Type of Proposition
       * @example Win
       */
      proposition_type?: string;
      /**
       * The name of a Race Runner
       * @example Betcloud Buddy
       */
      runner_name?: string;
      /**
       * The number of a Race Runner
       * @example 1
       */
      runner_number?: number;
      /**
       * Price type of the bet
       * @example fixed
       */
      price_type?: components['schemas']['PriceType'];
      /**
       * RAAIN rule has been breached on intercept.
       * @default false
       * @example true
       */
      raain_rule_breached?: boolean;
      /**
       * Punter Profile Sticky Note
       * @example Watch out for trouble here !
       */
      sticky_note?: components['schemas']['StickyNoteBaseSchema'];
      /**
       * The type of the bet
       * @example Single
       */
      bet_type: components['schemas']['BetType'];
    };
    /** BookieBetRequestsSchema */
    BookieBetRequestsSchema: {
      /**
       * Paging information
       * @default {}
       */
      paging?: components['schemas']['api__meta__schemas__bookie_schemas__PagingResponse'];
      /** Bet Requests */
      bet_requests: (
        | components['schemas']['BookieBetRequestSchema']
        | components['schemas']['BookieBetSettlementRequestSchema']
      )[];
    };
    /**
     * BookieBetSchema
     * @description This schema adds the additional information that a bookie needs to display the bet information
     */
    BookieBetSchema: {
      /**
       * The unique ID of this bet
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      bet_id: string;
      /**
       * The unique ID of the event (Race or Match)
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      event_id?: string;
      /**
       * For sports this will be the market type, for races it will be the bet type, for multi it will be empty
       * @example Win (Fixed)
       */
      bet_description: string;
      /**
       * The jump/start time of the event in UTC
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      event_start: string;
      /**
       * The date and time in UTC this bet was placed
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      created_at: string;
      /**
       * The type of event, either a Race or Match
       * @example Race
       */
      event_type?: components['schemas']['EventTypes'];
      /**
       * The Sport name or race type for an event to support icons
       * @example Harness Racing
       */
      event_icon?: string;
      /**
       * The stake/amount initially requested by punter in cents. Bookie may have reduced stake
       * @example 200
       */
      requested_stake: number;
      /**
       * The stake/amount wagered in the proposition in cents (after any stake reduction by Bookie)
       * @example 100
       */
      stake: number;
      /**
       * The odds for the Fixed-Odds proposition at the time the bet was placed
       * @example 2
       */
      odds?: number;
      /**
       * True if the bet was won, None if the bet is not resulted yet
       * @example false
       */
      is_won?: boolean;
      /**
       * True if the bet was placed with bonus balance
       * @example true
       */
      is_bonus: boolean;
      /**
       * Represents the current state for the Bet
       * @example settled
       */
      status: components['schemas']['BetStatuses'];
      /**
       * Represents the amount that has been paid out to the punter
       * @example 100
       */
      payout?: number;
      /** The data for the event that this bet is on */
      event_data?:
        | components['schemas']['BetRaceData']
        | components['schemas']['BetMatchData'];
      /** If this bet is a multi, this will contain a list of the legs */
      bet_legs?: components['schemas']['MultiLegSchema'][];
      /**
       * The price type the bet was struck against
       * @example fixed
       */
      price_type?: components['schemas']['PriceType'];
      /**
       * The type of the bet
       * @example Single
       */
      bet_type?: components['schemas']['BetType'];
      /**
       * The id of the punter who placed the bet
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * The full name of the punter who placed the bet
       * @example John Doe
       */
      punter_name: string;
      /**
       * The player type of the punter who placed the bet
       * @example Recreational
       */
      punter_type: string;
      /**
       * For a race, '<venue_name> - Race <race number>. For a Match is just match name
       * @example Sandown - Race 4
       */
      event_title?: string;
      /**
       * Runner name if a race, proposition name if a match
       * @example Geelong 40+
       */
      event_subtitle?: string;
      /**
       * Race name for win or place, or Market parent of the associated proposition
       * @example TST Eng 2nd Inns 19/12
       */
      market_name: string;
      /**
       * If the bet has been flagged by a bookie, this will return True
       * @example false
       */
      is_flagged: boolean;
      /**
       * The odds for the proposition from TAB at the time the bet was placed (NOT IMPLEMENTED)
       * @example 2
       */
      tab_odds?: number;
      /**
       * The odds for the bet's proposition right now (NOT IMPLEMENTED)
       * @example 2
       */
      current_odds?: number;
      /**
       * The bonus stake/amount wagered in the proposition in cents (NOT IMPLEMENTED)
       * @default 0
       * @example 100
       */
      bonus_stake?: number;
      /**
       * The punters bet success score (NOT IMPLEMENTED)
       * @default 0
       * @example 1.15
       */
      bcs?: number;
      /**
       * Total profit and loss of all punter's bets in cents (NOT IMPLEMENTED)
       * @default 0
       * @example -100
       */
      punter_total_profit?: number;
      /**
       * Total profit and loss of all punter's bets code specific to sport name or race type in cents (NOT IMPLEMENTED)
       * @default 0
       * @example 100
       */
      punter_code_profit?: number;
      /**
       * Exposure for the entire event in cents (NOT IMPLEMENTED)
       * @default 0
       * @example 10000
       */
      event_exposure?: number;
      /**
       * The result for all bets if this bet succeeds in cents (NOT IMPLEMENTED)
       * @default 0
       * @example 200000
       */
      result?: number;
      /** exotic selections: [[1st place selections], [2nd place selections], ...] */
      exotic_selections?: components['schemas']['ExoticSelection'][];
      /** exotic dividends: [[1st place selections], [2nd place selections], ...] */
      exotic_dividends?: components['schemas']['ExoticBetDividends'];
      /**
       * Promotion info for the given bet
       * @example true
       */
      promos?: components['schemas']['BetTokenSchema'][];
    };
    /** BookieBetSettlementRequestSchema */
    BookieBetSettlementRequestSchema: {
      /**
       * The id of the bet request
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      request_id: string;
      /**
       * The type of the bet request
       * @default Settlement
       * @example Settlement
       */
      request_type?: components['schemas']['BetRequestType'];
      /**
       * The id of the bet
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      bet_id: string;
      /**
       * The time that the bet was requested
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      created_at: string;
      /**
       * The payout amount that needs to be approved
       * @example 420000
       */
      requested_payout?: number;
      /**
       * The type of bet
       * @example single
       */
      type: string;
      /**
       * The odds of the bet
       * @example 2
       */
      odds?: number;
      /**
       * The stake of the bet
       * @example 420000
       */
      stake: number;
      /**
       * Indicates whether or not it is a bonus bet
       * @example false
       */
      is_bonus_bet: boolean;
      /**
       * The status of the bet request
       * @example Pending
       */
      status: string;
      /**
       * The time that the bet request was last updated
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      actioned_at: string;
      /**
       * Actioned By
       * @description The full name of the bookie that actioned the bet request
       * @example Peter Parker
       */
      actioned_by?: string;
      /**
       * The punter id
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * The full name of the punter preformatted to '<first_name> <last_name>'
       * @example Rob Banks
       */
      punter_name: string;
      /**
       * Punter category generated by Storm and/or Bookie
       * @example Newbie
       */
      punter_category: string;
      /**
       * The amount paid out for the bet in cents
       * @example 420000
       */
      bet_payout?: number;
      /**
       * The status of the bet
       * @example cashed_out
       */
      bet_status?: string;
      /** bet selection */
      selection?: unknown;
      /**
       * Punter Profile Sticky Note
       * @example Watch out for trouble here !
       */
      sticky_note?: components['schemas']['StickyNoteBaseSchema'];
      /** If this bet is a multi, this will contain a list of the legs */
      bet_legs?: components['schemas']['MultiLegSchema'][];
    };
    /** BookieCardInput */
    BookieCardInput: {
      /**
       * Token response from fat Zebra
       * @example xxxxxxxxx
       */
      token: string;
      /**
       * The punter ID
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * The card ID for update action
       * Format: uuid
       */
      card_id?: string;
      /**
       * Is the card verified
       * @example true
       */
      is_verified?: boolean;
    };
    /** BookieContactUsResponse */
    BookieContactUsResponse: {
      /**
       * The bookies phone number
       * @example 0212121221
       */
      phone_number: string;
      /**
       * The bookies international phone number
       * @example 0212121221
       */
      international_phone_number: string;
      /**
       * the bookies email
       * @example hexbet@mail.com
       */
      email: string;
      /**
       * the street number of the bookie
       * @example 30000000000
       */
      street_number: string;
      /**
       * the street name of the bookie.
       * @example Fake Street
       */
      street_name: string;
      /**
       * Suburb of the bookie.
       * @example Melbourne
       */
      suburb: string;
      /**
       * What state the bookie is located
       * @example Victoria
       */
      state: string;
      /**
       * The bookies postcode
       * @example 3000
       */
      post_code: string;
    };
    /** BookieDeleteCardInput */
    BookieDeleteCardInput: {
      /**
       * Id
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      id: string;
      /**
       * The punter ID
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
    };
    /** BookieDisplayForSearch */
    BookieDisplayForSearch: {
      /**
       * Id
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      id?: string;
      /**
       * First Name
       * @example John
       */
      first_name?: string;
      /**
       * Last Name
       * @example Doe
       */
      last_name?: string;
    };
    /**
     * BookieMatchObject
     * @description A complete match object, for displaying match data in the bookie trade manager
     */
    BookieMatchObject: {
      /**
       * The match id
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      match_id: string;
      /**
       * The display name of the match
       * @example Greyhound Race 1
       */
      display_name: string;
      /**
       * ID of the sport.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      sport_id?: string;
      /**
       * The sport name
       * @example AFL
       */
      sport_name: string;
      /**
       * The sport type
       * @example Promotional
       */
      sport_type?: string;
      /**
       * The start time of the race in UTC timezone
       * Format: date-time
       */
      start_time: string;
      /**
       * The tournament name
       * @example State Of Origin
       */
      tournament_name?: string;
      /**
       * The competition name
       * @example Round 20
       */
      competition_name: string;
      modifier?: components['schemas']['ModifierSchema'];
      match_stats?: components['schemas']['MatchStats'];
      /**
       * The status of the match.
       * @example Voided
       */
      status: components['schemas']['GeneralStatus'];
      /**
       * If the match status is locked
       * @example false
       */
      lock_status?: boolean;
      /**
       * If the match is suspended or not
       * @default false
       * @example false
       */
      is_suspended?: boolean;
      /**
       * If the winter settlement will be ignored or not
       * @example false
       */
      ignore_winter_settlement?: boolean;
      /**
       * Whether the SGM is disabled for the match.
       * @default false
       * @example false
       */
      sgm_disabled?: boolean;
      /**
       * Whether to intercept all SGM bets for the match.
       * @default false
       * @example false
       */
      sgm_intercept_all?: boolean;
      /**
       * Whether SGM is available (from source feed) for this match.
       * @default false
       * @example false
       */
      sgm_available?: boolean;
    };
    /** BookieProfileResponse */
    BookieProfileResponse: {
      /**
       * The bookie's first name
       * @example Johnny
       */
      first_name: string;
      /**
       * The bookie's last name
       * @example Depp
       */
      last_name: string;
      /**
       * The bookie's email
       * @example johnnycoke@gmail.com
       */
      email: string;
      /**
       * The bookie's phone number
       * @example 0412345678
       */
      mobile: string;
      /**
       * The state or territory that the bookie is licenced in
       * @example Victoria
       */
      licensed_state: components['schemas']['AustralianStatesTerritories'];
      /**
       * The bookie's license number
       * @example 1
       */
      license_id: string;
      /**
       * The bookie's id
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      id: string;
      /**
       * The brand being managed by the bookie
       * @example Pay Day Bet
       */
      brand: string;
      /**
       * The list of permissions the user has
       * @example ['settings_setup_policies', 'bank_ready_to_pay_export']
       */
      permissions?: string[];
    };
    /** BookieProfileUpdate */
    BookieProfileUpdate: {
      /**
       * The bookie's first name
       * @example Johnny
       */
      first_name: string;
      /**
       * The bookie's last name
       * @example Depp
       */
      last_name: string;
      /**
       * The bookie's email
       * @example johnnycoke@gmail.com
       */
      email: string;
      /**
       * The bookie's phone number
       * @example 0412345678
       */
      mobile: string;
      /**
       * The state or territory that the bookie is licenced in
       * @example Victoria
       */
      licensed_state: components['schemas']['AustralianStatesTerritories'];
      /**
       * The bookie's license number
       * @example 1
       */
      license_id: string;
    };
    /**
     * BookieProposition
     * @description This schema combines the proposition base object with a modifier object and a stats object
     * It is used to represent a proposition in the Bookie platform
     */
    BookieProposition: {
      /**
       * The proposition ID in our database
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      proposition_id: string;
      /**
       * The name of the proposition
       * @example Novak
       */
      proposition_name: string;
      /**
       * The modified market odds for this proposition (deprecated)
       * @example 2.3
       */
      return_amount?: number;
      /**
       * The modified market odds for this proposition
       * @example 2.3
       */
      odds?: number;
      /**
       * The modified market odds for this proposition from winter
       * @example 1.1
       */
      winter_return_amount?: number;
      /**
       * The status of the proposition
       * @example Voided
       */
      status: components['schemas']['GeneralStatus'];
      /**
       * If the proposition is suspended or not.
       * @default false
       * @example false
       */
      is_suspended?: boolean;
      /**
       * suspended status of proposition on winter
       * @default false
       * @example true
       */
      winter_is_suspended?: boolean;
      /**
       * success or otherwise after settlement, can be one of WINNER|LOSER|TOP2|TOP3 depending on market type, None suggests indeterminate state
       * @example WINNER
       */
      outcome?: components['schemas']['PropositionOutcome'];
      /**
       * SGM availability.
       * @default false
       * @example true
       */
      sgm_available?: boolean;
      /**
       * SRM price if available.
       * @example SRM price for top1-4
       */
      srm_price?: components['schemas']['PropositionSrmPriceSchema'];
      /**
       * Available price types
       * @example [
       *   "fixed"
       * ]
       */
      price_types?: components['schemas']['PriceType'][];
      /**
       * the id of the market.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      market_id?: string;
      /**
       * Proposition Level information used in FE display
       * @example {"metric": null, "value1": null, "value2": null, "team": null, "team_role": null, "player": null, "event_part": null, "discriminator": null}
       */
      proposition_info?: Record<string, never>;
      /**
       * Sort Order precedence for displayed Propositions from a Market
       * @example 100
       */
      sort_order?: number;
      /**
       * The tote dividends for this proposition,
       * @example {
       *   "tote_single_mid": 4,
       *   "other_tote": 5
       * }
       */
      dividends?: {
        [key: string]: number | undefined;
      };
      proposition_modifier?: components['schemas']['ModifierSchema'];
      proposition_stats?: components['schemas']['BookiePropositionStats'];
      /**
       * If the proposition status is locked or not.
       * @example false
       */
      lock_status?: boolean;
      /**
       * If the price is locked or not.
       * @example false
       */
      lock_price?: boolean;
      /**
       * The scratch time for the proposition in UTC timezone
       * Format: date-time
       */
      scratch_time?: string;
      /**
       * The winter scratch time for the proposition in UTC timezone
       * Format: date-time
       */
      winter_scratch_time?: string;
      /**
       * The deductions for a scratched proposition
       * @example [
       *   2,
       *   1
       * ]
       */
      deductions?: number[];
    };
    /** BookiePropositionStats */
    BookiePropositionStats: {
      /**
       * count of bets placed on propositions for this Market
       * @example 4
       */
      total_bets: number;
      /**
       * dollar amount of all bet stakes for this Market
       * @example 26000
       */
      total_staked: number;
      /**
       * biggest stake made for this Market
       * @example 8000
       */
      biggest_bet: number;
      /**
       * total exposure divided by total stake
       * @example 0.807
       */
      average_price: number;
      /**
       * dollar amount of all Bonus bet stakes for this Market
       * @example 900
       */
      bonus_bets: number;
      /**
       * exposure of (payout for) this proposition
       * @example 46800
       */
      exposure: number;
      /**
       * profit or loss result if this proposition wins
       * @example 5000
       */
      result: number;
    };
    /**
     * BookieRaceObject
     * @description A complete race object, for displaying race data in the bookie trade manager
     */
    BookieRaceObject: {
      /**
       * The user id
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      race_id: string;
      /**
       * If the race is suspended or not
       * @default false
       * @example false
       */
      is_suspended?: boolean;
      /**
       * The display name of the race
       * @example Greyhound Race 1
       */
      display_name: string;
      /**
       * The name of the venue this race is held at
       * @example Flemington
       */
      venue_name: string;
      /**
       * The type of race
       * @example Greyhounds
       */
      race_type: components['schemas']['RaceTypes'];
      /**
       * The start time of the race in UTC timezone
       * Format: date-time
       */
      start_time: string;
      /**
       * The race's overall event status
       * @example Open
       */
      status: components['schemas']['GeneralStatus'];
      /**
       * If the race status is locked
       * @example false
       */
      lock_status?: boolean;
      /**
       * If the race ignores winter settlement
       * @example false
       */
      ignore_winter_settlement?: boolean;
      /**
       * If the race ignores winter prices
       * @example false
       */
      lock_price?: boolean;
      /**
       * If the race has first past the post protest override enabled (or allow backsies mode if you like)
       * @example false
       */
      fptp_protest_override?: boolean;
      win_modifier?: components['schemas']['ModifierSchema'];
      place_modifier?: components['schemas']['ModifierSchema'];
      /** Runners */
      runners: components['schemas']['BookieRaceRunner'][];
      stats?: components['schemas']['RaceStats'];
      /**
       * Whether the SRM is disabled for the race.
       * @default false
       * @example false
       */
      srm_disabled?: boolean;
      /**
       * Whether to intercept all SRM bets for the race.
       * @default false
       * @example false
       */
      srm_intercept_all?: boolean;
      /**
       * Whether the Blended is disabled for the race.
       * @default false
       * @example false
       */
      blended_disabled?: boolean;
      /**
       * Whether to intercept all Blended bets for the race.
       * @default false
       * @example false
       */
      blended_intercept_all?: boolean;
      /**
       * Which price types, if any, have been set to force all bets to approval
       * @default []
       * @example [
       *   "tote_single_mid"
       * ]
       */
      price_types_intercept_all?: components['schemas']['PriceType'][];
      /**
       * Whether the Even shot is disabled for the race.
       * @default true
       * @example true
       */
      even_shot_disabled?: boolean;
    };
    /** BookieRaceRunner */
    BookieRaceRunner: {
      /**
       * The race runner ID in our database
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      race_runner_id: string;
      /**
       * The race runners Globally Unique ID from Winter
       * Format: uuid
       * @example 2023-04-29-GLD-H-6-5
       */
      race_runner_external_ref: string;
      /**
       * The display name of the runner
       * @example Elon Musk
       */
      display_name: string;
      /**
       * The runner number for this race
       * @example 2
       */
      number?: number;
      /**
       * The runner barrier number for this race
       * @example 5
       */
      barrier_number: number;
      /**
       * The exact URL where you may find an image representing this runner
       * @example https://placeimg.com/100/100
       */
      silk_url?: string;
      /**
       * where did the runner place.
       * @example 1
       */
      results_place?: number;
      /**
       * The status of the runner
       * @example Closed
       */
      status: components['schemas']['GeneralStatus'];
      /**
       * The status of the runner from winter
       * @example Closed
       */
      winter_status: components['schemas']['GeneralStatus'];
      /**
       * Win Proposition Payout Aggregate - Win Market Stake Aggregate
       * @example 1000
       */
      win_result: number;
      /**
       * Number of bets placed on the win proposition
       * @example 10
       */
      win_bets: number;
      /**
       * Win Proposition Payout Aggregate / Win Proposition Stake Aggregate
       * @example 2.5
       */
      avg_win_price: number;
      /**
       * Win Proposition Stake Aggregate
       * @example 100000
       */
      win_hold: number;
      /**
       * The largest single stake contributing to the Win Proposition Stake Aggregate
       * @example 100000
       */
      biggest_win_bet: number;
      /**
       * Place Proposition Payout Aggregate - Place Proposition Stake Aggregate
       * @example 10000
       */
      place_liability: number;
      /**
       * Number of bets put on the place proposition
       * @example 10
       */
      place_bets: number;
      /**
       * Place Proposition Payout Aggregate / Place Proposition Stake Aggregate
       * @example 2.5
       */
      avg_place_price: number;
      /**
       * Place Proposition Stake Aggregate
       * @example 100000
       */
      place_hold: number;
      win_proposition?: components['schemas']['BookieProposition'];
      place_proposition?: components['schemas']['BookieProposition'];
      /**
       * if the runner is suspended or not.
       * @default false
       * @example false
       */
      is_suspended?: boolean;
      /**
       * if the propositions are suspended or not.
       * @default false
       * @example false
       */
      proposition_is_suspended?: boolean;
      /**
       * if the runner is suspended or not from winter.
       * @default false
       * @example false
       */
      winter_is_suspended?: boolean;
      /**
       * if the runner status is locked.
       * @example false
       */
      lock_status?: boolean;
      /**
       * if the runner is manually suspended or not.
       * @example false
       */
      lock_price?: boolean;
      /**
       * The last person who manually scratched the runner
       * @example Elon Musk
       */
      scratched_by?: string;
      form_data?: components['schemas']['RaceRunnerFormData'];
      flucs_data?: components['schemas']['RaceRunnerFlucsData'];
      /** Opening Price */
      opening_price?: number;
      /** Flucs */
      flucs?: unknown[];
    };
    /** BulkBonusAwardInput */
    BulkBonusAwardInput: {
      /**
       * The name of the CSV which contained these bulk inserts
       * @example aflgrandfinal.csv
       */
      name: string;
      /**
       * The reason why each of these awards are being given
       * @example Grand final
       */
      reason: string;
      /** Bonus Awards */
      bonus_awards: components['schemas']['BonusAward'][];
    };
    /** BulkPromoInput */
    BulkPromoInput: {
      /**
       * The name of the promotion
       * @example Saturday Deposit Match 123
       */
      name: string;
      /**
       * The name of the CSV which contained these bulk inserts
       * @example aflgrandfinal.csv
       */
      file_name: string;
      /**
       * The reason why each of these promo are being given
       * @example Deposit Match
       */
      reason: string;
      /**
       * The type of promo
       * @example deposit_match
       */
      promo_type: components['schemas']['PromoType'];
      /**
       * The expiry time of the promotion
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      expiry?: string;
      /** Promo Punters */
      promo_punters: (
        | components['schemas']['DepositMatchPunterInput']
        | components['schemas']['BonusBetPunterInput']
      )[];
    };
    /** BulkPromoResponse */
    BulkPromoResponse: {
      /**
       * The unique ID of the promo
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      promo_id: string;
    };
    /** CancelBet */
    CancelBet: {
      /**
       * The bet ID to refund
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      bet_id: string;
      /** Reason for cancelling the bet */
      reason: string;
      /** Notes for cancelling the bet */
      note?: string;
    };
    /** CancelPunterPromoPayload */
    CancelPunterPromoPayload: {
      /**
       * The unique ID of the promo
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      promo_id: string;
      /**
       * The unique ID of the punter
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
    };
    /** CardItemResponse */
    CardItemResponse: {
      /**
       * The id of the card in our database.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      card_id?: string;
      /**
       * the type of card the user used
       * @example Visa
       */
      card_type?: string;
      /**
       * the last 4 digits of the user card.
       * @example 9876
       */
      last_4?: string;
      /**
       * The token for the card.
       * @example card_123456789
       */
      card_token?: string;
      /**
       * The expiry date of the card.
       * Format: date
       * @example 2022-12-12
       */
      card_expiry?: string;
      /**
       * Is the card verified.
       * @example false
       */
      is_verified?: boolean;
      /**
       * Is this the default card.
       * @example true
       */
      is_default?: boolean;
    };
    /** ChangedOddsSchema */
    ChangedOddsSchema: {
      /**
       * The ID of the proposition with changed odds
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      proposition_id?: string;
      /**
       * The new odds for the proposition
       * @example 1.5
       */
      new_odds: number;
    };
    /**
     * ChannelType
     * @description An enumeration.
     * @enum {string}
     */
    ChannelType: (typeof ChannelType)[number];
    /** ClaimPromoTokenResponse */
    ClaimPromoTokenResponse: {
      token: components['schemas']['BetTokenSchema'];
      gameplay: components['schemas']['Gameplay'];
    };
    /** CloseMatchMarketInput */
    CloseMatchMarketInput: {
      /**
       * Id of the object to suspend.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      match_id?: string;
      /**
       * The ids of the child objects to suspend
       * @example [
       *   "1",
       *   "2",
       *   "3"
       * ]
       */
      market_ids?: string[];
      /**
       * lock the status or not
       * @example true
       */
      lock_status?: boolean;
      /**
       * The status of the match or market
       * @example Open
       */
      status?: components['schemas']['GeneralStatus'];
      /**
       * to determine if it is for all markets of the match
       * @example true
       */
      for_all_markets?: boolean;
    };
    /** CloseMatchPropositionInput */
    CloseMatchPropositionInput: {
      /**
       * Id of the proposition to close.
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      proposition_id?: string;
      /**
       * lock the status or not
       * @example true
       */
      lock_status?: boolean;
      /**
       * The status of the proposition
       * @example Open
       */
      status?: components['schemas']['GeneralStatus'];
    };
    /** CompetitionListObject */
    CompetitionListObject: {
      /**
       * The id of the competition.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      competition_id: string;
      /**
       * The sport id of the competition.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      sport_id: string;
      /**
       * The name of the competition
       * @example example
       */
      name: string;
      /**
       * The display name of the competition
       * @example example
       */
      display_name: string;
      /**
       * The sort order of the competition
       * @example 0
       */
      sort_order?: number;
      /**
       * The updated time of the competition
       * Format: date-time
       */
      updated_at?: string;
      /**
       * The competition is manually created or not
       * @example true
       */
      is_manual?: boolean;
    };
    /** CompetitionMarketListObject */
    CompetitionMarketListObject: {
      /**
       * The id of the competition.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      competition_id: string;
      /**
       * The name of the competition
       * @example example
       */
      name: string;
      /**
       * The display name of the competition
       * @example example
       */
      display_name: string;
      /**
       * The competition is manually created or not
       * @example true
       */
      is_manual?: boolean;
      /** The Match object */
      match: components['schemas']['MatchMarketListObject'];
    };
    /** CompetitionMarketView */
    CompetitionMarketView: {
      /**
       * The UUID for the competition
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      competition_id: string;
      /**
       * The UUID for the Match in our database
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      match_id: string;
      /**
       * The name of the Match
       * @example The Tennis Grand Slam
       */
      match_name: string;
      /**
       * Formatted list of all the Markets in a Match
       * @example []
       */
      markets?: components['schemas']['MarketSchema'][];
    };
    /** CompetitionOffering */
    CompetitionOffering: {
      /**
       * The ID of this competition
       * Format: uuid
       */
      competition_id: string;
      /** The name of this competition offering */
      display_name: string;
      /** True if this specific competition is offered */
      is_offered: boolean;
      /** True if this specific competition is from oddsmatrix */
      is_om: boolean;
    };
    /** CompetitionTournament */
    CompetitionTournament: {
      /**
       * The id of a tournament
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      tournament_id: string;
      /**
       * The name of a tournament
       * @example Australian Open
       */
      tournament_name: string;
    };
    /** CompetitionView */
    CompetitionView: {
      /**
       * The UUID for the competition
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      competition_id: string;
      /**
       * The UUID for the sport in our database
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      sport_id: string;
      /**
       * The name of the competition
       * @example The Tennis Grand Slam
       */
      competition_name: string;
      /**
       * Formatted list of all the tournaments in a competition
       * @example []
       */
      tournaments?: components['schemas']['CompetitionTournament'][];
      /**
       * Country linked to this competition
       * @example Australia
       */
      country?: string;
      /**
       * Whether the league is a top league
       * @example true
       */
      is_top_league?: boolean;
      /** Open matches count for this competition */
      match_count?: number;
    };
    /** CountryRaceOffering */
    CountryRaceOffering: {
      /** States */
      states: components['schemas']['StateRaceOffering'][];
      /** Venues */
      venues: components['schemas']['VenueOffering'][];
      /** Display Name */
      display_name: string;
      /** All Offered */
      all_offered: boolean;
    };
    /** CountryStates */
    CountryStates: {
      /**
       * An available country (as dictated by Race Offering)
       * @example Australia
       */
      country: string;
      /**
       * The list of available states grouped by country (as dictated by Race Offering)
       * @example [VIC,NSW]
       */
      states: string[];
    };
    /** CreateDepositInput */
    CreateDepositInput: {
      /**
       * The id of the deposit in our database.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      deposit_id?: string;
      /**
       * The amount a user wishes to deposit.
       * @example 100000000000
       */
      amount: number;
      /**
       * The id of the promo the punter is opting in to, if applicable
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      opted_in_promo?: string;
    };
    /** DeleteBankInput */
    DeleteBankInput: {
      /**
       * the id of the bank object stored in out database
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      id?: string;
      /**
       * The punter ID
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
    };
    /** DeleteCardInput */
    DeleteCardInput: {
      /**
       * Id
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      id: string;
    };
    /** DeleteMarketInput */
    DeleteMarketInput: {
      /**
       * The id of the market to delete.
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      market_id: string;
    };
    /** DepositItemResponse */
    DepositItemResponse: {
      /**
       * The id of the deposit in our database.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      deposit_id: string;
      /**
       * The amount of the deposit.
       * @example 100000000000
       */
      amount: number;
      /**
       * The status of the deposit.
       * @example success
       */
      status: string;
      /**
       * The reason for the deposit status.
       * @example Deposit was successful.
       */
      reason?: string;
      /**
       * The bookie who actioned the deposit.
       * Format: uuid
       * @example system
       */
      actioned_by?: string;
      /**
       * The time the deposit was actioned.
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      actioned_at: string;
      /**
       * The type of deposit.
       * @example card
       */
      type: string;
    };
    /** DepositLimitReturn */
    DepositLimitReturn: {
      /**
       * The current maximum amount that the punter can deposit, in cents (example equates to $10.50)
       * @example 1050
       */
      deposit_limit_current?: number;
      /**
       * The frequency that the deposit limit resets
       * @example 7
       */
      deposit_limit_frequency_current?: components['schemas']['EventFrequencies'];
      /**
       * The upcoming limit that the punter will be able to deposit (if applicable)
       * @example 1050
       */
      deposit_limit_waiting?: number;
      /**
       * The upcoming frequency that the deposit limit resets
       * @example 7
       */
      deposit_limit_frequency_waiting?: components['schemas']['EventFrequencies'];
      /**
       * The datetime that the cooldown period ends (if applicable)
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      deposit_limit_cooldown_ends?: string;
      /**
       * The datetime that the deposit limit is/will be active
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      deposit_limit_active?: string;
      /**
       * The datetime that the deposit limit was last set/updated
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      deposit_limit_last_updated?: string;
    };
    /** DepositLimitSchema */
    DepositLimitSchema: {
      /**
       * If a bookie set the deposit limit, this will be the bookie's id or None if the user set the limit
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      bookie_id?: string;
      /**
       * Deposit limit amount
       * @example 5
       */
      amount?: number;
      /**
       * Frequency they can deposit
       * @example 1
       */
      frequency?: components['schemas']['EventFrequencies'];
      /**
       * Date the limit was set
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      date_set?: string;
      /**
       * Date for cooldown
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      cooldown_ends?: string;
      /**
       * Whens it active
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      active_when?: string;
      /**
       * When was it last updated
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      last_updated?: string;
      /**
       * if there is a deposit limit waiting
       * @example 1
       */
      limit_waiting?: number;
      /**
       * if there is a frequency waiting
       * @example 1
       */
      frequency_waiting?: components['schemas']['EventFrequencies'];
      /**
       * If a bookie set the deposit limit, this will be the bookie's full name
       * @example Test Admin
       */
      updated_by?: string;
    };
    /** DepositMatchItem */
    DepositMatchItem: {
      /**
       * Id of the promotion
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      id: string;
      /**
       * The type of the promotion
       * @example deposit_match
       */
      promo_type: components['schemas']['PromoType'];
      /**
       * Percentage of the deposit amount that will be received as bonus
       * @example 0.75
       */
      percentage: number;
      /**
       * Maximum amount of the bonus in cents
       * @example 10000
       */
      max_amount: number;
      /**
       * The expiry time of the promotion
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      expiry?: string;
      /**
       * Whether or not the punter must opt in to the promotion
       * @example true
       */
      opt_in_required: boolean;
    };
    /** DepositMatchPromoPunter */
    DepositMatchPromoPunter: {
      /**
       * The unique ID of the punter
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * The proportion of the deposit that the user will receive as bonus
       * @example 0.75
       */
      percentage: number;
      /**
       * The maximum amount for the deposit match bonus in cents
       * @example 100
       */
      max_amount: number;
      /**
       * Current status of the promo for this punter
       * @example pending
       */
      status: components['schemas']['PromoStatus'];
      /**
       * The bonus amount awarded to the punter for this deposit match
       * @example 100
       */
      bonus_amount?: number;
    };
    /** DepositMatchPunterInput */
    DepositMatchPunterInput: {
      /**
       * The unique ID of the punter
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * The proportion of the deposit that the user will receive as bonus
       * @example 0.75
       */
      percentage: number;
      /**
       * The maximum amount for the deposit match bonus in cents
       * @example 100
       */
      max_amount: number;
    };
    /** DepositReconcileResponse */
    DepositReconcileResponse: {
      /**
       * The message to return to the user.
       * @example Deposit was successfully reconciled.
       */
      message: string;
    };
    /** DepositResponse */
    DepositResponse: {
      /**
       * The message to display to the user.
       * @example Deposit was successful.
       */
      message: string;
      /**
       * The code of the response.
       * @example 101
       */
      code?: number;
      /**
       * UUID of the deposit
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      deposit_id: string;
      /**
       * Is the deposit first deposit?
       * @example true
       */
      is_first_deposit?: boolean;
      /** Verification Value Hash generated by the back end using a shared secret with FZ */
      verification?: string;
      /** currency of the deposit */
      currency?: string;
    };
    /** DepositStatusResponse */
    DepositStatusResponse: {
      /**
       * status of the deposit
       * @example Approved
       */
      status: components['schemas']['DepositStatuses'];
    };
    /**
     * DepositStatuses
     * @description An enumeration.
     * @enum {string}
     */
    DepositStatuses: (typeof DepositStatuses)[number];
    /**
     * EvenShotPropResponse
     * @description Response for price
     */
    EvenShotPropResponse: {
      /**
       * the proposition the even shot bet is on
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      proposition_id?: string;
      /**
       * The name of the runner
       * @example Dave
       */
      runner_name?: string;
      /**
       * The runner number for the option
       * @example 1
       */
      runner_number?: number;
      /**
       * The barrier number for the option
       * @example 1
       */
      barrier_number?: number;
      /**
       * The number of places the prop pays to (when it's a place prop)
       * @example 3
       */
      number_of_places?: number;
      /**
       * The price for the even-shot. Always 2
       * @default 2
       * @example 2
       */
      price?: number;
    };
    /**
     * EventFrequencies
     * @description An enumeration.
     * @enum {integer}
     */
    EventFrequencies: (typeof EventFrequencies)[number];
    /**
     * EventSupportedSortColumns
     * @description Manages the columns that our Event query util can sort by - critical that these columns match the event columns
     * @enum {string}
     */
    EventSupportedSortColumns: (typeof EventSupportedSortColumns)[number];
    /**
     * EventTypes
     * @description Manages the types of event that we support
     * @enum {string}
     */
    EventTypes: (typeof EventTypes)[number];
    /** ExoticBetDividends */
    ExoticBetDividends: {
      /** Dividends */
      dividends: components['schemas']['BetComboDividend'][];
    };
    /**
     * ExoticCombo
     * @description An exotic combo selection
     */
    ExoticCombo: {
      /**
       * Race runner (horse/greyhound/trots) number
       * @example 3
       */
      runner_number: number;
      /**
       * Race runner (horse/greyhound/trots) name
       * @example Winx
       */
      runner_name: string;
    };
    /** ExoticResult */
    ExoticResult: {
      type: components['schemas']['BetSubType'];
      /** Selection */
      selection: number[];
      /** Dividend */
      dividend: number;
    };
    /**
     * ExoticSelection
     * @description Selection of Exotic Combos
     * Example: represents multiple runners you are selecting for first
     *          a second ExoticSelection would select runner for second
     * So an Exacta or Quinella would have a list of 2 ExoticSelections,
     * a trifecta would have 3 list elements and FirstFour would have 4
     */
    ExoticSelection: {
      /** List of Exotic combo selections */
      exotic_combos: components['schemas']['ExoticCombo'][];
    };
    /** FPTPProtestOverride */
    FPTPProtestOverride: {
      /**
       * Id of the subject race.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      race_id?: string;
      /**
       * When set True disables First Past The Post Race Win Market PROTEST handling no backsies behaviour.
       * @default false
       * @example true
       */
      override?: boolean;
    };
    /** FZSCAData */
    FZSCAData: {
      /** Aav */
      aav?: string;
      /** Cavv */
      cavv?: string;
      /** Par */
      par?: string;
      /** Sli */
      sli?: string;
      /** Xid */
      xid?: string;
      /** Ver */
      ver?: string;
      /** Ucaf */
      ucaf?: string;
      /** Directoryservertxnid */
      directoryServerTxnId?: string;
      /** Threedsversion */
      threedsVersion?: string;
    };
    /** FZSCASuccess */
    FZSCASuccess: {
      /** Message */
      message: string;
      /** Errors */
      errors?: string[];
      data: components['schemas']['FZSCAData'];
    };
    /** FatZebraOauthTokenResponse */
    FatZebraOauthTokenResponse: {
      /**
       * The message response from fat zebra.
       * @example created
       */
      message: string;
      /**
       * Data response from fat zebra.
       * @example xxx
       */
      token: string;
    };
    /**
     * FlagFilterOption
     * @description An enumeration.
     * @enum {string}
     */
    FlagFilterOption: (typeof FlagFilterOption)[number];
    /** FlagInfo */
    FlagInfo: {
      /**
       * The ID of the punter subject to add/delete of a flag
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * The label applied by the bookie
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      label: string;
      /**
       * The hex value for the assigned label colour if such exists
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      colour?: string;
    };
    /** ForcePriceTypeApprovalPayload */
    ForcePriceTypeApprovalPayload: {
      /**
       * the id of the race to force all bets to approval for
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      race_id: string;
      /**
       * Price Type to force bets to approval for
       * @example [
       *   "tote_single_mid"
       * ]
       */
      price_types: components['schemas']['PriceType'][];
    };
    /** ForsportMatch */
    ForsportMatch: {
      /**
       * match id
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      matchId?: string;
      /**
       * match name
       * @example Western Sydney Wanderers vs Adelaide United FC
       */
      matchName?: string;
      /**
       * competition id
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      competitionId?: string;
      /**
       * competition name
       * @example Australia: FFA Cup 2023
       */
      competitionName?: string;
      /**
       * Kick off time (UTC)
       * @example 2021-11-29T06:00:35
       */
      kickoffTime?: string;
      /** odds */
      odds?: components['schemas']['ForsportOdds'][];
    };
    /** ForsportOdds */
    ForsportOdds: {
      /**
       * team name
       * @example Western Sydney Wanderers
       */
      teamName?: string;
      /**
       * URL
       * @example https://deeplink/to/odds
       */
      url?: string;
      /**
       * return
       * @example 2.50
       */
      price?: number;
    };
    /** ForsportOddsResponse */
    ForsportOddsResponse: {
      /** match */
      results?: components['schemas']['ForsportMatch'][];
    };
    /** FullPunter */
    FullPunter: {
      /**
       * The users ID in our database
       * Format: uuid
       */
      punter_id: string;
      /** The users Firebase UID */
      firebase_uid: string;
      /** If the user has finished onboarding, will return true */
      is_onboarded: boolean;
      /** If the user's identity has been verified, will return true */
      identity_verified: boolean;
      /**
       * The platform ID for this bookie
       * Format: uuid
       */
      platform_id: string;
      /** Sets the user's title, if included in request */
      title?: string;
      /** Sets the user's first name, if included in request */
      first_name?: string;
      /** Sets the user's last name, if included in request */
      last_name?: string;
      /** Sets the user's middle name, if included in request */
      middle_name?: string;
      /** Sets the user's email, if included in request */
      email?: string;
      /** Sets the user's first mobile number, if included in request */
      mobile?: string;
      /** Sets the user's street number, if included in request */
      street_number?: string;
      /** Sets the user's street name, if included in request */
      street_name?: string;
      /** Sets the user's suburb, if included in request */
      suburb?: string;
      /** Sets the user's state, if included in request */
      state?: string;
      /** Sets the user's post code, if included in request */
      post_code?: string;
      /** Punters date of birth DD-MM-YYYY */
      date_of_birth?: string;
      /** Punter has enabled email marketing */
      email_marketing_enabled: boolean;
      /** Punter has enabled SMS marketing */
      sms_marketing_enabled: boolean;
      /** Punter has enabled phone marketing */
      phone_marketing_enabled: boolean;
      /** Punter has enabled post marketing */
      post_marketing_enabled: boolean;
      /** Punter's category uuid. The name and value used are intentionally chosen not to be obvious. */
      pc?: string;
    };
    /** Gameplay */
    Gameplay: {
      /**
       * Name of the game that should be launched
       * @example spin-wheel
       */
      game: string;
      /** Variables to be passed to the game */
      variables: Record<string, never>;
    };
    /**
     * GeneralStatus
     * @description An enumeration.
     * @enum {string}
     */
    GeneralStatus: (typeof GeneralStatus)[number];
    /** GenerateZohoTokenResponse */
    GenerateZohoTokenResponse: {
      /** token */
      token: string;
    };
    /** GenericWithdrawalsSchema */
    GenericWithdrawalsSchema: {
      /**
       * the id of the withdrawal
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      withdrawal_id: string;
      /**
       * The sequence primary id of the withdrawal
       * @example 123
       */
      request_id: number;
      /**
       * The Type of transaction
       * @default Withdrawal
       * @example Withdrawal
       */
      transaction_type?: components['schemas']['TransactionTypes'];
      /**
       * The punters id,
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * The punters full name,
       * @example John Doe
       */
      punter_name: string;
      /**
       * The name of the bookie.
       * @example John Doe
       */
      bookie_name: string;
      /**
       * When was the record created
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      created_at: string;
      /**
       * How much the withdrawal request was for.
       * @example 1000
       */
      amount: number;
      /**
       * The status of the withdrawal.
       * @example Pending
       */
      status: components['schemas']['WithdrawalStatus'];
      /**
       * The method of transaction
       * @default Bank Transfer
       * @example Bank Transfer
       */
      method?: string;
      /**
       * When was the withdrawal request completed
       * Format: date-time
       * @example 2023-10-24
       */
      completed_at?: string;
      /**
       * If the request has been exported all ready.
       * @example true
       */
      exported: boolean;
      /**
       * Bookie Category
       * @example Newbie
       */
      category?: string;
      /**
       * List of Punters flags.
       * @example PunterFlag
       */
      flags?: components['schemas']['PunterFlag'][];
    };
    /** GlobalCompetitionModifier */
    GlobalCompetitionModifier: {
      /**
       * The competition ID in our database
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      competition_id: string;
      /**
       * The display name of the competition
       * @example The Ashes
       */
      display_name: string;
      /**
       * The summed total modifier which applies to this item, to be displayed to the user
       * @example -3
       */
      display_modifier: number;
      /**
       * The modifier for this specific item
       * @example 2
       */
      modifier: number;
    };
    /** GlobalExposureLimitsSchema */
    GlobalExposureLimitsSchema: {
      /**
       * Threshold that clips payout enforced at time of payout in cents
       * @example 999999
       */
      bet_exotics_payout_cap?: number;
      /**
       * Every race Exotics market has this limit applied to it on the incremental addition to exposure of a single bet in cents
       * @example 999999
       */
      race_exotics_market_exposure_manual_approval_limit?: number;
      /**
       * Every race win market has this limit applied to it on the incremental addition to exposure of a single bet in cents
       * @example 999999
       */
      race_win_market_exposure_manual_approval_limit?: number;
      /**
       * Every race place market has this limit applied to it on the incremental addition to exposure of a single bet in cents
       * @example 999999
       */
      race_place_market_exposure_manual_approval_limit?: number;
      /**
       * Every sport win market has this limit applied to on the incremental addition to exposure of a single bet in cents
       * @example 999999
       */
      sport_win_market_exposure_manual_approval_limit?: number;
      /**
       * Exposure limit applied per bet of SGM
       * @example 999999
       */
      sgm_per_bet_exposure_manual_approval_limit?: number;
      /**
       * Exposure limit applied per bet of SRM
       * @example 999999
       */
      srm_per_bet_exposure_manual_approval_limit?: number;
      /**
       * Exposure limit applied per bet of Blended
       * @example 999999
       */
      blended_per_bet_exposure_manual_approval_limit?: number;
    };
    /** GlobalMarginModifierInput */
    GlobalMarginModifierInput: {
      /**
       * The global margin to be set
       * @example 1
       */
      modifier: number;
    };
    /** GlobalRaceTypeModifier */
    GlobalRaceTypeModifier: {
      /**
       * The race type
       * @example Horse Racing
       */
      race_type: components['schemas']['RaceTypes'];
      /**
       * The summed total modifier which applies to this item, to be displayed to the user
       * @example -3
       */
      display_modifier: number;
      /**
       * The modifier for this specific item
       * @example 2
       */
      modifier: number;
      /** Modified Venues */
      modified_venues: components['schemas']['GlobalVenueModifier'][];
    };
    /** GlobalSportModifier */
    GlobalSportModifier: {
      /**
       * The sport ID in our database
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      sport_id: string;
      /**
       * The display name of the sport
       * @example Cricket
       */
      display_name: string;
      /**
       * The summed total modifier which applies to this item, to be displayed to the user
       * @example -3
       */
      display_modifier: number;
      /**
       * The modifier for this specific item
       * @example 2
       */
      modifier: number;
      /** Modified Competitions */
      modified_competitions: components['schemas']['GlobalCompetitionModifier'][];
    };
    /** GlobalVenueModifier */
    GlobalVenueModifier: {
      /**
       * The venue ID in our database
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      venue_id: string;
      /**
       * The display name of the venue
       * @example Sandown
       */
      display_name: string;
      /**
       * The summed total modifier which applies to this item, to be displayed to the user
       * @example -3
       */
      display_modifier: number;
      /**
       * The modifier for this specific item
       * @example 2
       */
      modifier: number;
    };
    /** GreenIDVerificationSchema */
    GreenIDVerificationSchema: {
      /**
       * The verification Id from greenID
       * @example I9djgLPj
       */
      verification_id?: string;
      /**
       * The current verification status from greenID
       * @example IN_PROGRESS
       */
      verification_status?: string;
      /**
       * The greenId verification token
       * @example 9abae7992b2a4a1392c7b213707c74f89810800f
       */
      verification_token?: string;
      /**
       * Whether the identity has been verified successfully
       * @default false
       * @example true
       */
      identity_verified?: boolean;
    };
    /**
     * LegacyPunterStatus
     * @description An enumeration.
     * @enum {string}
     */
    LegacyPunterStatus: (typeof LegacyPunterStatus)[number];
    /** LockPriceInput */
    LockPriceInput: {
      /**
       * the id of the race to lock price
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      race_id: string;
      /**
       * If the prices are locked
       * @example false
       */
      lock_price: boolean;
    };
    /** MarketGroupListObject */
    MarketGroupListObject: {
      /**
       * The id of the market group.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      market_group_id: string;
      /**
       * The match id  of the market group.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      match_id: string;
      /**
       * The title of the market group.
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      name: string;
      /**
       * The bet option of the market group
       * @example [
       *   "1"
       * ]
       */
      bet_options?: string[];
      /**
       * The updated time of the market group
       * Format: date-time
       */
      updated_at?: string;
      /**
       * The sort order of the market group
       * @example 0
       */
      sort_order?: number;
      /**
       * The market group is manually created or not
       * @example true
       */
      is_manual?: boolean;
    };
    /** MarketGroupMarketListObject */
    MarketGroupMarketListObject: {
      /**
       * The id of the market group.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      market_group_id: string;
      /**
       * The title of the market group.
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      name: string;
      /**
       * The market group is manually created or not
       * @example true
       */
      is_manual?: boolean;
    };
    /** MarketGroupsPunterSchema */
    MarketGroupsPunterSchema: {
      /**
       * Market Group Id
       * Format: uuid
       */
      market_group_id: string;
      /**
       * The name of the market group
       * @example Popular
       */
      name: string;
      /**
       * Bet options in the market group
       * @example [
       *   "1.2",
       *   "1.3"
       * ]
       */
      bet_options: string[];
    };
    /** MarketGroupsSchema */
    MarketGroupsSchema: {
      /**
       * The UUID of the market group
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      market_group_id?: string;
      /**
       * Bet options in the market group
       * @example [
       *   "1.2",
       *   "1.3"
       * ]
       */
      market_group_title: string;
    };
    /** MarketListObject */
    MarketListObject: {
      /**
       * The id of the market.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      market_id: string;
      /**
       * The title of the market.
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      name: string;
      /**
       * The type of the market
       * @example example
       */
      market_type?: string;
      /**
       * The updated time of the market
       * Format: date-time
       */
      updated_at?: string;
      /** The bet_option_priority of the market */
      bet_option_priority?: string;
      /** The bet_option_spectrum_id of the market */
      bet_option_spectrum_id?: string;
      /**
       * the status of the market
       * @example Open
       */
      status?: components['schemas']['GeneralStatus'];
      /**
       * The market is manually created or not
       * @example true
       */
      is_manual?: boolean;
      match: components['schemas']['MatchListObject'];
      /** Propositions */
      propositions?: components['schemas']['PropositionListObject'][];
    };
    /** MarketMarginResponse */
    MarketMarginResponse: {
      /**
       * The id of the market updated.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      market_id: string;
      /**
       * The amount of ticks the margin is being increased by.
       * @example 1
       */
      modifier: number;
    };
    /**
     * MarketMoverTypes
     * @description Manages the types of market movers that we support
     * @enum {string}
     */
    MarketMoverTypes: (typeof MarketMoverTypes)[number];
    /** MarketPropositionListObject */
    MarketPropositionListObject: {
      /**
       * The id of the market.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      market_id: string;
      /**
       * The title of the market.
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      name: string;
      /**
       * The type of the market
       * @example example
       */
      market_type?: string;
      /**
       * The market is manually created or not
       * @example true
       */
      is_manual?: boolean;
      /** The Market Group objects */
      propositions?: components['schemas']['PropositionObject'][];
    };
    /** MarketResponse */
    MarketResponse: {
      /**
       * Race name for win or place, or Market parent of the associated proposition
       * @example ('SWINDON A6',) place
       */
      market_name: string;
      /**
       * the type of market
       * @example Racing Place
       */
      market_type: string;
      /**
       * the id of the market.
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      market_id: string;
      /**
       * If the market is suspended or not
       * @example false
       */
      market_is_suspended?: boolean;
      /**
       * If all propositions of the market are suspended or not
       * @example false
       */
      is_suspended?: boolean;
      /**
       * If the market is manually closed or not
       * @example false
       */
      lock_status?: boolean;
      /**
       * If the market price is manually locked or not
       * @example false
       */
      lock_price?: boolean;
      /**
       * The status of the market
       * @example Open
       */
      status?: components['schemas']['GeneralStatus'];
      /**
       * If the market is manually created or not
       * @example false
       */
      is_manual?: boolean;
      /**
       * If the market is ignored from winter settlement or not
       * @example false
       */
      ignore_winter_settlement?: boolean;
      /**
       * Available price types
       * @example [
       *   "fixed"
       * ]
       */
      price_types?: components['schemas']['PriceType'][];
      /**
       * Market Level information used in FE display
       * @example {"metric": null, "value1": null, "value2": null, "team": null, "team_role": null, "player": null, "event_part": null, "discriminator": null}
       */
      market_info?: Record<string, never>;
    };
    /** MarketSchema */
    MarketSchema: {
      /**
       * The UUID for the market
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      market_id?: string;
      /**
       * Race name for win or place, or Market parent of the associated proposition
       * @example TST Eng 2nd Inns 19/12
       */
      market_name?: string;
      /**
       * Disclaimer supplemental to Market Name
       * @example Includes extra time.
       */
      disclaimer?: string;
      /**
       * The bet option of the market
       * @example
       */
      bet_option?: string;
      /**
       * Sort order for the bet option of the market
       * @example
       */
      bet_option_sort_order?: number;
      /**
       * The short type of the market
       * @example
       */
      market_type?: string;
      /**
       * The status of the market
       * @example Voided
       */
      status?: components['schemas']['GeneralStatus'];
      /**
       * Whether the market is suspended
       * @example false
       */
      is_suspended?: boolean;
      /** Propositions */
      propositions?: components['schemas']['PropositionSchema'][];
      /**
       * Available price types for the market
       * @example [
       *   "fixed"
       * ]
       */
      price_types?: components['schemas']['PriceType'][];
      /**
       * Market Level information used in FE display
       * @example {"metric": null, "value1": null, "value2": null, "team": null, "team_role": null, "player": null, "event_part": null, "discriminator": null}
       */
      market_info?: Record<string, never>;
    };
    /** MarketToVoid */
    MarketToVoid: {
      /**
       * The ID of the market being voided.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      market_id: string;
    };
    /** MarketingSchema */
    MarketingSchema: {
      /**
       * flag to enable email marketing
       * @default false
       * @example false
       */
      email_marketing_enabled?: boolean;
      /**
       * flag to enable sms marketing
       * @default false
       * @example false
       */
      sms_marketing_enabled?: boolean;
    };
    /** MatchListObject */
    MatchListObject: {
      /**
       * The id of the match.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      match_id: string;
      /**
       * The competition id of the match.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      competition_id: string;
      /**
       * The sport id of the match.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      tournament_id?: string;
      /**
       * The name of the match
       * @example example
       */
      name: string;
      /**
       * The updated time of the match
       * Format: date-time
       */
      updated_at?: string;
      /**
       * the start time of the match
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      start_time?: string;
      /**
       * The status of the match
       * @example Open
       */
      status?: components['schemas']['GeneralStatus'];
      /**
       * The match is manually created or not
       * @example true
       */
      is_manual?: boolean;
    };
    /** MatchMarketListObject */
    MatchMarketListObject: {
      /**
       * The id of the match.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      match_id: string;
      /**
       * The name of the match
       * @example example
       */
      name: string;
      /**
       * the start time of the match
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      start_time?: string;
      /**
       * The match is manually created or not
       * @example true
       */
      is_manual?: boolean;
      /** The Market Group objects */
      market_groups?: components['schemas']['MarketGroupMarketListObject'][];
      /** The Match object */
      market: components['schemas']['MarketPropositionListObject'];
    };
    /** MatchSettingsDTO */
    MatchSettingsDTO: {
      cashout_offered?: boolean;
      /**
       * Whether to disable the SGM on a match.
       * @example true
       */
      sgm_disabled?: boolean;
      /**
       * Whether to intercept all the SGM bets for a match.
       * @example true
       */
      sgm_intercept_all?: boolean;
      /**
       * Whether to offer cashout on this match or not
       * @example true
       */
      cashout_offered?: boolean;
    };
    /** MatchStats */
    MatchStats: {
      /**
       * The total number of bets on this event
       * @example 2
       */
      total_bets: number;
      /**
       * The total money staked across all bets on this event in cents
       * @example 15000
       */
      turnover: number;
      /**
       * The calculated exposure for this event in cents
       * @example 1000
       */
      exposure: number;
      /**
       * Player Type Distribution
       * @default []
       */
      player_type_distribution?: components['schemas']['PlayerTypeStats'][];
      /**
       * The total money staked across multi bets on this event in cents
       * @example 1700
       */
      multi_turnover: number;
      /**
       * The total number of SGM bets on this event
       * @example 5
       */
      sgm_total_bets: number;
      /**
       * The total money staked across SGM bets on this event in cents
       * @example 1500
       */
      sgm_turnover: number;
    };
    /** MatchToVoid */
    MatchToVoid: {
      /**
       * The ID of the match being voided.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      match_id: string;
    };
    /** MatchView */
    MatchView: {
      /**
       * The UUID of the market
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      market_id: string;
      /**
       * Market parent of the associated proposition
       * @example TST Eng 2nd Inns 19/12
       */
      market_name: string;
      /**
       * Disclaimer supplemental to Market Name
       * @example Includes extra time.
       */
      disclaimer?: string;
      /**
       * The type of market
       * @example First Scorer
       */
      market_type?: string;
      /**
       * count of all propositions on market.
       * @example 1
       */
      propositions_count?: number;
      modifiers: components['schemas']['ModifierSchema'];
      /**
       * The status of the match.
       * @example Abandoned
       */
      status: components['schemas']['GeneralStatus'];
      /**
       * If the market status is locked or not
       * @example false
       */
      lock_status?: boolean;
      /**
       * exposure of (payout for) this market
       * @example 46800
       */
      exposure: number;
      /**
       * If the object is suspended
       * @example false
       */
      is_suspended: boolean;
      /**
       * If the object is ignoring from winter settlement
       * @example false
       */
      ignore_winter_settlement?: boolean;
      /**
       * If the market is manually created or not
       * @example false
       */
      is_manual?: boolean;
    };
    /** ModifierInput */
    ModifierInput: {
      /**
       * The ID of the object to update.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      id: string;
      /** The amount of ticks to increase the margin by. */
      modifier: number;
    };
    /** ModifierResponse */
    ModifierResponse: {
      /**
       * The ID of the object updated.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      id: string;
      /**
       * The modifier in the database.
       * @example 1
       */
      modifier: number;
    };
    /**
     * ModifierSchema
     * @description Used to represent the state of a modifier in the Bookie platform
     */
    ModifierSchema: {
      /**
       * the modifier to display to the bookie
       * @default 0
       * @example 100
       */
      display_modifier?: number;
      /**
       * The modifier for that individual level object. IE. Race +1 Ticks
       * @example 1
       */
      modifier?: number;
    };
    /** MultiLegSchema */
    MultiLegSchema: {
      /**
       * The unique ID of this leg
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      bet_leg_id?: string;
      /**
       * The unique ID of the event (Race or Match)
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      event_id: string;
      /**
       * For sports this will be the market type, for races it will be the bet type
       * @example Win (Fixed)
       */
      bet_description: string;
      /**
       * The jump/start time of the event in UTC
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      event_start: string;
      /**
       * The type of event, either a Race or Match
       * @example Race
       */
      event_type: components['schemas']['EventTypes'];
      /**
       * The Sport name or race type for an event to support icons
       * @example Harness Racing
       */
      event_icon: string;
      /**
       * The locked in return odds for this bet leg
       * @example 2
       */
      odds?: number;
      /**
       * True if the bet was won, None if the bet leg is not resulted yet
       * @example false
       */
      is_won?: boolean;
      /**
       * Represents the current state for the Bet leg
       * @example settled
       */
      status?: components['schemas']['BetStatuses'];
      /**
       * The total amount in cents deducted from this bet
       * @example 50
       */
      deduction?: number;
      /** The data for the event that this bet leg is on */
      event_data:
        | components['schemas']['BetRaceData']
        | components['schemas']['BetMatchData'];
      /**
       * The Odds modifier, None if no modification
       * @example -2
       */
      modifier?: number;
      /**
       * Price type of the leg
       * @example fixed
       */
      price_type?: components['schemas']['PriceType'];
    };
    /** MultiViewBetSchema */
    MultiViewBetSchema: {
      /**
       * The unique ID of this bet
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      bet_id: string;
      /**
       * The date and time in UTC this bet was placed
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      created_at: string;
      /**
       * The amount wagered on the bet in cents
       * @example 1000
       */
      stake: number;
      /**
       * The locked in return odds for this bet. Product of each leg's odds
       * @example 25
       */
      odds: number;
      /**
       * Unset until all legs are resulted. True if all non-voided legs won, False otherwise
       * @example false
       */
      is_won?: boolean;
      /**
       * True if the bet was placed with bonus balance
       * @example true
       */
      is_bonus: boolean;
      /**
       * Represents the current state for the Bet
       * @example settled
       */
      status: components['schemas']['BetStatuses'];
      /**
       * Product of stake and each won leg's odds
       * @example 25000
       */
      current_stake_value: number;
      /**
       * Represents the amount that has been paid out to the punter
       * @example 100
       */
      payout?: number;
      /** A list of the details of each leg in this multi bet */
      bet_legs: components['schemas']['MultiLegSchema'][];
      /**
       * The punter's id
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * The full name of the punter preformatted to '<first_name> <last_name>'
       * @example Rob Banks
       */
      punter_name: string;
      /**
       * Punter category generated by Storm and/or Bookie
       * @example Newbie
       */
      punter_category: string;
    };
    /** NewBank */
    NewBank: {
      /**
       * The holder of the bank.
       * @example Johnny Depp
       */
      account_name: string;
      /**
       * The BSB of the bank account
       * @example 123456
       */
      bsb: string;
      /**
       * The name of the bank account
       * @example 123456
       */
      account_nick_name?: string;
      /**
       * The account number of the bank account
       * @example 123456
       */
      account_number: string;
      /**
       * The name of the bank (optional field)
       * @example ING
       */
      bank_name?: string;
      /**
       * Id of the platform
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      platform_id?: string;
    };
    /** NewPunterNote */
    NewPunterNote: {
      /** the UUID of a punter */
      punter_id: string;
      /** the type of note being comitted */
      note_type: string;
      /** the text of the note */
      text: string;
    };
    /**
     * NextRaceObject
     * @description A simple race object, for displaying the next to jump races
     */
    NextRaceObject: {
      /**
       * The race's id
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      race_id: string;
      /**
       * The name of the race's venue
       * @example Greyhound Race 1
       */
      venue_name: string;
      /**
       * The country the venue is in
       * @example Australia
       */
      venue_country: string;
      /**
       * The start time of the race in UTC timezone
       * Format: date-time
       */
      start_time: string;
      /**
       * The number of the race
       * @example 7
       */
      race_number: number;
      /**
       * The type of race
       * @example Greyhounds
       */
      race_type: components['schemas']['RaceTypes'];
      /**
       * Whens the race going to take place.
       * Format: date
       * @example 2022-02-07
       */
      meeting_date?: string;
      /**
       * Race venue id
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      venue_id: string;
      /**
       * The status of the race.
       * @example Abandoned
       */
      status: components['schemas']['GeneralStatus'];
    };
    /**
     * NextToJumpMatches
     * @description This schema is inherited by any schema that returns a paginated response from an endpoint.
     */
    NextToJumpMatches: {
      /**
       * The total number of pages that exist for the query
       * @example 1
       */
      total_pages: number;
      /**
       * The total number of records that could be returned (from all pages)
       * @example 18
       */
      total_records: number;
      /**
       * Matches
       * @default []
       */
      matches?: components['schemas']['api__meta__schemas__punter_schemas__MatchSchema'][];
    };
    /** NoteSchema */
    NoteSchema: {
      /**
       * The ID of the Note
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      note_id: string;
      /**
       * The ID of the punter that the note is associated with
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * The ID of the bookie who created the note
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      bookie_id: string;
      /**
       * The name of the bookie who created the note
       * @example Farrokh Bulsara
       */
      bookie_name?: string;
      /**
       * The text content of the note
       * Format: date-time
       * @example This is an example note
       */
      created_at?: string;
      /**
       * The text content of the note
       * @example This is an example note
       */
      text?: string;
      /**
       * The type of note
       * @example General
       */
      note_type: components['schemas']['NoteTypes'];
      /** A list of the note's attachments */
      attachments: components['schemas']['AttachmentSchema'][];
    };
    /**
     * NoteTypes
     * @description An enumeration.
     * @enum {string}
     */
    NoteTypes: (typeof NoteTypes)[number];
    /** OfferedSport */
    OfferedSport: {
      /**
       * The UUID of the sport
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      sport_id: string;
      /**
       * The name of the sport
       * @example AFL Football
       */
      display_name: string;
    };
    /** Offerings */
    Offerings: {
      /**
       * Whether starting price is enabled for the system
       * @example true
       */
      starting_price?: boolean;
      /**
       * Whether SGM is enabled for the bookie
       * @example true
       */
      sgm?: boolean;
      /**
       * Whether tote single is enabled for the system
       * @example true
       */
      tote_single?: boolean;
      /**
       * Whether Blended is enabled for the bookie
       * @example true
       */
      blended?: boolean;
      /**
       * Whether even shot is enabled for the system
       * @example true
       */
      even_shot?: boolean;
    };
    /** OtherRacesRow */
    OtherRacesRow: {
      /**
       * Race Id
       * Format: uuid
       */
      race_id: string;
      /** Race Number */
      race_number: number;
      /**
       * Meeting Date
       * Format: date
       */
      meeting_date: string;
    };
    /** Overview */
    Overview: {
      /** Punter Name */
      punter_name: string;
      /** Account Number */
      account_number: string;
      /** Account Balance */
      account_balance: number;
      /** Available Balance */
      available_balance: number;
      /** Bonus */
      bonus: number;
      /** Power Plays */
      power_plays: number;
      /** Spins */
      spins: number;
      /** Bets */
      bets: number;
      /** Is Onboarded */
      is_onboarded: boolean;
      status: components['schemas']['LegacyPunterStatus'];
      /**
       * Self Exclusion Expiry
       * Format: date-time
       */
      self_exclusion_expiry?: string;
      /** Kyc Document Submitted */
      kyc_document_submitted?: boolean;
      /**
       * Whether the punter identity has been verified
       * @default false
       * @example true
       */
      identity_verified?: boolean;
    };
    /**
     * PagingSchema
     * @description This schema is inherited by any schema that returns a paginated response from an endpoint.
     */
    PagingSchema: {
      /**
       * The total number of pages that exist for the query
       * @example 1
       */
      total_pages: number;
      /**
       * The total number of records that could be returned (from all pages)
       * @example 18
       */
      total_records: number;
    };
    /** PayInput */
    PayInput: {
      /**
       * Id of the card to use for the payment
       * Format: uuid
       * @description Id of the card to use for the payment
       */
      card_id?: string;
      /**
       * Card token
       * @description Card token in absense of card_id
       */
      card_token?: string;
      /**
       * Amount to pay
       * @description Amount to pay
       */
      amount: number;
      /**
       * 3DS validation data
       * @description 3DS validation data
       */
      extra_data?: components['schemas']['FZSCAData'];
      /**
       * The id of the deposit in our database.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      deposit_id: string;
      /** JSON object returned by FZ's library in the front end */
      details: components['schemas']['FZSCASuccess'];
    };
    /** PayResponse */
    PayResponse: {
      /**
       * Message from the payment gateway
       * @description Message from the payment gateway
       */
      message: string;
      /**
       * Is the deposit first deposit?
       * @example true
       */
      is_first_deposit?: boolean;
    };
    /** Permission */
    Permission: {
      /** permission being updated */
      permission: string;
      /** list of roles that have the permission */
      roles: string[];
    };
    /** PlatformContact */
    PlatformContact: {
      /**
       * The phone number of the platform
       * @example 1800123456
       */
      phone_number?: string;
      /**
       * The international phone number of the platform
       * @example +61812123434
       */
      international_phone_number?: string;
      /**
       * The email address of the platform
       * @example support@ggbet.com.au
       */
      email?: string;
      /**
       * The address number in the street
       * @example 81-87
       */
      street_number?: string;
      /**
       * The name of the street
       * @example King William St
       */
      street_name?: string;
      /**
       * If suburb is recorded, include it
       * @example Fitzroy
       */
      suburb?: string;
      /**
       * If the state is recorded, include it
       * @example Vic
       */
      state?: string;
      /**
       * If the postcode is recorded, include it
       * @example 3065
       */
      post_code?: string;
    };
    /** PlatformOfferings */
    PlatformOfferings: {
      /** All of the offered sports */
      offered_sports?: components['schemas']['OfferedSport'][];
      /** A list of all offered race types */
      offered_race_types?: string[];
      /** Racing futures sport */
      offered_racing_futures?: components['schemas']['OfferedSport'];
    };
    /** PlayerTypeStats */
    PlayerTypeStats: {
      /**
       * The type of player who placed the bets
       * @example Newbie
       */
      player_type: components['schemas']['PunterCategories'];
      /**
       * The total money staked across all bets by this player type
       * @example 1500
       */
      player_turnover: number;
      /**
       * The number of players of this type who placed bets on this event
       * @example 20
       */
      player_count: number;
    };
    /**
     * PriceType
     * @description An enumeration.
     * @enum {string}
     */
    PriceType: (typeof PriceType)[number];
    /**
     * PrimerPaymentType
     * @description An enumeration.
     * @enum {string}
     */
    PrimerPaymentType: (typeof PrimerPaymentType)[number];
    /** PrivacyPolicy */
    PrivacyPolicy: {
      /** The privacy policy for the platfrom */
      privacy_policy: string;
    };
    /** PromoPunter */
    PromoPunter: {
      /**
       * Punter ID associated with the Storm data
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * Additional parameters for the specific promotion type
       * @example {"percentage": 0.75, "max_amount": 20000}
       */
      parameters: Record<string, never>;
    };
    /**
     * PromoSource
     * @description An enumeration.
     * @enum {string}
     */
    PromoSource: (typeof PromoSource)[number];
    /**
     * PromoStatus
     * @description An enumeration.
     * @enum {string}
     */
    PromoStatus: (typeof PromoStatus)[number];
    /** PromoSummaryResponse */
    PromoSummaryResponse: {
      /** Promotions */
      promotions: components['schemas']['PromoSummaryResponseItem'][];
      /**
       * Offset value to be used when requesting next page
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      offset?: string;
      paging?: {
        next_offset?: string;
      };
    };
    /** PromoSummaryResponseItem */
    PromoSummaryResponseItem: {
      /**
       * The unique ID of the promotion
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      promo_id: string;
      /**
       * The name of the promotion
       * @example Super Fun Promo 123
       */
      name: string;
      /**
       * The name of the csv file
       * @example promo1.csv
       */
      file_name: string;
      /**
       * The reason for the promotion.
       * @example They asked for it.
       */
      reason: string;
      /**
       * the number of punters included in the promotion
       * @example 2
       */
      total_punters: number;
      /**
       * The maximum value in bonus funds this promotion can award
       * @example 10000
       */
      max_value: number;
      /**
       * the number of punters who have claimed the promotion
       * @example 1
       */
      claimed_punters: number;
      /**
       * the amount of bonus that has been claimed
       * @example 5000
       */
      claimed_amount: number;
      /**
       * Date the promo was created
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      promotion_date: string;
      /**
       * The expiry time of the promotion
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      expiry?: string;
      start_time?: string;
      status?: string;
    };
    /**
     * PromoType
     * @description An enumeration.
     * @enum {string}
     */
    PromoType: (typeof PromoType)[number];
    /** PropositionListObject */
    PropositionListObject: {
      /**
       * The id of the proposition.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      proposition_id: string;
      /**
       * The market id of the proposition.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      market_id: string;
      /**
       * the name of the proposition
       * @example example
       */
      name: string;
      /**
       * the market type of the proposition
       * @example example
       */
      proposition_type?: string;
      /**
       * the max stake limit of the proposition
       * @example 100
       */
      max_stake_limit?: number;
      /**
       * the proposition allows multi or not
       * @example true
       */
      allow_multi?: boolean;
      /**
       * The odds of the proposition
       * @example 1.01
       */
      odds?: number;
      /**
       * The sort order of the proposition
       * @example 1
       */
      sort_order?: number;
      /**
       * the status of the proposition
       * @example Open
       */
      status?: components['schemas']['GeneralStatus'];
      /**
       * The updated time of the proposition
       * Format: date-time
       */
      updated_at?: string;
      /**
       * The proposition is manually created or not
       * @example true
       */
      is_manual?: boolean;
    };
    /** PropositionMarginResponse */
    PropositionMarginResponse: {
      /**
       * The id of the proposition to be updated
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      proposition_id: string;
      /**
       * The amount of ticks increased by.
       * @example 1
       */
      modifier: number;
    };
    /** PropositionObject */
    PropositionObject: {
      /**
       * The id of the proposition.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      proposition_id: string;
      /**
       * the name of the proposition
       * @example example
       */
      name: string;
      /**
       * the max stake limit of the proposition
       * @example 100
       */
      max_stake_limit?: number;
      /**
       * the proposition allows multi or not
       * @example true
       */
      allow_multi?: boolean;
      /**
       * The odds of the proposition
       * @example 1.01
       */
      odds?: number;
      /**
       * The proposition is manually created or not
       * @example true
       */
      is_manual?: boolean;
    };
    /**
     * PropositionOutcome
     * @description An enumeration.
     * @enum {string}
     */
    PropositionOutcome: (typeof PropositionOutcome)[number];
    /**
     * PropositionResult
     * @description An enumeration.
     * @enum {string}
     */
    PropositionResult: (typeof PropositionResult)[number];
    /**
     * PropositionSchema
     * @description Used to represent a particular proposition
     */
    PropositionSchema: {
      /**
       * The proposition ID in our database
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      proposition_id: string;
      /**
       * The name of the proposition
       * @example Novak
       */
      proposition_name: string;
      /**
       * The modified market odds for this proposition (deprecated)
       * @example 2.3
       */
      return_amount?: number;
      /**
       * The modified market odds for this proposition
       * @example 2.3
       */
      odds?: number;
      /**
       * The modified market odds for this proposition from winter
       * @example 1.1
       */
      winter_return_amount?: number;
      /**
       * The status of the proposition
       * @example Voided
       */
      status: components['schemas']['GeneralStatus'];
      /**
       * suspended status of proposition
       * @default false
       * @example true
       */
      is_suspended?: boolean;
      /**
       * suspended status of proposition on winter
       * @default false
       * @example true
       */
      winter_is_suspended?: boolean;
      /**
       * success or otherwise after settlement, can be one of WINNER|LOSER|TOP2|TOP3 depending on market type, None suggests indeterminate state
       * @example WINNER
       */
      outcome?: components['schemas']['PropositionOutcome'];
      /**
       * SGM availability.
       * @default false
       * @example true
       */
      sgm_available?: boolean;
      /**
       * SRM price if available.
       * @example SRM price for top1-4
       */
      srm_price?: components['schemas']['PropositionSrmPriceSchema'];
      /**
       * Available price types
       * @example [
       *   "fixed"
       * ]
       */
      price_types?: components['schemas']['PriceType'][];
      /**
       * the id of the market.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      market_id?: string;
      /**
       * Proposition Level information used in FE display
       * @example {"metric": null, "value1": null, "value2": null, "team": null, "team_role": null, "player": null, "event_part": null, "discriminator": null}
       */
      proposition_info?: Record<string, never>;
      /**
       * Sort Order precedence for displayed Propositions from a Market
       * @example 100
       */
      sort_order?: number;
      /**
       * The tote dividends for this proposition,
       * @example {
       *   "tote_single_mid": 4,
       *   "other_tote": 5
       * }
       */
      dividends?: {
        [key: string]: number | undefined;
      };
    };
    /**
     * PropositionSrmPriceSchema
     * @description Used to represent an SRM price
     */
    PropositionSrmPriceSchema: {
      /**
       * Win price
       * @example 2.3
       */
      top_1: number;
      /**
       * Top 2 price
       * @example 2.3
       */
      top_2: number;
      /**
       * Top 3 price
       * @example 2.3
       */
      top_3: number;
      /**
       * Top 3 price
       * @example 2.3
       */
      top_4: number;
    };
    /** PropositionToVoid */
    PropositionToVoid: {
      /**
       * The ID of the market being voided.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      proposition_id: string;
    };
    /**
     * PropositionTypes
     * @description Manages the types of Bet Propositions we support
     * @enum {string}
     */
    PropositionTypes: (typeof PropositionTypes)[number];
    /** PropsForMarket */
    PropsForMarket: {
      /** All the propositiosn on this market */
      propositions: components['schemas']['BookieProposition'][];
    };
    /** PunterAccountAdjustment */
    PunterAccountAdjustment: {
      /**
       * punter id
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * adjustment amount in cents (can be positive or negative)
       * @example 1000
       */
      amount: number;
      /**
       * reason for punter account adjustment
       * @example Resettlement
       */
      reason: string;
      /**
       * notes for punter account adjustment
       * @example Adjustment for incorrect winnings payment
       */
      note: string;
    };
    /** PunterAccountBetSchema */
    PunterAccountBetSchema: {
      /**
       * The UUID of the bet
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      bet_id: string;
      /**
       * The UUID of the bet's proposition
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      proposition_id: string;
      /**
       * The UUID of the punter that placed the bet
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      bet_punter_id: string;
      /**
       * The full name of the punter preformatted to '<first_name> <last_name>'
       * @example Rob Banks
       */
      bet_punter_name: string;
      /**
       * The type of punter that placed the bet, from Newbie to High Roller
       * @example High Roller
       */
      bet_punter_status: components['schemas']['PunterCategories'];
      /**
       * The odds of the bet that were recorded when the bet was cast
       * @example 20
       */
      bet_odds?: number;
      /**
       * The amount of money that the punter has bet
       * @example 420000
       */
      bet_stake: number;
      /**
       * Indicates whether or not it is a bonus bet
       * @example false
       */
      is_bonus_bet: boolean;
      /**
       * Current status of the bet (eg. pending, settled, voided, etc)
       * @example pending
       */
      bet_status: components['schemas']['BetStatuses'];
      /**
       * Whether the bet has been won
       * @example false
       */
      bet_won?: boolean;
      /**
       * The amount of money in cents the punter would receive if the bet wins (bet_odds * bet_stake)
       * @example 8400
       */
      potential_return: number;
      /**
       * The amount of money in cents the punter did receive. May be different to potential return due to deductions. Only populated for settled events
       * @example 8200
       */
      actual_return?: number;
      /**
       * The proposition of bet that was placed, either 'win' or 'place'
       * @example Win
       */
      proposition: components['schemas']['PropositionTypes'];
      /** List of exotic combo selections. Boxed exotics allow multiple selections for each place */
      exotic_selections?: components['schemas']['ExoticSelection'][];
      /**
       * Price type of the bet
       * @example fixed
       */
      price_type?: components['schemas']['PriceType'];
    };
    /** PunterBetRequestSchema */
    PunterBetRequestSchema: {
      /**
       * The id of the bet request
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      request_id: string;
      /**
       * The time that the bet was requested
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      created_at: string;
      /**
       * The odds that the punter has requested to bed
       * @example 2
       */
      requested_odds?: number;
      /**
       * The amount of money that the punter has requested to bet
       * @example 420000
       */
      requested_stake: number;
      /**
       * The status of the bet request
       * @example Pending
       */
      status: string;
      /**
       * The time that the bet request was last updated
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      actioned_at: string;
      /**
       * the id of the event in our database, race_id or match_id
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      event_id?: string;
      /**
       * The time that the event will start in UTC
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      event_start: string;
      /**
       * The current odds of the proposition
       * @example 1.1
       */
      proposition_odds?: number;
      /**
       * The odds approved for the bet
       * @example 1.1
       */
      approved_odds?: number;
      /**
       * The stake approved for the bet
       * @example 420000
       */
      approved_stake?: number;
      /**
       * The status of the bet
       * @example cashed_out
       */
      bet_status?: string;
      /** bet request selection */
      selection?: unknown;
      /** If this bet is a multi, this will contain a list of the legs */
      bet_legs?: components['schemas']['MultiLegSchema'][];
      /**
       * The price type the bet is being struck against
       * @example fixed
       */
      price_type?: components['schemas']['PriceType'];
      /** Details of promo tokens attached to the bet */
      promo_tokens: components['schemas']['BetTokenSchema'][];
    };
    /**
     * PunterBetRequestsPageSchema
     * @description This schema is inherited by any schema that returns a paginated response from an endpoint.
     */
    PunterBetRequestsPageSchema: {
      /**
       * The total number of pages that exist for the query
       * @example 1
       */
      total_pages: number;
      /**
       * The total number of records that could be returned (from all pages)
       * @example 18
       */
      total_records: number;
      /** The list of bet requests */
      records: components['schemas']['PunterBetRequestSchema'][];
    };
    /**
     * PunterBetSchema
     * @description This schema contains all bet data which would be displayed in both bookie & punter views
     */
    PunterBetSchema: {
      /**
       * The unique ID of this bet
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      bet_id: string;
      /**
       * The unique ID of the event (Race or Match)
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      event_id?: string;
      /**
       * For sports this will be the market type, for races it will be the bet type, for multi it will be empty
       * @example Win (Fixed)
       */
      bet_description: string;
      /**
       * The jump/start time of the event in UTC
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      event_start: string;
      /**
       * The date and time in UTC this bet was placed
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      created_at: string;
      /**
       * The type of event, either a Race or Match
       * @example Race
       */
      event_type?: components['schemas']['EventTypes'];
      /**
       * The Sport name or race type for an event to support icons
       * @example Harness Racing
       */
      event_icon?: string;
      /**
       * The stake/amount initially requested by punter in cents. Bookie may have reduced stake
       * @example 200
       */
      requested_stake: number;
      /**
       * The stake/amount wagered in the proposition in cents (after any stake reduction by Bookie)
       * @example 100
       */
      stake: number;
      /**
       * The odds of the bet
       * @example 1.5
       */
      odds?: number;
      /**
       * Whether the bet has been won
       * @example false
       */
      is_won?: boolean;
      /**
       * True if the bet was placed with bonus balance
       * @example true
       */
      is_bonus: boolean;
      /**
       * Represents the current state for the Bet
       * @example settled
       */
      status: components['schemas']['BetStatuses'];
      /**
       * The payout of the bet as a whole number
       * @example 5000
       */
      payout?: number;
      /** The data for the event that this bet is on */
      event_data?:
        | components['schemas']['BetRaceData']
        | components['schemas']['BetMatchData'];
      /** If this bet is a multi, this will contain a list of the legs */
      bet_legs?: components['schemas']['MultiLegSchema'][];
      /**
       * The price type the bet was struck against
       * @example fixed
       */
      price_type?: components['schemas']['PriceType'];
      /**
       * The total amount in cents deducted from this bet
       * @example 50
       */
      deduction?: number;
      /**
       * For a race, '<venue_name> - Race <race number>. For a Match is just match name
       * @example Sandown - Race 4
       */
      event_title?: string;
      /**
       * Runner name if a race, proposition name if a match
       * @example Geelong 40+
       */
      event_subtitle?: string;
      /**
       * The market name for this bet
       * @example AFW Gee-NMl
       */
      market_name?: string;
      /** exotic selections: [[1st place selections], [2nd place selections], ...] */
      exotic_selections?: components['schemas']['ExoticSelection'][];
      /**
       * Promotion info for the given bet
       * @example true
       */
      promos?: components['schemas']['BetTokenSchema'][];
    };
    /** PunterBetSupportSchema */
    PunterBetSupportSchema: {
      /** Racing */
      racing: boolean;
      /** Sport */
      sport: boolean;
      /** Multi */
      multi: boolean;
      /** Exotics */
      exotics: boolean;
      /** Sgmulti */
      sgmulti: boolean;
      /** Srmulti */
      srmulti: boolean;
      /** Quickbet */
      quickbet: boolean;
      /** Starting Price */
      starting_price: boolean;
      /** Tote Singles */
      tote_singles: boolean;
      /** Even Shot */
      even_shot: boolean;
    };
    /**
     * PunterCategories
     * @description Manages punter Storm categories
     * @enum {string}
     */
    PunterCategories: (typeof PunterCategories)[number];
    /** PunterFlag */
    PunterFlag: {
      /**
       * The ID of the bookie that assigned the flag
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      bookie_id: string;
      /**
       * The label applied by the bookie
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      label: string;
      /**
       * The hex value for the assigned label colour if such exists
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      colour?: string;
    };
    /**
     * PunterListObject
     * @description A simplified punter schema, for displaying punter data in the punters tab of the bookie platform
     */
    PunterListObject: {
      /**
       * The punter id
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * The full name of the punter
       * @example Robert Wilhelm
       */
      full_name?: string;
      /**
       * The location of a punter
       * @example VIC
       */
      state?: string;
      /**
       * The time that a punter joined in UTC
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      punter_joined: string;
      /**
       * Turnover is calculated as the sum of all stakes on bets placed by a punter
       * @example 56000
       */
      punter_turnover: number;
      /**
       * The stake of the punter's last bet
       * @example 4000
       */
      punter_lastbet?: number;
      /**
       * The last time the punter bet in UTC
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      punter_lastbetdate?: string;
      /**
       * The number of bets the punter has placed
       * @example 4
       */
      punter_numbets: number;
      /**
       * The average stake of the punter's bets, rounded to nearest cent
       * @example 5000
       */
      punter_avgbet: number;
      /**
       * The punter's BetCloud score
       * @example 1.1
       */
      punter_bcs: number;
      /**
       * The punter's career earnings/loss
       * @example 50000
       */
      punter_winnings: number;
      /**
       * The punter's classification from Newbie to High Roller
       * @example Newbie
       */
      punter_type: components['schemas']['PunterCategories'];
      /**
       * The punter's current balance
       * @example 50000
       */
      punter_balance: number;
      /**
       * The punter's current restricted balance
       * @example 50000
       */
      punter_restricted_balance: number;
      /**
       * Flags applied to the punter account by bookies
       * @default []
       * @example A list of PunterFlag - See definition
       */
      flags?: components['schemas']['PunterFlag'][];
      /** Whether the punter has been onboarded */
      punter_onboarded?: boolean;
    };
    /** PunterMatchMarketSchema */
    PunterMatchMarketSchema: {
      /**
       * The UUID for the market
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      market_id?: string;
      /**
       * Race name for win or place, or Market parent of the associated proposition
       * @example TST Eng 2nd Inns 19/12
       */
      market_name?: string;
      /**
       * Market type, to be used for display business logic
       * @example Home Draw Away
       */
      market_type?: string;
      /**
       * The status of the market
       * @example Voided
       */
      status?: components['schemas']['GeneralStatus'];
      /** Market Level information used in FE display */
      market_info?: Record<string, never>;
      /** Propositions */
      propositions?: components['schemas']['PunterMatchPropositionSchema'][];
    };
    /** PunterMatchPropositionSchema */
    PunterMatchPropositionSchema: {
      /**
       * The proposition ID in our database
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      proposition_id: string;
      /**
       * The name of the proposition
       * @example Novak
       */
      proposition_name: string;
      /**
       * The modified market odds for this proposition
       * @example 2.3
       */
      odds?: number;
      /**
       * The status of the proposition
       * @example Open
       */
      status: components['schemas']['GeneralStatus'];
      /**
       * suspended status of proposition
       * @default false
       * @example true
       */
      is_suspended?: boolean;
      /** Proposition Level information used in FE display */
      proposition_info?: Record<string, never>;
    };
    /** PunterMatchSchema */
    PunterMatchSchema: {
      /**
       * The id of the match
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      match_id: string;
      /**
       * The name of the race
       * @example Round 7: Collingwood vs Carlton
       */
      match_name: string;
      /**
       * The date and time that the match starts
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      match_start_time?: string;
      /**
       * The id of the match's sport
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      sport_id?: string;
      /**
       * The name of the match's sport
       * @example AFL
       */
      sport_name?: string;
      /**
       * The id of the match's competiton
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      competition_id?: string;
      /**
       * The name of the match's competiton
       * @example Australian Football League
       */
      competition_name?: string;
      /**
       * count of all the markets
       * @example 1
       */
      market_count?: number;
      /** Main Markets */
      main_markets?: components['schemas']['PunterMatchMarketSchema'][];
      /**
       * SGM availability.
       * @default false
       * @example true
       */
      sgm_available?: boolean;
      /** Match Level information used in FE display */
      match_info?: Record<string, never>;
    };
    /**
     * PunterPreferenceNames
     * @description Manages punter preferences
     * @enum {string}
     */
    PunterPreferenceNames: 'Default_Card';
    /** PunterPreferenceSchema */
    PunterPreferenceSchema: {
      /**
       * The name of preference to update
       * @example Default_Card
       */
      preference_name: components['schemas']['PunterPreferenceNames'];
      /**
       * The value of the preference to hold
       * @example xxxx-yyyy-ssss
       */
      preference_value?: string;
      /**
       * Is this preference enabled
       * @default true
       */
      enabled?: boolean;
    };
    /** PunterProfile */
    PunterProfile: {
      /**
       * The ID of the punter
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * If the user has a title, include it
       * @example Middle
       */
      title?: string;
      /**
       * If the user has a first name, include it
       * @example Farrokh
       */
      first_name?: string;
      /**
       * If the user has a last name, include it
       * @example Bulsara
       */
      last_name?: string;
      /**
       * If the user has a middle name, include it
       * @example Middle
       */
      middle_name?: string;
      /**
       * If the user has an email, include it
       * @example user@appnativ.com.au
       */
      email?: string;
      /**
       * If the user has a phone number, include it
       * @example 0432123456
       */
      phone_number?: string;
      /**
       * The address number in the street
       * @example 81-87
       */
      street_number?: string;
      /**
       * The name of the street
       * @example King William St
       */
      street_name?: string;
      /**
       * If suburb is recorded, include it
       * @example Fitzroy
       */
      suburb?: string;
      /**
       * If the state is recorded, include it
       * @example Vic
       */
      state?: string;
      /**
       * If the postcode is recorded, include it
       * @example 3065
       */
      post_code?: string;
      /**
       * If date of birth is recorded, include it
       * Format: date
       * @example 1991-01-01
       */
      dob?: string;
      /**
       * Whether or not the punter's ID has been successfully verified. Returns True if verified
       * @example true
       */
      verification_status: boolean;
      /**
       * Account Status
       * @example Open
       */
      account_status?: components['schemas']['PunterStatuses'];
      /**
       * Self exclusion period in days
       * @example 30
       */
      self_exclusion_days?: number;
      /**
       * Self exclusion expiry timestamp
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      self_exclusion_expiry?: string;
      /**
       * Bookie Category can be used to override Storm value. Note, this value is initialised to Newbie when Punter is created
       * @example Newbie
       */
      bookie_category: components['schemas']['PunterCategories'];
      /**
       * Storm generated category for Punter. Will be none until Storm has enough data to calculate value. Use bookie_category value if this is None
       * @example Sharp
       */
      storm_category?: components['schemas']['PunterCategories'];
      /**
       * Flag allowing Bookie to override Storm category (i.e. False). Note, if storm_category is None, use bookie_category regardless of this flag's value
       * @example true
       */
      use_storm_category: boolean;
      /**
       * Punter score calculated by Storm. Will be None until Storm has enough data.
       * @example 73.25
       */
      storm_score?: number;
      /**
       * Confidence level of Punter's Storm ranking. Will be None until score is calculated
       * @example Medium
       */
      storm_confidence?: components['schemas']['StormConfidence'];
      /**
       * Flags applied to the punter account by bookies
       * @default []
       * @example A list of PunterFlag - See definition
       */
      flags?: components['schemas']['PunterFlag'][];
      /** whether the customer has completed the onboarding process */
      is_onboarded?: boolean;
      /**
       * Date to follow up if any
       * Format: date
       * @example 1991-01-01
       */
      follow_up_at?: string;
      /**
       * Status Reason
       * @example None
       */
      status_reason?: components['schemas']['PunterStatusReasons'];
      /**
       * Punter Profile Sticky Note
       * @example Watch out for trouble here !
       */
      sticky_note?: components['schemas']['StickyNoteBaseSchema'];
      /**
       * Affiliate linked to customer Account
       * @example AFFILIATE_1
       */
      affiliate_code?: string;
      /**
       * Affiliate Token to customer Account
       * @example AFFILIATE_TOKEN_1
       */
      affiliate_token?: string;
      /** Whether the punter wants to be excluded from all phone calls */
      do_not_call?: boolean;
    };
    /** PunterPromoInput */
    PunterPromoInput: {
      /**
       * The name of the promotion
       * @example Saturday Deposit Match 123
       */
      name: string;
      /**
       * The reason why each of these promo are being given
       * @example Deposit Match
       */
      reason: string;
      /**
       * The type of promo
       * @example deposit_match
       */
      promo_type: components['schemas']['PromoType'];
      /**
       * The expiry time of the promotion
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      expiry?: string;
      /**
       * The unique ID of the punter
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * Additional parameters for the specific promotion type
       * @example {"percentage": 0.75, "max_amount": 20000}
       */
      parameters: Record<string, never>;
    };
    /** PunterPromoResponse */
    PunterPromoResponse: {
      /**
       * The unique ID of the promo
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      promo_id: string;
    };
    /** PunterPromotionsResponse */
    PunterPromotionsResponse: {
      /** Punter Promos */
      punter_promos: components['schemas']['PunterPromotionsResponseItem'][];
      /**
       * Offset value to be used when requesting next page
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      offset?: string;
    };
    /** PunterPromotionsResponseItem */
    PunterPromotionsResponseItem: {
      /**
       * Id of the promotion
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      promo_id: string;
      /**
       * Type of promotion
       * @example deposit_match
       */
      type: components['schemas']['PromoType'];
      /**
       * Name of the promotion
       * @example Super Awesome Promo 123
       */
      name: string;
      /**
       * The reason for the promotion.
       * @example They asked nicely
       */
      reason: string;
      /**
       * Date the promo was created
       * Format: date-time
       */
      promotion_date: string;
      /**
       * Current status of the promo for this punter
       * @example pending
       */
      status: components['schemas']['PromoStatus'];
      /**
       * The bonus amount awarded to the punter for this promotion
       * @example 100
       */
      bonus_amount?: number;
      /**
       * Extra parameters specific to the promo type
       * @example {"percentage": 0.75, "max_amount": 1000}
       */
      parameters?: Record<string, never>;
      /**
       * The expiry time of the promotion
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      expiry?: string;
      /**
       * The time/date the promotion was claimed
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      claimed_at?: string;
    };
    /** PunterRestrictionSchema */
    PunterRestrictionSchema: {
      /** Any promo restrictions apply to the punter */
      promos?: components['schemas']['BetTokenType'][];
      /** Any bet type restrictions apply to the punter */
      bet_type?: components['schemas']['BetType'][];
      /** Any racing restrictions apply to the punter */
      racing?: components['schemas']['RaceTypes'][];
      /** Any sport restrictions apply to the punter */
      sport?: string[];
    };
    /** PunterSettingsSchema */
    PunterSettingsSchema: {
      /**
       * The ID of the punter
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * The Punter Category assigned by the bookie
       * @example Newbie
       */
      bookie_category?: components['schemas']['PunterCategories'];
      /**
       * The Punter Category assigned by STORM
       * @example Sharp
       */
      storm_category?: components['schemas']['PunterCategories'];
      /**
       * Boolean flag to control the source for Punter category setting, True applies storm_category, False applies bookie_category
       * @example True
       */
      use_storm_category?: boolean;
    };
    /** PunterSportSchema */
    PunterSportSchema: {
      /**
       * Sport Id
       * Format: uuid
       */
      sport_id: string;
      /** Sport Name */
      sport_name: string;
      /**
       * list of sports containing 5 matches each
       * @default []
       */
      upcoming_matches?: components['schemas']['PunterMatchSchema'][];
    };
    /** PunterStats */
    PunterStats: {
      /**
       * Punter Id
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * The Punters current BetCloud Score (BCS)
       * @example 0.82
       */
      bet_cloud_score: number;
      /**
       * Total amount staked
       * @example 10000
       */
      turnover: number;
      /**
       * Total amount won minus the total amount staked
       * @example 10000
       */
      winnings: number;
      /**
       * Current balance
       * @example 10000
       */
      balance: number;
      /**
       * Restricted balance (i.e. Non Withdrawable Balance)
       * @example 10000
       */
      restricted_balance: number;
      /**
       * Unrestricted balance (i.e. Withdrawable Balance)
       * @example 10000
       */
      unrestricted_balance: number;
      /**
       * Current bonus balance
       * @example 10000
       */
      bonus_balance: number;
      /**
       * Total amount of bonuses given
       * @example 10000
       */
      bonus_given: number;
      /**
       * The last time the punter bet in UTC
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      last_bet_date?: string;
      /**
       * The punters last bet stake
       * @example 10000
       */
      last_bet?: number;
      /**
       * Average stake size
       * @example 100.00
       */
      average_bet: number;
      /**
       * Total number of bets made
       * @example 22
       */
      total_bets: number;
      /**
       * Total number of bets made
       * @example Newbie
       */
      player_type: components['schemas']['PunterCategories'];
      /**
       * Ordered list of the event types most bet on for this punter
       * @example [
       *   "AFL Football",
       *   "Greyhounds",
       *   "Soccer"
       * ]
       */
      frequent_bet_types: string[];
      /**
       * Eligible Bonus for subject Punter
       * @example 1000
       */
      eligible_bonus?: number;
      /**
       * Number of odds boost punter has claimed and bet result is win
       * @example 1000
       */
      odds_boost_win_count?: number;
      /**
       * Value of new payout of odds boost punter has claimed
       * @example 1000
       */
      odds_boost_total_amount?: number;
      /**
       * Value of new payout of odds boost punter has claimed and bet result is win
       * @example 1000
       */
      odds_boost_win_new_amount?: number;
      /**
       * Value of original payout of odds boost punter has claimed and bet result is win
       * @example 1000
       */
      odds_boost_win_original_amount?: number;
      /**
       * Number of bet boost punter has claimed
       * @example 1000
       */
      bet_boost_count?: number;
      /**
       * Value of bet boost punter has claimed
       * @example 1000
       */
      bet_boost_amount?: number;
    };
    /**
     * PunterStatusReasons
     * @description Manages punter status reasons
     * @enum {string}
     */
    PunterStatusReasons: (typeof PunterStatusReasons)[number];
    /**
     * PunterStatuses
     * @description Manages punter statuses
     * @enum {string}
     */
    PunterStatuses: (typeof PunterStatuses)[number];
    /** PunterStormSettings */
    PunterStormSettings: {
      /** Punter ID associated with the Storm data */
      punter_id: string;
      /** Platform ID of punter. Will be validated against the bookie account that calls the endpoint */
      platform_id: string;
      /**
       * Storm score computed for the Punter
       * @example 77.52
       */
      storm_score?: number;
      /**
       * Storm category computed for the Punter
       * @example High Roller
       */
      storm_category?: string;
      /**
       * Storm value for the storm score and category
       * @example Medium
       */
      storm_confidence?: string;
      /**
       * Storm calculated generosity amount
       * @example 0.41
       */
      generosity_amount?: number;
      /** Storm calculated generosity score */
      generosity_score?: number;
      /**
       * Timestamp of the storm data. Record will be skipped if database contains a more recent timestamp
       * Format: date-time
       * @example 11/03/2022 16:38:54
       */
      storm_timestamp: string;
      /**
       * User who updated the storm data
       * @example STORM_v1
       */
      storm_updated_by: string;
      /** Responsible Gambling Score computed by Storm */
      rg_score?: number;
      /**
       * Responsible Gambling Category computed by Storm
       * @example 1
       */
      rg_category?: number;
      /**
       * Generosity Percentage
       * @example 50
       */
      generosity_pct?: number;
      /**
       * Generosity number
       * @example 1
       */
      generosity_number?: number;
      /**
       * Eligible bonus
       * @example 1000
       */
      eligible_bonus?: number;
    };
    /** PunterTokenHistoryItem */
    PunterTokenHistoryItem: {
      /**
       * The number of tokens
       * @example 3
       */
      token_count: number;
      /**
       * The source of the tokens
       * @example storm
       */
      source: components['schemas']['PromoSource'];
      /**
       * Date of the update
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      updated_at: string;
      /**
       * Who made the update, e.g. punter, storm, bookie
       * @example Joe Bloggs
       */
      updated_by?: string;
      /**
       * Additional parameters for the specific promotion type
       * @example {"values": [1000, 2000, 3000], "max_stake": 20000, "probability": 0.05}
       */
      parameters: Record<string, never>;
    };
    /** PunterTokenHistoryResponse */
    PunterTokenHistoryResponse: {
      /** Token History */
      token_history: components['schemas']['PunterTokenHistoryItem'][];
      /**
       * Offset value to be used when requesting next page
       * @example 2021-11-29T06:00:35
       */
      offset?: string;
    };
    /** PunterTokenPayload */
    PunterTokenPayload: {
      /**
       * The unique ID of the punter
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * The type of the token
       * @example spin-wheel
       */
      token_type: components['schemas']['TokenType'];
      /**
       * The maximum amount for the deposit match bonus in cents
       * @example 100
       */
      amount: number;
    };
    /** PunterTokens */
    PunterTokens: {
      /**
       * Punter ID associated with the Storm data
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * The type of the token
       * @example recovery
       */
      token_type: components['schemas']['TokenType'];
      /**
       * Number of tokens
       * @example 3
       */
      count: number;
      /**
       * Additional parameters for the specific promotion type
       * @example {"values": [1000, 2000, 3000], "max_stake": 20000, "probability": 0.05}
       */
      parameters: Record<string, never>;
    };
    /** PunterTransaction */
    PunterTransaction: {
      /**
       * The UUID for the transaction record
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      transaction_id: string;
      /**
       * date and time transaction occurred (transaction.created_at).
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      timestamp: string;
      /**
       * Type of transaction (Deposit, Withdrawal, Bet, Adjustment, ...).
       * @example Deposit
       */
      transaction_type: components['schemas']['TransactionTypes'];
      /**
       * Sub type of transaction (e.g. Single, Exotics, Credit, etc).
       * @example Single
       */
      sub_type?: string;
      /**
       * Transaction amount in cents (bets and withdrawals are negative)
       * @example 1000
       */
      amount: number;
      /**
       * Running balance resulting from this Tx
       * @example 1000
       */
      running_balance: number;
      /**
       * Transaction details
       * @example {
       *   "note": "Deposit",
       *   "reason": "Promotion"
       * }
       */
      details: Record<string, never>;
    };
    /** RaceFormData */
    RaceFormData: {
      /**
       * Race Type
       * @example Thoroughbred
       */
      race_type?: string;
      /**
       * Race Distance in Meters
       * @example 1000
       */
      race_distance?: number;
      /**
       * Weather Condition
       * @example Fine
       */
      weather_condition?: string;
      /**
       * class or grade
       * @example G5
       */
      race_class_conditions?: string;
      /**
       * Track condition
       * @example Firm
       */
      track_condition?: string;
    };
    /** RaceMarketEntityInfo */
    RaceMarketEntityInfo: {
      /**
       * Id of the entity to update
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      id: string;
      /**
       * Status of the entity to update
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      status?: string;
      /**
       * If the entity is suspended
       * @example false
       */
      is_suspended?: boolean;
      /**
       * If the entity is locked
       * @example false
       */
      lock_status?: boolean;
      /**
       * If the price is locked
       * @example false
       */
      lock_price?: boolean;
      /**
       * If winter settlement is locked
       * @example false
       */
      lock_settlement?: boolean;
    };
    /**
     * RaceMetaData
     * @description A Race object with only metadata about the race
     */
    RaceMetaData: {
      /**
       * The race ID in our database
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      race_id: string;
      /**
       * The venue ID in our database
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      venue_id?: string;
      /**
       * The name of the Venue
       * @example Prairie Meadows
       */
      venue_name?: string;
      /**
       * The country
       * @example USA
       */
      venue_country?: string;
      /**
       * The display name of the race
       * @example Race 1
       */
      display_name: string;
      /**
       * The type of race
       * @example Horse Racing
       */
      race_type: components['schemas']['RaceTypes'];
      /**
       * The start time of the race in UTC timezone
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      start_time: string;
      /**
       * Number of the race
       * @example 1
       */
      race_number: number;
      /**
       * The race status
       * @example Voided
       */
      status: components['schemas']['GeneralStatus'];
      /**
       * when is/was the race.
       * Format: date
       * @example 2023-10-24
       */
      meeting_date?: string;
      /**
       * Number of the places
       * @example 1
       */
      number_of_places?: number;
      form_data?: components['schemas']['RaceFormData'];
    };
    /** RaceModifierInput */
    RaceModifierInput: {
      /**
       * The Race type to apply a modifier to, or the race type for the venue that the modifier should apply to
       * @example Horse Racing
       */
      race_type: components['schemas']['RaceTypes'];
      /**
       * The competition ID in our database
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      venue_id?: string;
      /**
       * The modifier for this specific item
       * @example 2
       */
      modifier: number;
    };
    /** RaceNumbersForVenues */
    RaceNumbersForVenues: {
      /**
       * The race ID in our database
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      race_id: string;
      /**
       * The number of the race
       * @example 10
       */
      race_number: string;
      /**
       * The start time of the race in UTC timezone
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      start_time: string;
    };
    /** RaceOfferingView */
    RaceOfferingView: {
      /** The list of offered types of racing */
      race_types: components['schemas']['RaceTypeOffering'][];
      /** True if all racing venues are offered */
      all_racing: boolean;
    };
    /** RaceResultRow */
    RaceResultRow: {
      /**
       * The id of the race.
       * Format: uuid
       */
      race_id?: string;
      /** Runner Results */
      runner_results?: components['schemas']['RunnerResults'][];
      /** Exotic Results */
      exotic_results?: components['schemas']['ExoticResult'][];
    };
    /** RaceRunnerFlucsData */
    RaceRunnerFlucsData: {
      /** The opening price for a given runner */
      opening_price?: number;
      /**
       * List of price flucs
       * @example [{5.5,5.75,6,5.75}]
       */
      flucs?: number[];
      /**
       * Fire Level
       * @example Fire Low Animation
       */
      market_mover?: components['schemas']['MarketMoverTypes'];
    };
    /** RaceRunnerFormData */
    RaceRunnerFormData: {
      /**
       * Race Type
       * @example Thoroughbred
       */
      race_type?: string;
      /**
       * Trainer name
       * @example A Trainer
       */
      trainer_name?: string;
      /**
       * Trainer name
       * @example A Rider
       */
      rider_name?: string;
      /**
       * Last Finishes
       * @example 14332
       */
      last_5_starts?: string;
      /**
       * Handicap Weight in Kg
       * @example 4.5
       */
      handicap_weight?: string;
      /**
       * Handicap Length in Meters
       * @example 10.5
       */
      harness_handicap?: string;
      /**
       * List of badge dictionaries
       * @example [{'the_badge': 'the badge description'}]
       */
      badges?: {
        [key: string]: string | undefined;
      }[];
    };
    /** RaceRunnerModifierInput */
    RaceRunnerModifierInput: {
      /**
       * Race Runner id to update.
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      race_runner_id: string;
      /**
       * The modifier for this race runner's win odds
       * @example 1
       */
      win_modifier?: number;
      /**
       * The modifier for this race runner's place odds
       * @example 1
       */
      place_modifier?: number;
    };
    /** RaceSettingsDTO */
    RaceSettingsDTO: {
      /**
       * Whether to disable the SRM on a race.
       * @example true
       */
      srm_disabled?: boolean;
      /**
       * Whether to intercept all the SRM bets for a race.
       * @example true
       */
      srm_intercept_all?: boolean;
      /**
       * Whether to disable the SRM on a race.
       * @example true
       */
      blended_disabled?: boolean;
      /**
       * Whether to intercept all the SRM bets for a race.
       * @example true
       */
      blended_intercept_all?: boolean;
      /**
       * Whether to disable the Even Shot on a race.
       * @example true
       */
      even_shot_disabled?: boolean;
    };
    /** RaceStats */
    RaceStats: {
      /**
       * The total number of bets on this event
       * @example 2
       */
      total_bets: number;
      /**
       * The total money staked across all bets on this event in cents
       * @example 15000
       */
      turnover: number;
      /**
       * The calculated exposure for this event in cents
       * @example 1000
       */
      exposure: number;
      /**
       * Player Type Distribution
       * @default []
       */
      player_type_distribution?: components['schemas']['PlayerTypeStats'][];
      /**
       * The total money staked across only win bets on this event in cents
       * @example 1000
       */
      win_turnover: number;
      /**
       * The total money staked across only win bets on this event in cents
       * @example 3000
       */
      place_turnover: number;
      /**
       * The total money staked across only exotic bets on this event in cents
       * @example 1000
       */
      exotic_turnover: number;
      /**
       * The total number of SRM bets on this race
       * @default 0
       * @example 5
       */
      srm_total_bets?: number;
      /**
       * The total money staked across SRM bets on this race in cents
       * @default 0
       * @example 1500
       */
      srm_turnover?: number;
    };
    /** RaceStatusUpdateInput */
    RaceStatusUpdateInput: {
      /** Race info to update */
      race?: components['schemas']['RaceMarketEntityInfo'];
      /** Market info to update */
      markets?: components['schemas']['RaceMarketEntityInfo'][];
    };
    /** RaceTypeOffering */
    RaceTypeOffering: {
      /** Countries */
      countries: components['schemas']['CountryRaceOffering'][];
      /** Display Name */
      display_name: string;
      /** All Offered */
      all_offered: boolean;
    };
    /**
     * RaceTypes
     * @description Manages the types of racing that we support
     * NOTE: From TAB we just get H, G, R (single letter abbreviations)
     * @enum {string}
     */
    RaceTypes: (typeof RaceTypes)[number];
    /** ReconcilePayload */
    ReconcilePayload: {
      /**
       * The id of the deposit in our database.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      deposit_id: string;
      /**
       * The amount to reconcile to.
       * @example 100000000000
       */
      amount: number;
    };
    /** RemainingLimitResponse */
    RemainingLimitResponse: {
      /**
       * The punter who has the limit.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * The deposit limit amount in cents
       * @example 1
       */
      deposit_limit?: number;
      /**
       * The remaining limit amount in cents
       * @example 0
       */
      remaining?: number;
    };
    /** RemoteBetRequestStatusInput */
    RemoteBetRequestStatusInput: {
      /**
       * Request Id
       * Format: uuid
       * @description The ID of the bet request to action
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      request_id: string;
      /**
       * The status to set the bet request to
       * @example Rejected
       */
      action: string;
      /**
       * The approved amount in cents
       * @example 10000
       */
      amount?: number;
      /**
       * The reason for the action
       * @example None
       */
      reason?: string;
      /**
       * Bookie Email
       * @description Email of the bookie who approved this
       * @example test@test.com
       */
      bookie_email: string;
      /**
       * Ip
       * @description IP of the request in the global approvals system
       * @example 127.0.0.1
       */
      ip: string;
    };
    /** RequestedWithdrawView */
    RequestedWithdrawView: {
      /**
       * The id of the withdrawal request
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      withdrawal_id: string;
      /**
       * The amount that the punter would like to withdraw, in cents (example equates to $10.50)
       * @example 1050
       */
      amount_requested: number;
      /**
       * The date that the punter requested the withdrawal
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      date_requested: string;
      /**
       * The status of the withdrawal request
       * @example Pending
       */
      withdrawal_status: components['schemas']['WithdrawalStatus'];
      /**
       * The nickname of the bank account that the punter would like to withdraw to if set, otherwise the account name is returned
       * @example My Bank
       */
      bank_nickname?: string;
    };
    /** RunnerListRow */
    RunnerListRow: {
      /**
       * the UUID of the RaceRunner, containing records of runners in races
       * Format: uuid
       */
      race_runner_id: string;
      /** the printable name of the runner in the race */
      display_name: string;
      /** the number given to the runner in the race */
      number: number;
      /** the barrier assigned to the runner in the race */
      barrier_number: number;
      win_proposition?: components['schemas']['PropositionSchema'];
      /** the odds of a given runner winning the race */
      win_odds?: number;
      place_proposition?: components['schemas']['PropositionSchema'];
      /** the odds of a given runner placing in the race */
      place_odds?: number;
      /** a link to the silk graphic for the given runner */
      silk_url?: string;
      /**
       * The amount in cents to deduct from bets on other win propositions
       * @example 50
       */
      win_deductions?: number;
      /**
       * The amount in cents to deduct from bets on other place propositions
       * @example 28
       */
      place_deductions?: number;
      /**
       * The status of the runner.
       * @example SCRATCHED
       */
      status?: string;
      /**
       * Runner scratch time if available.
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      scratch_time?: string;
      form_data?: components['schemas']['RaceRunnerFormData'];
      flucs_data?: components['schemas']['RaceRunnerFlucsData'];
    };
    /** RunnerResults */
    RunnerResults: {
      /**
       * The id of the race
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      race_id?: string;
      /**
       * The id of the race runner
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      race_runner_id?: string;
      /**
       * The race runners Globally Unique ID from Winter
       * Format: uuid
       * @example 2023-04-29-GLD-H-6-5
       */
      race_runner_external_ref: string;
      /**
       * name of the runner
       * @example Johhny Three Legs.
       */
      runner_name?: string;
      /**
       * Number of the runner
       * @example 2
       */
      runner_number?: string;
      /**
       * What position did they finish in
       * @example 1
       */
      result_place?: string;
      /**
       * What gate where they at.
       * @example 1
       */
      barrier_number?: string;
      /**
       * The final win odds for the runner
       * @example 10
       */
      win_odds?: number;
      /**
       * The final place odds for the runner
       * @example 3.7
       */
      place_odds?: number;
      /**
       * The silk url of the runner.
       * @example test.com
       */
      silk_url?: string;
      /**
       * A section for displaying Win proposition results and potentially other information in future
       * @example {"dividends" : {"tote_single_mid": 1.5}}]
       */
      win_proposition?: components['schemas']['ToteSingleResults'];
      /**
       * A section for displaying Place proposition results and potentially other information in future
       * @example {"dividends" : {"tote_single_mid": 1.5}}]
       */
      place_proposition?: components['schemas']['ToteSingleResults'];
    };
    /** RunnerStatusUpdateInput */
    RunnerStatusUpdateInput: {
      /**
       * Id of the runner to update
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      id: string;
      /**
       * Status of the runner to update
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      status?: string;
      /**
       * If the runner is suspended
       * @example false
       */
      is_suspended?: boolean;
      /**
       * If the status is locked
       * @example false
       */
      lock_status?: boolean;
      /**
       * If the price is locked
       * @example false
       */
      lock_price?: boolean;
      /** Scratch info for the runner */
      scratch_info?: components['schemas']['ScratchInfo'];
    };
    /**
     * SEMultiCombinationPuntersSortBy
     * @description An enumeration.
     * @enum {string}
     */
    SEMultiCombinationPuntersSortBy: (typeof SEMultiCombinationPuntersSortBy)[number];
    /**
     * SEMultiSortOrder
     * @description An enumeration.
     * @enum {string}
     */
    SEMultiSortOrder: (typeof SEMultiSortOrder)[number];
    /** SEMultisCombinationPunterStatsItemResponse */
    SEMultisCombinationPunterStatsItemResponse: {
      /**
       * The Punter id.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      id: string;
      /**
       * The Punter's name.
       * @example Andrew V
       */
      name: string;
      /**
       * The Punter's Category.
       * @example Newbie
       */
      category: components['schemas']['PunterCategories'];
      /**
       * The number of bets made by this punter in an SGM combination.
       * @default 0
       * @example 12
       */
      bets_count?: number;
      /**
       * The bets stake.
       * @default 0
       * @example 12
       */
      stake?: number;
      /**
       * The average odds value the bet is placed.
       * @default 0
       * @example 3.6
       */
      odds?: number;
      /**
       * The exposure value of the bet.
       * @default 0
       * @example 100
       */
      exposure?: number;
    };
    /** SEMultisCombinationPunterStatsResponse */
    SEMultisCombinationPunterStatsResponse: {
      /**
       * Paging information
       * @default {}
       */
      paging?: components['schemas']['api__meta__schemas__bookie_schemas__PagingResponse'];
      /**
       * List of punters and their stats for a match combination.
       * @default []
       * @example list[SGMultisCombinationPunterStatsItemResponse]
       */
      punters?: components['schemas']['SEMultisCombinationPunterStatsItemResponse'][];
    };
    /** SGMultiBetPropositionResponse */
    SGMultiBetPropositionResponse: {
      /**
       * The market name.
       * @example Points Over/Under 50.5
       */
      market_name: string;
      /**
       * The proposition name.
       * @example Over 50.5
       */
      name: string;
    };
    /**
     * SGMultiBetResponse
     * @description Response item for SGM Bet for a Match for risk management.
     */
    SGMultiBetResponse: {
      /**
       * The bet id.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      bet_id: string;
      /**
       * The creation time of the bet in UTC.
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      created_at: string;
      /**
       * The punter's id.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * The punter's name.
       * @example Victoria
       */
      punter_name: string;
      /**
       * The punter's category name.
       * @example Newbie
       */
      punter_category: components['schemas']['PunterCategories'];
      /**
       * The bet's status.
       * @example pending
       */
      status: components['schemas']['BetStatuses'];
      /**
       * The stake value the bet is placed.
       * @default 0
       * @example 12
       */
      stake?: number;
      /**
       * The odds value the bet is placed.
       * @default 0
       * @example 3.61
       */
      odds?: number;
      /**
       * The exposure value of the bet.
       * @default 0
       * @example 100
       */
      exposure?: number;
      /**
       * The number of duplicate bets with the same SGM combination, excluding the current bet.
       * @default 0
       * @example 12
       */
      duplicate_bets?: number;
      /**
       * The list of propositions of the SGM bet.
       * @default []
       * @example list[SGMultiBetPropositionResponse]
       */
      propositions?: components['schemas']['SGMultiBetPropositionResponse'][];
    };
    /**
     * SGMultiBetSortBy
     * @description An enumeration.
     * @enum {string}
     */
    SGMultiBetSortBy: (typeof SGMultiBetSortBy)[number];
    /**
     * SGMultiBetSortOrder
     * @description An enumeration.
     * @enum {string}
     */
    SGMultiBetSortOrder: (typeof SGMultiBetSortOrder)[number];
    /**
     * SGMultiMonitorSortBy
     * @description An enumeration.
     * @enum {string}
     */
    SGMultiMonitorSortBy: (typeof SGMultiMonitorSortBy)[number];
    /**
     * SGMultiPriceRequest
     * @description Request for price
     */
    SGMultiPriceRequest: {
      /**
       * The Match Id
       * Format: uuid
       * @example 12312dw234
       */
      match_id: string;
      /**
       * List of propositions to be priced
       * @default []
       * @example ['1bda22c9-a435-4be3-a831-697b24e8cae4']
       */
      proposition_ids?: string[];
    };
    /**
     * SGMultiPriceResponse
     * @description Response for Request for price
     */
    SGMultiPriceResponse: {
      /**
       * The price/odds of the propositions combo
       * @example 2.8
       */
      price?: number;
    };
    /** SGMultisBetsResponse */
    SGMultisBetsResponse: {
      /**
       * Paging information
       * @default {}
       */
      paging?: components['schemas']['api__meta__schemas__bookie_schemas__PagingResponse'];
      /**
       * List of SGM bets for a match
       * @default []
       * @example list[SGMultiBetResponse]
       */
      bets?: components['schemas']['SGMultiBetResponse'][];
    };
    /** SGMultisCombinationPunterStatResponse */
    SGMultisCombinationPunterStatResponse: {
      /**
       * The Punter id.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      id: string;
      /**
       * The Punter's name.
       * @example Andrew V
       */
      name: string;
      /**
       * The Punter's Category.
       * @example Newbie
       */
      category: components['schemas']['PunterCategories'];
      /**
       * The number of bets made by this punter in an SGM combination.
       * @default 0
       * @example 12
       */
      bets_count?: number;
      /**
       * The bets stake.
       * @default 0
       * @example 12
       */
      stake?: number;
      /**
       * The average odds value the bet is placed.
       * @default 0
       * @example 3.6
       */
      odds?: number;
      /**
       * The exposure value of the bet.
       * @default 0
       * @example 100
       */
      exposure?: number;
    };
    /**
     * SGMultisCombinationStatResponse
     * @description Response item for SGM Combination Stat for a Match in risk management.
     */
    SGMultisCombinationStatResponse: {
      /**
       * The unique id of proposition.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      multi_uid: string;
      /**
       * The combination name.
       * @example Man City | UTEP Miners | Over 50.5
       */
      name: string;
      /**
       * The number of bets made in an SGM combination.
       * @default 0
       * @example 12
       */
      bets_count?: number;
      /**
       * The number of punters bet in an SGM combination.
       * @default 0
       * @example 12
       */
      punters_count?: number;
      /**
       * The bets stake.
       * @default 0
       * @example 12
       */
      stake?: number;
      /**
       * The odds value the bet is placed.
       * @default 0
       * @example 3.6
       */
      odds?: number;
      /**
       * The exposure value of the bet.
       * @default 0
       * @example 100
       */
      exposure?: number;
      /**
       * List of punters made bets on in this combination.
       * @default []
       * @example list[SGMultisCombinationPunterStatResponse]
       */
      punters?: components['schemas']['SGMultisCombinationPunterStatResponse'][];
    };
    /** SGMultisCombinationStatsResponse */
    SGMultisCombinationStatsResponse: {
      /**
       * Paging information
       * @default {}
       */
      paging?: components['schemas']['api__meta__schemas__bookie_schemas__PagingResponse'];
      /**
       * List of SGM combinations and their stats for a match
       * @default []
       * @example list[SGMultisCombinationStatResponse]
       */
      combinations?: components['schemas']['SGMultisCombinationStatResponse'][];
    };
    /**
     * SGMultisMatchCombinationsSortBy
     * @description An enumeration.
     * @enum {string}
     */
    SGMultisMatchCombinationsSortBy: (typeof SGMultisMatchCombinationsSortBy)[number];
    /** SGMultisMonitorResponse */
    SGMultisMonitorResponse: {
      /**
       * Paging information
       * @default {}
       */
      paging?: components['schemas']['api__meta__schemas__bookie_schemas__PagingResponse'];
      /**
       * List of events for trade manager
       * @default []
       * @example TradeManagerEvent
       */
      items?: components['schemas']['TradeManagerEvent'][];
    };
    /**
     * SGMultisPropositionSortBy
     * @description An enumeration.
     * @enum {string}
     */
    SGMultisPropositionSortBy: (typeof SGMultisPropositionSortBy)[number];
    /**
     * SGMultisPropositionStatResponse
     * @description Response item for SGM Proposition Stat for a Match for risk management.
     */
    SGMultisPropositionStatResponse: {
      /**
       * The unique id of proposition.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      id: string;
      /**
       * The combination name.
       * @example Man City | UTEP Miners | Over 50.5
       */
      name: string;
      /**
       * The number of bets made in an SGM combination.
       * @default 0
       * @example 12
       */
      bets_count?: number;
      /**
       * The number of punters bet in an SGM combination.
       * @default 0
       * @example 12
       */
      punters_count?: number;
      /**
       * The bets stake.
       * @default 0
       * @example 12
       */
      stake?: number;
      /**
       * The odds value the bet is placed.
       * @default 0
       * @example 3.6
       */
      odds?: number;
      /**
       * The exposure value of the bet.
       * @default 0
       * @example 100
       */
      exposure?: number;
    };
    /** SGMultisPropositionStatsResponse */
    SGMultisPropositionStatsResponse: {
      /**
       * Paging information
       * @default {}
       */
      paging?: components['schemas']['api__meta__schemas__bookie_schemas__PagingResponse'];
      /**
       * List of SGM propositions and their stats for a match
       * @default []
       * @example list[SGMultisPropositionStatResponse]
       */
      propositions?: components['schemas']['SGMultisPropositionStatResponse'][];
    };
    /**
     * SRMultiBetSortOrder
     * @description An enumeration.
     * @enum {string}
     */
    SRMultiBetSortOrder: (typeof SRMultiBetSortOrder)[number];
    /**
     * SRMultiMonitorRaceItem
     * @description This schema is used in the trade manager > SRM monitor
     */
    SRMultiMonitorRaceItem: {
      /**
       * The id of the race
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      id: string;
      /**
       * The race type
       * @example Harness Racing
       */
      type: string;
      /**
       * The Race name for the event
       * @example R1 Ladbroke It! Maiden Plate
       */
      title?: string;
      /**
       * The Venue name for the race
       * @example Flemington
       */
      subtitle: string;
      /**
       * The time that the race will start in UTC
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      start_time: string;
      /**
       * The status inferred from TAB that the event is in
       * @example Protest
       */
      status: components['schemas']['GeneralStatus'];
      /**
       * The total number of bets places on this event
       * @default 0
       * @example 12
       */
      total_bets?: number;
      /**
       * The total stake of all bets placed on this event, in cents
       * @default 0
       * @example 420
       */
      total_stakes?: number;
      /**
       * The total exposures for the placed bets
       * @default 0
       * @example 180
       */
      total_exposures?: number;
      /**
       * The stake of the largest bet placed on this event, in cents
       * @default 0
       * @example 180
       */
      max_bet?: number;
    };
    /**
     * SRMultiMonitorSortBy
     * @description An enumeration.
     * @enum {string}
     */
    SRMultiMonitorSortBy: (typeof SRMultiMonitorSortBy)[number];
    /**
     * SRMultiRaceBetResponse
     * @description Response item for SRM Bets for a Race for risk management.
     */
    SRMultiRaceBetResponse: {
      /**
       * The bet id.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      bet_id: string;
      /**
       * The creation time of the bet in UTC.
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      created_at: string;
      /**
       * The punter's id.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * The punter's name.
       * @example Victoria
       */
      punter_name: string;
      /**
       * The punter's category name.
       * @example Newbie
       */
      punter_category: components['schemas']['PunterCategories'];
      /**
       * The bet's status.
       * @example pending
       */
      status: components['schemas']['BetStatuses'];
      /**
       * The stake value the bet is placed.
       * @default 0
       * @example 12
       */
      stake?: number;
      /**
       * The odds value the bet is placed.
       * @default 0
       * @example 3.61
       */
      odds?: number;
      /**
       * The exposure value of the bet.
       * @default 0
       * @example 100
       */
      exposure?: number;
      /**
       * The number of duplicate bets with the same SGM combination, excluding the current bet.
       * @default 0
       * @example 12
       */
      duplicate_bets?: number;
      /**
       * The list of selected runners.
       * @default []
       * @example list[SRMultiRaceBetRunnerResponse]
       */
      runners?: components['schemas']['SRMultiRaceBetRunnerResponse'][];
    };
    /** SRMultiRaceBetRunnerResponse */
    SRMultiRaceBetRunnerResponse: {
      /**
       * The runner's number.
       * @example 5
       */
      number: number;
      /**
       * The runner name.
       * @example Dirty Weekend
       */
      name: string;
      /**
       * The selected winning places for the runner. Possible values: Top1, Top2, Top3, Top4
       * @example Top1
       */
      top_selection?: components['schemas']['SrmTopSelection'];
    };
    /**
     * SRMultiRaceBetsSortBy
     * @description An enumeration.
     * @enum {string}
     */
    SRMultiRaceBetsSortBy: (typeof SRMultiRaceBetsSortBy)[number];
    /**
     * SRMultiRaceCombinationsSortBy
     * @description An enumeration.
     * @enum {string}
     */
    SRMultiRaceCombinationsSortBy: (typeof SRMultiRaceCombinationsSortBy)[number];
    /**
     * SRMultiRaceRunnersSortBy
     * @description An enumeration.
     * @enum {string}
     */
    SRMultiRaceRunnersSortBy: (typeof SRMultiRaceRunnersSortBy)[number];
    /**
     * SRMultiSortOrder
     * @description An enumeration.
     * @enum {string}
     */
    SRMultiSortOrder: (typeof SRMultiSortOrder)[number];
    /** SRMultisMonitorResponse */
    SRMultisMonitorResponse: {
      /**
       * Paging information
       * @default {}
       */
      paging?: components['schemas']['api__meta__schemas__bookie_schemas__PagingResponse'];
      /**
       * List of SRM races for trade manager
       * @default []
       * @example SRMultiMonitorRaceItem
       */
      races?: components['schemas']['SRMultiMonitorRaceItem'][];
    };
    /** SRMultisRaceBetsResponse */
    SRMultisRaceBetsResponse: {
      /**
       * Paging information
       * @default {}
       */
      paging?: components['schemas']['api__meta__schemas__bookie_schemas__PagingResponse'];
      /**
       * List of SRM bets for a Race
       * @default []
       * @example list[SRMultiRaceBetResponse]
       */
      bets?: components['schemas']['SRMultiRaceBetResponse'][];
    };
    /** SRMultisRaceCombinationPunterStatsItemResponse */
    SRMultisRaceCombinationPunterStatsItemResponse: {
      /**
       * The Punter id.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      id: string;
      /**
       * The Punter's name.
       * @example Andrew V
       */
      name: string;
      /**
       * The Punter's Category.
       * @example Newbie
       */
      category: components['schemas']['PunterCategories'];
      /**
       * The number of bets made by this punter in an SGM combination.
       * @default 0
       * @example 12
       */
      bets_count?: number;
      /**
       * The bets stake.
       * @default 0
       * @example 12
       */
      stake?: number;
      /**
       * The average odds value the bet is placed.
       * @default 0
       * @example 3.6
       */
      odds?: number;
      /**
       * The exposure value of the bet.
       * @default 0
       * @example 100
       */
      exposure?: number;
    };
    /** SRMultisRaceCombinationPunterStatsResponse */
    SRMultisRaceCombinationPunterStatsResponse: {
      /**
       * Paging information
       * @default {}
       */
      paging?: components['schemas']['api__meta__schemas__bookie_schemas__PagingResponse'];
      /**
       * List of punters made bets on in this combination.
       * @default []
       * @example list[SRMultisRaceCombinationPunterStatsItemResponse]
       */
      punters?: components['schemas']['SRMultisRaceCombinationPunterStatsItemResponse'][];
    };
    /** SRMultisRaceCombinationRunnerItemResponse */
    SRMultisRaceCombinationRunnerItemResponse: {
      /**
       * The runner's number.
       * @example 5
       */
      number: number;
      /**
       * The runner name.
       * @example Dirty Weekend
       */
      name: string;
      /**
       * The selected winning places for the runner. Possible values: Top1, Top2, Top3, Top4
       * @example Top1
       */
      top_selection?: components['schemas']['SrmTopSelection'];
    };
    /**
     * SRMultisRaceCombinationStatsItemResponse
     * @description Response item for SRM Combination Stat for a Race in risk management.
     */
    SRMultisRaceCombinationStatsItemResponse: {
      /**
       * The unique id of proposition.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      multi_uid: string;
      /**
       * The number of bets made in an SRM combination.
       * @default 0
       * @example 12
       */
      bets_count?: number;
      /**
       * The number of punters bet in an SRM combination.
       * @default 0
       * @example 12
       */
      punters_count?: number;
      /**
       * The total bets stake.
       * @default 0
       * @example 12
       */
      stake?: number;
      /**
       * The average odds.
       * @default 0
       * @example 3.6
       */
      odds?: number;
      /**
       * The total exposure.
       * @default 0
       * @example 100
       */
      exposure?: number;
      /**
       * The list of selected runners.
       * @default []
       * @example list[SRMultisRaceCombinationRunnerItemResponse]
       */
      runners?: components['schemas']['SRMultisRaceCombinationRunnerItemResponse'][];
    };
    /** SRMultisRaceCombinationStatsResponse */
    SRMultisRaceCombinationStatsResponse: {
      /**
       * Paging information
       * @default {}
       */
      paging?: components['schemas']['api__meta__schemas__bookie_schemas__PagingResponse'];
      /**
       * List of SRM combinations and their stats for a race
       * @default []
       * @example list[SRMultisRaceCombinationStatsItemResponse]
       */
      combinations?: components['schemas']['SRMultisRaceCombinationStatsItemResponse'][];
    };
    /**
     * SRMultisRaceRunnerStatsItemResponse
     * @description Response item for SRM Runner Stats for a Race for risk management.
     */
    SRMultisRaceRunnerStatsItemResponse: {
      /**
       * The unique id of the runner.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      id: string;
      /**
       * The runner number.
       * @example 12
       */
      number: number;
      /**
       * The runner name.
       * @example Man City | UTEP Miners | Over 50.5
       */
      name: string;
      /**
       * The number of bets made on this runner as part of SRM bets.
       * @default 0
       * @example 12
       */
      bets_count?: number;
      /**
       * The number of punters bet in on this runner as part of SRM bets.
       * @default 0
       * @example 12
       */
      punters_count?: number;
      /**
       * The total bets stake.
       * @default 0
       * @example 12
       */
      stake?: number;
      /**
       * The average odds value of the SRM bets
       * @default 0
       * @example 3.6
       */
      odds?: number;
      /**
       * The total exposure value for the runner as part of SRM bets
       * @default 0
       * @example 100
       */
      exposure?: number;
    };
    /** SRMultisRaceRunnerStatsResponse */
    SRMultisRaceRunnerStatsResponse: {
      /**
       * Paging information
       * @default {}
       */
      paging?: components['schemas']['api__meta__schemas__bookie_schemas__PagingResponse'];
      /**
       * List of SRM runner stats for a race
       * @default []
       * @example list[SRMultisRaceRunnerStatsItemResponse]
       */
      runners?: components['schemas']['SRMultisRaceRunnerStatsItemResponse'][];
    };
    /** SaveMyaffiliates */
    SaveMyaffiliates: {
      /** myaffiliates' punter id */
      punter_id: string;
      /** myaffiliates' affiliate code */
      affiliate_code?: string;
    };
    /** ScratchInfo */
    ScratchInfo: {
      /**
       * the time when the runner is scratched
       * @example 2021-11-29T06:00:35
       */
      scratch_time?: string;
      /**
       * the deduction for win proposition
       * @example 1
       */
      win_deduction?: number;
      /**
       * the deduction for 2 places
       * @example 3
       */
      p2_deduction?: number;
      /**
       * the deduction for 3 places
       * @example 2
       */
      p3_deduction?: number;
    };
    /** EvenShotRaceBetStats */
    EvenShotRaceBetStats: {
      /**
       * The race runner ID in our database
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      race_id: string;
      /**
       * Number of bets placed on the even shot proposition
       * @example 10
       */
      even_shot_bets: number;
      /**
       * Even shot Proposition Stake Aggregate
       * @example 100000
       */
      even_shot_hold: number;
      /**
       * even shot Proposition Payout Aggregate - even shot Proposition Stake Aggregate
       * @example 10000
       */
      even_shot_liability: number;
      /** Runners */
      runners?: components['schemas']['EvenShotRaceRunnerStats'][];
    };
    /** EvenShotRaceRunnerStats */
    EvenShotRaceRunnerStats: {
      /**
       * The race runner ID in our database
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      race_runner_id: string;
      /**
       * The display name of the runner
       * @example Elon Musk
       */
      display_name: string;
      /**
       * The runner number for this race
       * @example 2
       */
      number?: number;
      /**
       * The runner barrier number for this race
       * @example 5
       */
      barrier_number: number;
      /**
       * The exact URL where you may find an image representing this runner
       * @example https://placeimg.com/100/100
       */
      silk_url?: string;
      /**
       * The status of the runner
       * @example Closed
       */
      status: components['schemas']['GeneralStatus'];
      /**
       * Number of bets placed on the even shot proposition
       * @example 10
       */
      even_shot_bets: number;
      /**
       * even shot Proposition Stake Aggregate
       * @example 100000
       */
      even_shot_hold: number;
      /**
       * The largest single stake contributing to the even shot Proposition Stake Aggregate
       * @example 100000
       */
      biggest_even_shot_bet: number;
      /**
       * even shot Proposition Payout Aggregate - even shot Proposition Stake Aggregate
       * @example 10000
       */
      even_shot_liability: number;
      /** Topx Stats */
      topx_stats?: components['schemas']['EvenShotTopXStats'][];
    };
    /** EvenShotTopXStats */
    EvenShotTopXStats: {
      /**
       * Proposition type, Top2, Top3 or Top4
       * @example Top2
       */
      proposition_type: string;
      /**
       * Number of bets placed on the even shot proposition
       * @example 10
       */
      even_shot_bets: number;
      /**
       * Even shot Stake Aggregate
       * @example 100000
       */
      even_shot_hold: number;
      /**
       * The largest single stake contributing to the even shot Proposition Stake Aggregate
       * @example 100000
       */
      biggest_even_shot_bet: number;
      /**
       * Even shot Proposition payout Aggregate - Even shot Proposition stake Aggregate
       * @example 10000
       */
      even_shot_liability: number;
    };
    /** SessionRequest */
    SessionRequest: {
      /**
       * Id of the deposit
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      deposit_id: string;
      /**
       * Deposit amount in cents
       * @example 10000
       */
      amount?: number;
      /**
       * The id of the promo the punter is opting in to, if applicable
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      opted_in_promo?: string;
    };
    /** SessionRequestPatch */
    SessionRequestPatch: {
      /**
       * Id of the deposit
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      deposit_id: string;
      /**
       * Deposit amount in cents
       * @example 10000
       */
      amount?: number;
      /**
       * The id of the promo the punter is opting in to, if applicable
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      opted_in_promo?: string;
      /**
       * Whether the payment is using an existing pay method or a new one
       * @example FIRST_PAYMENT
       */
      payment_type?: components['schemas']['PrimerPaymentType'];
      /** current primer token to be patched */
      client_token: string;
    };
    /** SessionResponse */
    SessionResponse: {
      /**
       * Primer client token
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      client_token: string;
    };
    /** SetSportsIgnoreWinterSettlementInput */
    SetSportsIgnoreWinterSettlementInput: {
      /** the id of the race */
      match_id: string;
      /** The ids of the child objects to suspend */
      market_ids?: string[];
      /**
       * If the race ignores manually settlement
       * @example false
       */
      ignore_winter_settlement: boolean;
    };
    /** SettleBetInput */
    SettleBetInput: {
      /**
       * the bet id
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      bet_id: string;
      /**
       * If the bet was a win bet or not
       * @default false
       * @example true
       */
      is_won?: boolean;
      /**
       * The payout of the bet
       * @example 100000
       */
      payout: number;
    };
    /** SettlePropositionInput */
    SettlePropositionInput: {
      /**
       * the id of the proposition to settle
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      proposition_id: string;
      /**
       * The result of the proposition.
       * @example WINNER
       */
      result: components['schemas']['PropositionResult'];
    };
    /** SettleRaceInput */
    SettleRaceInput: {
      /**
       * the id of the race to settle
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      race_id: string;
      /**
       * the runner number who came first
       * @example [
       *   1,
       *   2
       * ]
       */
      first_places: number[];
      /**
       * the runner number who came second
       * @example [
       *   3
       * ]
       */
      second_places: number[];
      /**
       * the runner number who came third
       * @example [
       *   4
       * ]
       */
      third_places: number[];
      /**
       * the runner number who came forth
       * @example [
       *   9,
       *   10
       * ]
       */
      forth_places: number[];
      /**
       * the runner numbers who were scratched
       * @example [
       *   11,
       *   12
       * ]
       */
      scratched: number[];
      /**
       * the runner numbers who were removed
       * @example [
       *   11,
       *   12
       * ]
       */
      removed?: number[];
    };
    /** SettleSportMarketInput */
    SettleSportMarketInput: {
      /**
       * the number of expected winners
       * @default 1
       * @example 1
       */
      expected_winners?: number;
      /** the propositions to settle */
      propositions: components['schemas']['SettlePropositionInput'][];
      /**
       * The id of the market when settle on market level.
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      market_id?: string;
    };
    /** SignupPunter */
    SignupPunter: {
      /** Sets the user to be onboarded, if included in request */
      is_onboarded?: boolean;
      /** Sets the user's title */
      title?: string;
      /** Sets the user's first name */
      first_name?: string;
      /** Sets the user's last name */
      last_name?: string;
      /** Sets the user's middle name */
      middle_name?: string;
      /** Sets the user's email */
      email?: string;
      /** Sets the user's password */
      password?: string;
      /** Sets the user's first mobile number */
      mobile?: string;
      /** Sets the user's street number */
      street_number?: string;
      /** Sets the user's street name */
      street_name?: string;
      /** Sets the user's suburb */
      suburb?: string;
      /** Sets the user's state */
      state?: string;
      /** Sets the user's post code */
      post_code?: string;
      /** Punters date of birth DD-MM-YYYY */
      date_of_birth?: string;
      /** Punter has enabled email marketing */
      email_marketing_enabled?: boolean;
      /** Punter has enabled SMS marketing */
      sms_marketing_enabled?: boolean;
      /** Punter has enabled phone marketing */
      phone_marketing_enabled?: boolean;
      /** Punter has enabled post marketing */
      post_marketing_enabled?: boolean;
      /** affiliate code of the user */
      affiliate_code?: string;
      /** appsflyer id of the user */
      appsflyer_id?: string;
      /** MyAffiliates token of the user */
      myaffiliates_token?: string;
    };
    /** SimplifiedBookiePunterTransaction */
    SimplifiedBookiePunterTransaction: {
      /**
       * The UUID for the transaction record
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      transaction_id: string;
      /**
       * date and time transaction occurred (transaction.created_at).
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      timestamp: string;
      /**
       * Type of transaction (Deposit, Withdrawal, Bet, Adjustment, ...).
       * @example Deposit
       */
      transaction_type: components['schemas']['TransactionTypes'];
      /**
       * Sub type of transaction (e.g. Single, Exotics, Credit, etc).
       * @example Single
       */
      sub_type?: string;
      /**
       * Transaction amount in cents (bets and withdrawals are negative)
       * @example 1000
       */
      amount: number;
      /**
       * Running balance resulting from this Tx
       * @example 1000
       */
      running_balance: number;
      /**
       * Transaction details
       * @example {
       *   "note": "Deposit",
       *   "reason": "Promotion"
       * }
       */
      details: Record<string, never>;
    };
    /** Sitecontent */
    Sitecontent: {
      /**
       * Type of content
       * @example static_asset
       */
      type: string;
      /** Actual content */
      content_info?: unknown;
    };
    /** SportListObject */
    SportListObject: {
      /**
       * The id of the sport.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      sport_id: string;
      /**
       * The name of the sport
       * @example Sport name
       */
      name: string;
      /**
       * The display name of the sport
       * @example Sport display name
       */
      display_name: string;
      /**
       * The sort order of the sport
       * @example 0
       */
      sort_order?: number;
      /**
       * The updated time of the sport
       * Format: date-time
       */
      updated_at?: string;
      /**
       * The sport is manually created or not
       * @example true
       */
      is_manual?: boolean;
      /**
       * The sport type
       * @example Promotional
       */
      sport_type?: string;
    };
    /** SportMarketListObject */
    SportMarketListObject: {
      /**
       * The id of the sport.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      sport_id: string;
      /**
       * the name of the sport
       * @example example
       */
      name: string;
      /**
       * The display name of the sport
       * @example example
       */
      display_name: string;
      /**
       * The sport is manually created or not
       * @example true
       */
      is_manual?: boolean;
      /** The Competition object */
      competition: components['schemas']['CompetitionMarketListObject'];
    };
    /** SportModifierInput */
    SportModifierInput: {
      /**
       * The sport ID in our database
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      sport_id?: string;
      /**
       * The competition ID in our database
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      competition_id?: string;
      /**
       * The modifier for this specific item
       * @example 2
       */
      modifier: number;
    };
    /** SportOffering */
    SportOffering: {
      /** The list of countries this below this race type */
      competitions: components['schemas']['CompetitionOffering'][];
      /**
       * The ID of this sport
       * Format: uuid
       */
      sport_id: string;
      /** The name of this sport offering */
      display_name: string;
      /** True if all venues of this race type are offered */
      all_offered: boolean;
    };
    /** SportOfferingView */
    SportOfferingView: {
      /** The list of offered sports */
      sports?: components['schemas']['SportOffering'][];
      /** True if all sports are offered */
      all_sport: boolean;
    };
    /** SportSchema */
    SportSchema: {
      /**
       * The UUID of a sport
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      sport_id: string;
      /**
       * The name of the sport
       * @example AFL
       */
      sport_name: string;
      /**
       * The display name of a sport
       * @example AFL
       */
      display_name: string;
      /**
       * Activity icon
       * @example www.google.com
       */
      icon?: string[];
    };
    /**
     * SportType
     * @description An enumeration.
     * @enum {string}
     */
    SportType: (typeof SportType)[number];
    /** SrmOfferingDTO */
    SrmOfferingDTO: {
      /**
       * Domestic SRM offering.
       * @example SrmOfferingItemDTO
       */
      domestic: components['schemas']['SrmOfferingItemDTO'];
      /**
       * International SRM offering.
       * @example SrmOfferingItemDTO
       */
      international: components['schemas']['SrmOfferingItemDTO'];
    };
    /** SrmOfferingItemDTO */
    SrmOfferingItemDTO: {
      /**
       * Whether horse market is offered
       * @example true
       */
      horse: boolean;
      /**
       * Whether greyhound market is offered
       * @example true
       */
      dog: boolean;
      /**
       * Whether harness market is offered
       * @default false
       */
      harness?: boolean;
    };
    /**
     * SrmPriceRequest
     * @description Request for price
     */
    SrmPriceRequest: {
      /**
       * The Match Id
       * Format: uuid
       * @example 12312dw234
       */
      race_id: string;
      /**
       * Selected runners for Top1-4
       * @default [
       *   [],
       *   [],
       *   [],
       *   []
       * ]
       * @example [
       *   [
       *     2,
       *     3
       *   ],
       *   [
       *     4
       *   ],
       *   [
       *     5
       *   ],
       *   []
       * ]
       */
      selection?: number[][];
    };
    /**
     * SrmPriceResponse
     * @description Response for Request for price
     */
    SrmPriceResponse: {
      /**
       * The price/odds of the SRM selections
       * @example 2.8
       */
      price?: number;
    };
    /**
     * SrmTopSelection
     * @description An enumeration.
     * @enum {string}
     */
    SrmTopSelection: (typeof SrmTopSelection)[number];
    /** StateRaceOffering */
    StateRaceOffering: {
      /** Venues */
      venues: components['schemas']['VenueOffering'][];
      /** Display Name */
      display_name: string;
      /** All Offered */
      all_offered: boolean;
    };
    /** StatementLinkSchema */
    StatementLinkSchema: {
      /**
       * month
       * @example 1
       */
      month: number;
      /**
       * the url of statement file
       * @example https://www.clickdimensions.com/links/TestPDFfile.pdf
       */
      pdf_link: string;
    };
    /**
     * States
     * @description An enumeration.
     * @enum {string}
     */
    States: (typeof States)[number];
    /** Stats */
    Stats: {
      /**
       * The amount value for this stat
       * @example 2000000000
       */
      amount: number;
      /**
       * The amount of records in this stat
       * @example 2
       */
      count: number;
    };
    /** StatsReturn */
    StatsReturn: {
      approved: components['schemas']['Stats'];
      rejected: components['schemas']['Stats'];
      cancelled: components['schemas']['Stats'];
    };
    /** StickyNoteBaseSchema */
    StickyNoteBaseSchema: {
      /**
       * The time that the sticky note was last updated
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      updated_at: string;
      /** The name of the bookie user that last updated the sticky note */
      updated_by: string;
      /** the note in the form of a 100 char string */
      text: string;
    };
    /** StickyNoteSchema */
    StickyNoteSchema: {
      /**
       * The time that the sticky note was last updated
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      updated_at: string;
      /** The name of the bookie user that last updated the sticky note */
      updated_by: string;
      /** the note in the form of a 100 char string */
      text: string;
      /**
       * the UUID of the subject punter
       * Format: uuid
       */
      punter_id: string;
    };
    /** StickyNoteUpdateSchema */
    StickyNoteUpdateSchema: {
      /** the note in the form of a 100 char string */
      text: string;
    };
    /**
     * StormConfidence
     * @description Describes the confidence level of the Storm Category for given Punter
     * @enum {string}
     */
    StormConfidence: (typeof StormConfidence)[number];
    /** StormPromotionPayload */
    StormPromotionPayload: {
      /**
       * Name of the promotion
       * @example dm_aflgrandfinal_23
       */
      name: string;
      /**
       * Type of promotion
       * @example deposit_match
       */
      type: components['schemas']['PromoType'];
      /**
       * Expiry time of the promotion
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      expiry?: string;
      /**
       * Platform ID of the promotion
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      platform_id: string;
      /** List of punters in the promotion */
      punters: components['schemas']['PromoPunter'][];
    };
    /** StormSettingsPayload */
    StormSettingsPayload: {
      /** Each list entry contains a different Punter's Storm data */
      storm_settings: components['schemas']['PunterStormSettings'][];
    };
    /** StormTokensPayload */
    StormTokensPayload: {
      /** List of punter tokens to update */
      punter_tokens: components['schemas']['PunterTokens'][];
    };
    /**
     * SupportedSortOrders
     * @description Manages the orders that our utils can sort by
     * @enum {string}
     */
    SupportedSortOrders: (typeof SupportedSortOrders)[number];
    /** SuspendInput */
    SuspendInput: {
      /**
       * Id of the object to suspend.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      id?: string;
      /**
       * The ids of the child objects to suspend
       * @example [
       *   "1",
       *   "2",
       *   "3"
       * ]
       */
      ids?: string[];
      /**
       * to suspend or un suspend the race
       * @default false
       * @example true
       */
      suspend?: boolean;
    };
    /** TableauToken */
    TableauToken: {
      /**
       * Token Status
       * @example created
       */
      message?: string;
      /**
       * Token Status
       * @example kl;wdjcnqef;kvnqwefjkv bfwer;iojkvnrt4eklvn wef;o vnhwrt4'pbnmfel;'kv nwrfgl'kbjnrtg
       */
      token?: string;
      /**
       * Tableau dashboard url
       * @example https://prod-apsoutheast-a.online.tableau.com/t/betcloud/views/LiveRiskDev/LiveRiskDev
       */
      link?: string;
    };
    /** TermsOfService */
    TermsOfService: {
      /** The terms of service for the platfrom */
      terms_of_service: string;
    };
    /** TokenSummaryItem */
    TokenSummaryItem: {
      /**
       * The type of token
       * @example spin-wheel
       */
      token_type: components['schemas']['TokenType'];
      /**
       * The number of tokens currently available
       * @example 3
       */
      available_count: number;
      /**
       * The number of tokens that have been used
       * @example 10
       */
      used_count: number;
    };
    /**
     * TokenType
     * @description An enumeration.
     * @enum {string}
     */
    TokenType: (typeof TokenType)[number];
    /** ToteSingleResults */
    ToteSingleResults: {
      /** Dividends */
      dividends?: {
        [key: string]: number | undefined;
      };
    };
    /** TradeManagerBetSchema */
    TradeManagerBetSchema: {
      /**
       * The UUID of the bet
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      bet_id: string;
      /**
       * The UUID of the bet's proposition
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      proposition_id: string;
      /**
       * The UUID of the punter that placed the bet
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      bet_punter_id: string;
      /**
       * The full name of the punter preformatted to '<first_name> <last_name>'
       * @example Rob Banks
       */
      bet_punter_name: string;
      /**
       * The type of punter that placed the bet, from Newbie to High Roller
       * @example High Roller
       */
      bet_punter_status: components['schemas']['PunterCategories'];
      /**
       * The odds of the bet that were recorded when the bet was cast
       * @example 20
       */
      bet_odds?: number;
      /**
       * The amount of money that the punter has bet
       * @example 420000
       */
      bet_stake: number;
      /**
       * Indicates whether or not it is a bonus bet
       * @example false
       */
      is_bonus_bet: boolean;
      /**
       * Current status of the bet (eg. pending, settled, voided, etc)
       * @example pending
       */
      bet_status: components['schemas']['BetStatuses'];
      /**
       * Whether the bet has been won
       * @example false
       */
      bet_won?: boolean;
      /**
       * The amount of money in cents the punter would receive if the bet wins (bet_odds * bet_stake)
       * @example 8400
       */
      potential_return: number;
      /**
       * The amount of money in cents the punter did receive. May be different to potential return due to deductions. Only populated for settled events
       * @example 8200
       */
      actual_return?: number;
      /**
       * The proposition of bet that was placed, either 'win' or 'place'
       * @example Win
       */
      proposition: components['schemas']['PropositionTypes'];
      /** List of exotic combo selections. Boxed exotics allow multiple selections for each place */
      exotic_selections?: components['schemas']['ExoticSelection'][];
      /**
       * Price type of the bet
       * @example fixed
       */
      price_type?: components['schemas']['PriceType'];
      /**
       * Promotion info for the given bet
       * @example true
       */
      promos?: components['schemas']['BetTokenSchema'][];
      /**
       * bet sequence id
       * @example 20
       */
      bet_seq_id?: number;
    };
    /**
     * TradeManagerEvent
     * @description This schema is used throughout the trade manager to denote either a race's or match's metadata
     */
    TradeManagerEvent: {
      /**
       * the id of the event in our database, race_id or match_id
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      event_id: string;
      /**
       * Denotes if the event is a race or match
       * @example Race
       */
      event_type: string;
      /**
       * The Race name or Match name for the event
       * @example Nadal vs Khachanov
       */
      event_title?: string;
      /**
       * The Competition or venue name for the event
       * @example Flemington
       */
      event_subtitle: string;
      /**
       * The time that the event will start in UTC
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      event_start_time: string;
      /**
       * The SportName or race_type for an event to support icons
       * @example Horse Racing
       */
      event_icon: string;
      /**
       * The status inferred from TAB that the event is in
       * @example Protest
       */
      event_status: components['schemas']['GeneralStatus'];
      /**
       * The total number of bets places on this event
       * @default 0
       * @example 12
       */
      total_bets?: number;
      /**
       * The total stake of all bets placed on this event, in cents
       * @default 0
       * @example 420
       */
      turnover?: number;
      /**
       * The stake of the largest bet placed on this event, in cents
       * @default 0
       * @example 180
       */
      biggest_bet?: number;
      /**
       * The Worst case exposure for all Win Place propositions
       * @default 0
       * @example 180
       */
      exposure?: number;
      /**
       * If the event is suspended
       * @default false
       * @example false
       */
      event_suspended?: boolean;
    };
    /**
     * TransactionTypes
     * @description Used to track what kind of transaction was made
     * @enum {string}
     */
    TransactionTypes: (typeof TransactionTypes)[number];
    /** UpcomingMatchesByTimeSchema */
    UpcomingMatchesByTimeSchema: {
      /**
       * Paging information
       * @default {}
       * @example PagingResponse
       */
      paging?: components['schemas']['api__meta__schemas__punter_schemas__PagingResponse'];
      /**
       * List of Upcoming Matches Sorted By Time
       * @default []
       */
      items?: components['schemas']['PunterMatchSchema'][];
      /**
       * List of main market types included in the response
       * @default []
       */
      main_market_types?: string[];
    };
    /** UpdateBookie */
    UpdateBookie: {
      /** If the user has finished onboarding, will return true */
      is_onboarded?: boolean;
      /** If the user has a first name, includes it */
      first_name?: string;
      /** If the user has a last name, includes it */
      last_name?: string;
      /** If the user has a profile image, includes it */
      profile_image_uri?: string;
    };
    /** UpdateCompetitionInput */
    UpdateCompetitionInput: {
      /**
       * the id of the competition
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      competition_id: string;
      /**
       * the new sport id of the competition
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      sport_id?: string;
      /**
       * the new name of the competition
       * @example example
       */
      name?: string;
      /**
       * the new sort order of the competition
       * @example 1
       */
      sort_order?: number;
    };
    /** UpdateCompetitionOffering */
    UpdateCompetitionOffering: {
      /** The list of competition ID's to modify. If none, will assume ALL competitions to be changed */
      competition_id_list?: string[];
      /** True if we want to set them all to offered, false if we want to un-offer them */
      is_offered: boolean;
    };
    /** UpdateDepositStatusInput */
    UpdateDepositStatusInput: {
      /**
       * The id of the deposit in our database.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      deposit_id: string;
      /**
       * The status of the deposit.
       * @example Approved
       */
      status: string;
      /**
       * Reason for deposit failure
       * @example User closed deposit window
       */
      reason?: string;
      /** JSON object returned by FZ's library in the front end */
      details?: Record<string, never>;
    };
    /** UpdateMarketGroupInput */
    UpdateMarketGroupInput: {
      /**
       * the id of the market group
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      market_group_id: string;
      /**
       * the new match id of the market group
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      match_id?: string;
      /**
       * the new title of the market group
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      name?: string;
      /**
       * the new bet options of the market group
       * @example example
       */
      bet_options?: string[];
      /**
       * the new sort order of the market group
       * @example 1
       */
      sort_order?: number;
    };
    /** UpdateMarketInput */
    UpdateMarketInput: {
      /**
       * The id of the market.
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      market_id: string;
      /**
       * The new match id of the market.
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      match_id?: string;
      /**
       * the new name of the market
       * @example example
       */
      name?: string;
      /**
       * the new market type of the market
       * @example example
       */
      market_type?: string;
      /**
       * the new bet option priority of the market
       * @example example
       */
      bet_option_priority?: string;
      /**
       * the new bet option spectrum id of the market
       * @example example
       */
      bet_option_spectrum_id?: string;
    };
    /** UpdateMatchInput */
    UpdateMatchInput: {
      /**
       * the id of the match
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      match_id: string;
      /**
       * the competition id of the match
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      competition_id?: string;
      /**
       * the tournament id of the match
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      tournament_id?: string;
      /**
       * the new name of the match
       * @example example
       */
      name?: string;
      /**
       * the new start time of the match
       * @example 2021-11-29T06:00:35
       */
      start_time?: string;
    };
    /** UpdatePriceTypesPayload */
    UpdatePriceTypesPayload: {
      /**
       * the id of the market to update
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      market_id: string;
      /**
       * The available price types for the market
       * @example [
       *   "starting"
       * ]
       */
      price_types: components['schemas']['PriceType'][];
    };
    /** UpdatePropositionInput */
    UpdatePropositionInput: {
      /**
       * The id of the proposition.
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      proposition_id: string;
      /**
       * The new market id of the proposition.
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      market_id?: string;
      /**
       * the new name of the proposition
       * @example example
       */
      name?: string;
      /**
       * the new market type of the proposition
       * @example example
       */
      proposition_type?: string;
      /**
       * the new max stake limit of the proposition
       * @example 100
       */
      max_stake_limit?: number;
      /**
       * the proposition allows multi or not
       * @example true
       */
      allow_multi?: boolean;
      /**
       * The new odds of the proposition
       * @example 1
       */
      odds?: number;
      /**
       * The new sort order of the proposition
       * @example 1
       */
      sort_order?: number;
    };
    /** UpdatePunter */
    UpdatePunter: {
      /** Sets the user to be onboarded, if included in request */
      is_onboarded?: boolean;
      /** Sets the user's first name, if included in request */
      first_name?: string;
      /** Sets the user's last name, if included in request */
      last_name?: string;
      /** Sets the user's email, if included in request */
      email?: string;
      /** Sets the user's first mobile number, if included in request */
      mobile?: string;
      /** Sets the user's street number, if included in request */
      street_number?: string;
      /** Sets the user's street name, if included in request */
      street_name?: string;
      /** Sets the user's suburb, if included in request */
      suburb?: string;
      /** Sets the user's state, if included in request */
      state?: string;
      /** Sets the user's post code, if included in request */
      post_code?: string;
      /** Punters date of birth DD-MM-YYYY */
      date_of_birth?: string;
      /** Punter has enabled email marketing */
      email_marketing_enabled?: boolean;
      /** Punter has enabled SMS marketing */
      sms_marketing_enabled?: boolean;
      /** Punter has enabled phone marketing */
      phone_marketing_enabled?: boolean;
      /** Punter has enabled post marketing */
      post_marketing_enabled?: boolean;
      /** The deposit limit for the user, that's currently active */
      deposit_limit_current?: number;
      /** The future deposit limit for the user, that's currently in a waiting period */
      deposit_limit_waiting?: number;
      /**
       * The date and time that the specific deposit limit is active from
       * Format: date-time
       */
      deposit_limit_active?: string;
      /** The frequency that the user will be able to make deposits, currently active */
      deposit_limit_frequency_current?: components['schemas']['EventFrequencies'];
      /** The frequency that the user will be able to make deposits, currently in a waiting period */
      deposit_limit_frequency_waiting?: components['schemas']['EventFrequencies'];
      /**
       * The number of days that the user will have to wait before increasing their deposit limit
       * Format: date-time
       */
      deposit_limit_cooldown_ends?: string;
    };
    /** UpdatePunterProfile */
    UpdatePunterProfile: {
      /**
       * The punter ID
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * If the payload includes has a title, update it
       * @example Mr
       */
      title?: string;
      /**
       * If the payload includes has a first name, update it
       * @example Farrokh
       */
      first_name?: string;
      /**
       * If the payload includes has a last name, update it
       * @example Bulsara
       */
      last_name?: string;
      /**
       * If the payload includes has a middle name, update it
       * @example Middle
       */
      middle_name?: string;
      /**
       * If the payload includes has a email, update it
       * @example user@appnativ.com.au
       */
      email?: string;
      /**
       * If the payload includes has a phone number, update it
       * @example 0432123456
       */
      phone_number?: string;
      /**
       * The address number in the street
       * @example 81-87
       */
      street_number?: string;
      /**
       * The name of the street
       * @example King William St
       */
      street_name?: string;
      /**
       * If the payload includes has a suburb, update it
       * @example Fitzroy
       */
      suburb?: string;
      /**
       * If the payload includes has a state, update it
       * @example Vic
       */
      state?: string;
      /**
       * If the payload includes has a postcode, update it
       * @example 3065
       */
      post_code?: string;
      /**
       * If the payload includes has a dob, update it
       * @example 1991-01-01
       */
      dob?: string;
      /**
       * If true, update the Punter's identity_verified boolean
       * @example true
       */
      verification_status?: boolean;
      /**
       * Account Status
       * @example Open
       */
      account_status?: components['schemas']['PunterStatuses'];
      /**
       * Number of days for the Temporary Self Exclusion
       * @example 30
       */
      self_exclusion_days?: number;
      /**
       * If the playload has date to follow up, update it
       * Format: date
       * @example 1991-01-01
       */
      follow_up_at?: string;
      /**
       * Status Reason
       * @example None
       */
      status_reason?: components['schemas']['PunterStatusReasons'];
    };
    /** UpdatePunterProfileReturn */
    UpdatePunterProfileReturn: {
      /**
       * The punter ID to return
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * Return the user's title
       * @example Mr
       */
      title?: string;
      /**
       * Return the user's first name
       * @example Farrokh
       */
      first_name?: string;
      /**
       * Return the user's last name
       * @example Bulsara
       */
      last_name?: string;
      /**
       * Return the user's middle name
       * @example Middle
       */
      middle_name?: string;
      /**
       * Return the user's email
       * @example user@appnativ.com.au
       */
      email?: string;
      /**
       * Return the user's phone number
       * @example 0432123456
       */
      phone_number?: string;
      /**
       * The address number in the street
       * @example 81-87
       */
      street_number?: string;
      /**
       * The name of the street
       * @example King William St
       */
      street_name?: string;
      /**
       * If the payload includes has a suburb, update it
       * @example Fitzroy
       */
      suburb?: string;
      /**
       * Return the user's state
       * @example Vic
       */
      state?: string;
      /**
       * Return the user's postcode
       * @example 3065
       */
      post_code?: string;
      /**
       * Return the user's dob
       * @example 1991-01-01
       */
      dob?: string;
      /** Return the Punter's identity_verified boolean value */
      verification_status?: boolean;
      /**
       * Account Status
       * @example Open
       */
      account_status?: components['schemas']['PunterStatuses'];
      /**
       * Number of days for the Temporary Self Exclusion
       * @example 30
       */
      self_exclusion_days?: number;
      /**
       * Expiry date for Punter's Temporary Self Exclusion
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      self_exclusion_expiry?: string;
      /**
       * Return date to follow up
       * Format: date
       * @example 1991-01-01
       */
      follow_up_at?: string;
      /**
       * Status Reason
       * @example None
       */
      status_reason?: components['schemas']['PunterStatusReasons'];
    };
    /** UpdatePunterProfileStatusExcludePermanently */
    UpdatePunterProfileStatusExcludePermanently: {
      /**
       * The punter ID
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * Status Reason
       * @example None
       */
      status_reason?: components['schemas']['PunterStatusReasons'];
    };
    /** UpdateRolesInput */
    UpdateRolesInput: {
      /** email of the bookie whose roles are being updated */
      email: string;
      /** list of roles we are assigning to that bookie */
      roles: string[];
    };
    /** UpdateSelfExclusionRequest */
    UpdateSelfExclusionRequest: {
      /**
       * Self exclusion period in days. -1 means permanent exclusion
       * @example 3
       */
      period: number;
    };
    /** UpdateVenueOffering */
    UpdateVenueOffering: {
      /** The list of venue ID's to modify. If none, will assume ALL venues to be changed */
      venue_id_list?: string[];
      /** True if we want to set them all to offered, false if we want to un-offer them */
      is_offered: boolean;
      /** The specific race type to allow all venues for. If none, sets for all race types */
      race_type?: components['schemas']['RaceTypes'];
    };
    /** UploadRequestInput */
    UploadRequestInput: {
      /**
       * The id of the upload in our database.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      upload_id?: string;
      /**
       * Type of upload
       * @example banner
       */
      related_key?: components['schemas']['UploadType'];
      /**
       * Additional information about the upload
       * @example logged_out_banner
       */
      related_val?: string;
      /**
       * JSON object with properties that related to the upload
       * @example For banners the object could include
       */
      related_data?: string;
      /**
       * Overall description of the upload
       * @example Terms and Conditions, AFL Grand Final Banner
       */
      title?: string;
      /**
       * Name of the file
       * @example terms_and_conditions_March_2023.pdf
       */
      source_filename: string;
      /**
       * File contents
       * Format: binary
       * @example binary data
       */
      file_contents: string;
    };
    /**
     * UploadRequestItem
     * @description Request item for content upload
     */
    UploadRequestItem: {
      /**
       * File contents
       * Format: binary
       * @example binary data
       */
      content: string;
      /**
       * Name of the file
       * @example beauty.jpeg
       */
      name?: string;
      /**
       * Content type of the file
       * @example application/json, image/jpeg
       */
      contentType?: string;
      /**
       * When having a value, it is used for concurrency check to fail update when data as changed since last time. Pass in value of generation or X-Goog-Generation.
       * @example 1685332990215229
       */
      version?: number;
      /**
       * Sets the cache duration (public) of object in the storage. It sets the Cache-Control header to 'public,max=<duration>'. Without value the storage defaults to 3600s.
       * @example 3600
       */
      cacheDurationSec?: number;
    };
    /**
     * UploadRequestOutput
     * @description Returns all the metadata associated to the upload
     */
    UploadRequestOutput: {
      /** Upload Id */
      upload_id: string;
      related_key: components['schemas']['UploadType'];
      /** Related Val */
      related_val?: string;
      /** Related Data */
      related_data?: string;
      /** Title */
      title?: string;
      /** Source Filename */
      source_filename: string;
      /** Uri */
      uri: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /**
     * UploadType
     * @description Type of upload, banner or T&Cs, but can be expanded to cater for just about anything, silks customer initiated uploads etc
     * @enum {string}
     */
    UploadType: (typeof UploadType)[number];
    /** VenueListView */
    VenueListView: {
      /**
       * the UUID of the venue
       * Format: uuid
       */
      venue_id: string;
      /** the name of the venue */
      venue_name: string;
      /** The display name of the venue */
      venue_display_name: string;
      /** the country the venue is in */
      venue_country: string;
      /** a list of venue races in RaceViewRow format ordered by race number */
      venue_races?: components['schemas']['VenueListViewRow'][];
      /** Priority Venue */
      priority_venue?: number;
    };
    /** VenueListViewRow */
    VenueListViewRow: {
      /**
       * the UUID of the race
       * Format: uuid
       */
      venue_id?: string;
      /**
       * the UUID of the race
       * Format: uuid
       */
      race_id: string;
      /**
       * the start time of the race
       * Format: date-time
       */
      start_time: string;
      /** the number of the race */
      race_number: number;
      /** type of race */
      race_type: components['schemas']['RaceTypes'];
      /**
       * The status of the race
       * @example Abandoned
       */
      status: components['schemas']['GeneralStatus'];
      /** Results */
      results?: components['schemas']['RunnerResults'][];
      /**
       * When is/was the race
       * Format: date
       * @example 2023-10-24
       */
      meeting_date: string;
    };
    /** VenueNameAndNotifications */
    VenueNameAndNotifications: {
      /**
       * The venue ID in our database
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      venue_id: string;
      /**
       * The display name of the venue
       * @example Sandown Park
       */
      display_name: string;
      /**
       * The number of pending notifications for this venue
       * @default 0
       * @example 1
       */
      notification_count?: number;
      /**
       * Returns False if the venue should be greyed out
       * @example true
       */
      has_races: boolean;
    };
    /** VenueOffering */
    VenueOffering: {
      /** Venue Id */
      venue_id: string;
      /** Display Name */
      display_name: string;
      /** Is Offered */
      is_offered: boolean;
      /** Venue Type */
      venue_type: string;
    };
    /** VerifiedPunter */
    VerifiedPunter: {
      /**
       * The users ID in our database
       * Format: uuid
       */
      punter_id: string;
      /** The users Firebase UID */
      firebase_uid: string;
      /** If the user has finished onboarding, will return true */
      is_onboarded: boolean;
      /** If the user's identity has been verified, will return true */
      identity_verified: boolean;
      /**
       * The platform ID for this bookie
       * Format: uuid
       */
      platform_id: string;
      /** Sets the user's title, if included in request */
      title?: string;
      /** Sets the user's first name, if included in request */
      first_name?: string;
      /** Sets the user's last name, if included in request */
      last_name?: string;
      /** Sets the user's middle name, if included in request */
      middle_name?: string;
      /** Sets the user's email, if included in request */
      email?: string;
      /** Sets the user's first mobile number, if included in request */
      mobile?: string;
      /** Sets the user's street number, if included in request */
      street_number?: string;
      /** Sets the user's street name, if included in request */
      street_name?: string;
      /** Sets the user's suburb, if included in request */
      suburb?: string;
      /** Sets the user's state, if included in request */
      state?: string;
      /** Sets the user's post code, if included in request */
      post_code?: string;
      /** Punters date of birth DD-MM-YYYY */
      date_of_birth?: string;
      /** Punter has enabled email marketing */
      email_marketing_enabled: boolean;
      /** Punter has enabled SMS marketing */
      sms_marketing_enabled: boolean;
      /** Punter has enabled phone marketing */
      phone_marketing_enabled: boolean;
      /** Punter has enabled post marketing */
      post_marketing_enabled: boolean;
      /** Punter's category uuid. The name and value used are intentionally chosen not to be obvious. */
      pc?: string;
      /** Id toolkit localId */
      localId: string;
      /** Verification id from GreenID check */
      verification_id?: string;
      /** Verification status from GreenID check */
      verification_status?: string;
      /** Verification token from GreenID check */
      verification_token?: string;
    };
    /** WithdrawBalance */
    WithdrawBalance: {
      /**
       * The amount that the punter would like to withdraw, in cents (example equates to $10.50)
       * @example 1050
       */
      amount: number;
      /**
       * The id of the bank account to withdraw from
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      bank_id: string;
    };
    /** WithdrawalDownload */
    WithdrawalDownload: {
      /**
       * The withdrawals to be downloaded
       * @default []
       * @example [
       *   "1bda22c9-a435-4be3-a831-697b24e8cae4"
       * ]
       */
      withdrawal_ids?: string[];
      /**
       * The withdrawals to be downloaded
       * @example [
       *   "New",
       *   "Exported"
       * ]
       */
      exported?: boolean;
    };
    /** WithdrawalRequestResponse */
    WithdrawalRequestResponse: {
      /**
       * ID of the record to update
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      withdrawal_id: string;
      /**
       * The amount of the request.
       * @example 10000000000000
       */
      amount: number;
      /**
       * This is for later
       * @example Don't use this.
       */
      reason?: string;
      /**
       * status of the request
       * @example Approved
       */
      status: string;
      /**
       * The id of the punter record.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id: string;
      /**
       * The name of the punter
       * @example John Doe
       */
      punter_name: string;
      /**
       * The id of the bookie record.
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      bookie_id: string;
      /**
       * The name of the bookie
       * @example John Doe
       */
      bookie_name?: string;
      /**
       * When was the request completed
       * Format: date-time
       * @example 2023-10-24
       */
      completed_at?: string;
    };
    /**
     * WithdrawalStatus
     * @description Defines the status of a manual punter withdrawal request
     * @enum {string}
     */
    WithdrawalStatus: (typeof WithdrawalStatus)[number];
    /**
     * WithdrawalStatusEnum
     * @description An enumeration.
     * @enum {string}
     */
    WithdrawalStatusEnum: (typeof WithdrawalStatusEnum)[number];
    /** WithdrawalStatusToUpdate */
    WithdrawalStatusToUpdate: {
      /**
       * New Status of the withdrawal
       * @example Approved
       */
      status: components['schemas']['WithdrawalStatus'];
      /**
       * The list of specific ids of the withdrawal to request. If this ids has value and the all_approved_exported also set to True, the ids trumps.
       * @default []
       * @example [
       *   "1bda22c9-a435-4be3-a831-697b24e8cae4"
       * ]
       */
      withdrawal_ids?: string[];
      /**
       * Whether to apply the changes to all exported and approved withdrawals. If withdrawal_ids has value, the withdrawal_ids trumps.
       * @default false
       * @example true
       */
      all_approved_exported?: boolean;
    };
    /** RecordAction */
    api__endpoints__bookie__account__bookie_account__RecordAction: {
      /** The action being performed */
      action_type: components['schemas']['ActionTypes'];
      /** information about the action preformed */
      action_info?: Record<string, never>;
      /** A short summary of the action being performed */
      action_summary?: string;
    };
    /** ResetPasswordInput */
    api__endpoints__bookie__account__bookie_account__ResetPasswordInput: {
      /** information about the action preformed */
      action_info?: Record<string, never>;
      /** A short summary of the action being performed */
      action_summary?: string;
      /**
       * Email
       * @example johndoe@mail.com
       */
      email?: string;
    };
    /** MatchSchema */
    api__endpoints__bookie__trade_manager__sport_details__MatchSchema: {
      /**
       * The UUID of a match
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      match_id: string;
      /**
       * The name of the match
       * @example Round 20
       */
      display_name: string;
      /**
       * The start time of the match
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      start_time?: string;
      /**
       * the status of the match
       * @example Abandoned
       */
      status: components['schemas']['GeneralStatus'];
    };
    /** BankSchema */
    api__endpoints__punter__account__bank__BankSchema: {
      /**
       * the id of the bank object stored in out database
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      id?: string;
      /**
       * The BSB of the bank account
       * @example 123456
       */
      bsb: string;
      /**
       * The name of the bank account
       * @example 123456
       */
      account_nick_name?: string;
      /**
       * The holder of the bank account.
       * @example John Doe
       */
      account_name: string;
      /**
       * The account number of the bank account
       * @example 123456
       */
      account_number: string;
      /**
       * The name of the bank (optional field)
       * @example ING
       */
      bank_name?: string;
      /**
       * Id of the punter
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      punter_id?: string;
      /**
       * Id of the platform
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      platform_id?: string;
    };
    /** RecordAction */
    api__endpoints__punter__account__punter_account__RecordAction: {
      /** type of action preformed */
      action_type?: components['schemas']['ActionTypes'];
      /** The summary of the action performed */
      action_summary?: string;
      /** information about the action preformed */
      action_info?: Record<string, never>;
    };
    /** ResetPasswordInput */
    api__endpoints__punter__account__punter_account__ResetPasswordInput: {
      /** The action being performed */
      action_type: string;
      /** information about the action preformed */
      action_info?: Record<string, never>;
      /** A short summary of the action being performed */
      action_summary?: string;
      /**
       * Email
       * @example johndoe@mail.com
       */
      email?: string;
      /**
       * The name of the project to reset the password for.
       * @example ggbet
       */
      firebase_project_name?: string;
    };
    /** SpecificPropositionInput */
    api__endpoints__punter__races__race_details__SpecificPropositionInput: {
      /**
       * The Id's of all the propositions to get
       * @example [
       *   "1bda22c9-a435-4be3-a831-697b24e8cae4"
       * ]
       */
      proposition_ids: string[];
    };
    /** SpecificPropositionInput */
    api__endpoints__punter__sports__sport_details__SpecificPropositionInput: {
      /**
       * The Id's of all the propositions to get
       * @example [
       *   "1bda22c9-a435-4be3-a831-697b24e8cae4"
       * ]
       */
      proposition_ids: string[];
    };
    /** BankSchema */
    api__meta__schemas__bookie_schemas__BankSchema: {
      /**
       * The 7 character BSB of the bank account, including the dash
       * @example 123-456
       */
      bsb: string;
      /**
       * The 6-10 digit account number of the bank account
       * @example 123456789
       */
      account_number: string;
      /**
       * The name of the account holder (max 26 characters)
       * @example Farrokh Bulsara
       */
      account_name: string;
      /**
       * The approved financial institution code for the bank
       * @example BAN
       */
      bank_code: string;
      /**
       * The APCA number for the bank account
       * @example 123456
       */
      apca_number: string;
    };
    /** PagingResponse */
    api__meta__schemas__bookie_schemas__PagingResponse: {
      /**
       * The next offset to use for the next page.
       * @example abc,defg
       */
      next_offset?: string;
    };
    /** MatchSchema */
    api__meta__schemas__punter_schemas__MatchSchema: {
      /**
       * The id of the match
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      match_id: string;
      /**
       * The name of the race
       * @example Round 7: Collingwood vs Carlton
       */
      match_name: string;
      /**
       * The date and time that the match starts
       * Format: date-time
       * @example 2021-11-29T06:00:35
       */
      match_start_time?: string;
      /**
       * The id of the match's sport
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      sport_id?: string;
      /**
       * The name of the match's sport
       * @example AFL
       */
      sport_name?: string;
      /**
       * The id of the match's competiton
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      competition_id?: string;
      /**
       * The name of the match's competiton
       * @example Australian Football League
       */
      competition_name?: string;
      /**
       * The id of the match's tournament (if the match is a tournament)
       * Format: uuid
       * @example 1bda22c9-a435-4be3-a831-697b24e8cae4
       */
      tournament_id?: string;
      /**
       * The name of the match's tournament (if the match is a tournament)
       * @example Premiership Cup
       */
      tournament_name?: string;
      /**
       * count of all the markets
       * @example 1
       */
      market_count?: number;
      /**
       * the status of the match
       * @example Open
       */
      status?: components['schemas']['GeneralStatus'];
      /**
       * Whether the match is suspended
       * @example false
       */
      is_suspended?: boolean;
      head_to_head_market?: components['schemas']['MarketSchema'];
      /**
       * SGM availability.
       * @default false
       * @example true
       */
      sgm_available?: boolean;
      /**
       * Match Level information used in FE display
       * @example {"participants": [{"name": "Isaro P./Suksumrarn T.", "role": null, "logo_url": null}, {"name": "Kunsuwan N./Timangkul A.", "role": null, "logo_url": null}]}
       */
      match_info?: Record<string, never>;
    };
    /** PagingResponse */
    api__meta__schemas__punter_schemas__PagingResponse: {
      /**
       * The next offset to use for the next page.
       * @example abc,defg
       */
      next_offset?: string;
    };
  };
  responses: never;
  parameters: never;
  requestBodies: never;
  headers: never;
  pathItems: never;
};

export type external = Record<string, never>;

export type operations = {
  /**
   * Is Australian
   * @description Returns True if equest has been verified by CloudFlare - otherwise not reachable - John Vesey
   */
  is_australian_generic_is_australian_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Livez
   * @description Returns Http status 200 OK
   */
  livez_generic_livez_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Config */
  config_generic_config__select_value__get: {
    parameters: {
      path: {
        select_value: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Bookie Account
   * @description Uses a firebase token to either grab an existing account, or create and return one - Matt Balshaw
   */
  bookie_account_bookie_account_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Update Bookie
   * @description Updates a bookies profile - Matt Balshaw
   */
  update_bookie_bookie_account_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateBookie'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Update Bookie Roles
   * @description Updates a bookies profile - Matt Balshaw
   */
  update_bookie_roles_bookie_account_update_roles_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateRolesInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Record Reset Password
   * @description Record if a Bookie logs in or logs out. --- Samuel Mcilwain.
   */
  record_reset_password_bookie_account_record_reset_password_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['api__endpoints__bookie__account__bookie_account__ResetPasswordInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': boolean;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Record Punter Action */
  record_punter_action_bookie_account_record_action_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['api__endpoints__bookie__account__bookie_account__RecordAction'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': boolean;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Authorisation Token */
  get_authorisation_token_bookie_account_authz_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Deposits
   * @description Get a list of deposits for a punter.
   */
  get_deposits_bookie_bank_deposits_get: {
    parameters: {
      query: {
        id: string;
        deposit_status?: components['schemas']['DepositStatuses'];
        offset?: string;
        limit?: number;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['DepositItemResponse'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Reconcile Deposit
   * @description Reconcile deposits for a punter.
   * Bookie can change the amount of the deposit.
   */
  reconcile_deposit_bookie_bank_deposits_reconcile_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['ReconcilePayload'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['DepositReconcileResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Sync Deposits */
  sync_deposits_bookie_bank_deposits_sync_post: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Fz Deposit List */
  get_fz_deposit_list_bookie_bank_deposits_fz_list_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Fz Deposit */
  get_fz_deposit_bookie_bank_deposits_fz__reference__get: {
    parameters: {
      path: {
        reference: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Pending Withdrawals
   * @description returns a list of pending withdrawals for a bookies platform - Ginger Bread Sam
   */
  get_pending_withdrawals_bookie_bank_withdrawals_status_get: {
    parameters: {
      query?: {
        status?: components['schemas']['WithdrawalStatusEnum'];
        limit?: number;
        offset?: number;
        exported?: boolean;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['GenericWithdrawalsSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Update Withdrawal Status */
  update_withdrawal_status_bookie_bank_withdrawals_status_patch: {
    requestBody: {
      content: {
        'application/json': components['schemas']['WithdrawalStatusToUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['WithdrawalRequestResponse'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Download Specified Withdrawals
   * @description Given a list of withdrawal ids, generates and returns an aba of the requested withdrawals
   *
   * [File format information](https://www.cemtexaba.com/aba-format/cemtex-aba-file-format-details)
   *
   * *Matt Balshaw*
   */
  download_specified_withdrawals_bookie_bank_withdrawals_download_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['WithdrawalDownload'];
      };
    };
    responses: {
      /** @description Returns an ABA of withdrawals */
      200: {
        content: {
          'application/json': unknown;
          'text/aba': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** History */
  history_bookie_bank_withdrawals_history_get: {
    parameters: {
      query?: {
        limit?: number;
        offset?: number;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['GenericWithdrawalsSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Stats */
  stats_bookie_bank_withdrawals_stats_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['StatsReturn'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Bet Approvals Pending */
  get_bet_approvals_pending_bookie_bet_approvals_get: {
    parameters: {
      query?: {
        limit?: number;
        offset?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['BookieBetRequestsSchema'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Bet Approvals History */
  get_bet_approvals_history_bookie_bet_approvals_history_get: {
    parameters: {
      query?: {
        limit?: number;
        offset?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['BookieBetRequestsSchema'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Claim Bet Request
   * @description Claims a specific bet request for a single bookie
   *
   * *Matt Balshaw*
   */
  claim_bet_request_bookie_bet_approvals_claim_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['BetRequestClaimInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Change Bet Request Status */
  change_bet_request_status_bookie_bet_approvals_status_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['BetRequestStatusInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': boolean;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Settle Bet Manually */
  settle_bet_manually_bookie_bet_approvals_settle_bet_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['SettleBetInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Download Bet Approvals
   * @description Returns a csv of formatted bet approval rows for a given list of ids
   * orders the csv by bet request created date
   *
   * *Matt Balshaw*
   */
  download_bet_approvals_bookie_bet_approvals_download_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['ApprovalDownloadInput'];
      };
    };
    responses: {
      /** @description Returns a CSV of the bet approvals */
      200: {
        content: {
          'application/json': unknown;
          'text/csv': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Remote Change Bet Request Status
   * @description Accepts a bet approval request from the global bet approvals system
   */
  remote_change_bet_request_status_bookie_bet_approvals_remote_update_status_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['RemoteBetRequestStatusInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': boolean;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Platform Race Offerings
   * @description Returns a data structure representing all the race types that each venue offers.
   * Uses the platform of whichever bookie is requesting the data.
   *
   * *Matt Balshaw*
   */
  get_platform_race_offerings_bookie_offerings_race_offerings_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['RaceOfferingView'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Update Venue Offering
   * @description Given a list of venue IDs, if they are to be offered or not, and optionally a specific race type, changes the bookie race venue offering - Matt Balshaw
   */
  update_venue_offering_bookie_offerings_race_offerings_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateVenueOffering'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['RaceOfferingView'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Platform Sport Offering */
  get_platform_sport_offering_bookie_offerings_sport_offerings_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['SportOfferingView'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Update Sport Offering */
  update_sport_offering_bookie_offerings_sport_offerings_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateCompetitionOffering'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['SportOfferingView'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Platform Bets
   * @description Returns a list of bets made on this platform
   * Default order by bet created_at desc
   * Supports offset paginated retrieval
   * *Matt Balshaw*
   */
  platform_bets_bookie_placed_bets_get: {
    parameters: {
      query?: {
        event_title?: string;
        event_type?: components['schemas']['EventTypes'];
        states?: string;
        is_multi?: boolean;
        is_bonus?: boolean;
        punter_name?: string;
        start_date?: string;
        end_date?: string;
        sort_by?: components['schemas']['BetsSupportedSortColumns'];
        sort_direction?: components['schemas']['SupportedSortOrders'];
        limit?: number;
        offset?: number;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['BookieBetSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Bonus Award */
  bonus_award_bookie_promos_bonus_bonus_bet_get: {
    parameters: {
      query?: {
        limit?: number;
        offset?: number;
        applied_from?: string;
        applied_to?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['BonusAwardsResponse'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Bulk Bonus Award
   * @description Bulk award punters some bonus balance.
   * Bonus balance will be added onto punters existing bonus balance.
   * Bonus amount must be greater than zero.
   *
   * *Matt Balshaw*
   */
  bulk_bonus_award_bookie_promos_bonus_bets_bulk_bonus_award_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkBonusAwardInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Bonus Award
   * @description Revoke and existing bonus transaction
   * Existing bonus_balance of the related punter will be deducted.
   */
  bonus_award_bookie_promos_bonus_bets_bonus_award_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['BonusAwardInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Bonus Revoke
   * @description Revoke a bonus award
   */
  bonus_revoke_bookie_promos_bonus_bets_bonus_revoke_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['BonusRevokeInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Add Punter Token */
  add_punter_token_bookie_promos_token_token_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['PunterTokenPayload'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Token History
   * @description Returns token history for a given token type and punter
   */
  get_token_history_bookie_promos_token_token_history_get: {
    parameters: {
      query: {
        punter_id: string;
        token_type: components['schemas']['TokenType'];
        limit?: number;
        offset?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PunterTokenHistoryResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Token Summary
   * @description Returns summary of available and used tokens for punter.
   * If no token_type is specified, will return data for all token types
   */
  get_token_summary_bookie_promos_token_token_summary_get: {
    parameters: {
      query: {
        punter_id: string;
        token_type?: components['schemas']['TokenType'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['TokenSummaryItem'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Bulk Promo Upload
   * @description Bulk create promotion for punters
   */
  bulk_promo_upload_bookie_promos_promo_bulk_promo_upload_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkPromoInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['BulkPromoResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Promo Summary
   * @description Return summary info for promotions
   */
  get_promo_summary_bookie_promos_promo_promo_summary_get: {
    parameters: {
      query: {
        promo_type: components['schemas']['PromoType'];
        limit?: number;
        offset?: string;
        applied_from?: string;
        applied_to?: string;
        sources?: string;
      };
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['PromoSource'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PromoSummaryResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Promo Punters
   * @description Return the punter list for a promotion
   */
  get_promo_punters_bookie_promos_promo_promo_punters_get: {
    parameters: {
      query: {
        promo_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': (
            | components['schemas']['DepositMatchPromoPunter']
            | components['schemas']['BonusBetPromoPunter']
          )[];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Promo Punters Csv
   * @description Return the punter list for a promotion as a CSV
   */
  get_promo_punters_csv_bookie_promos_promo_promo_punters_csv_get: {
    parameters: {
      query: {
        promo_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: never;
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Add Punter Promo
   * @description Add a promotion to an individual punter
   */
  add_punter_promo_bookie_promos_promo_promotion_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['PunterPromoInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PunterPromoResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Cancel Punter Promo
   * @description Cancel a promo
   */
  cancel_punter_promo_bookie_promos_promo_cancel_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['CancelPunterPromoPayload'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': boolean;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Upsert Statements */
  upsert_statements_bookie_punters_activity_statements_post: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Punter Account Adjustment */
  punter_account_adjustment_bookie_punters_adjustments_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['PunterAccountAdjustment'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': boolean;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Punter Bets
   * @description Returns all matching events for a given Punter,
   * with default order by bet created_at desc
   * support for offset paginated retrieval
   * *Matt Balshaw*
   */
  punter_bets_bookie_punters_bets__punter_id__get: {
    parameters: {
      query?: {
        event_title?: string;
        event_type?: components['schemas']['EventTypes'];
        states?: string;
        is_multi?: boolean;
        is_bonus?: boolean;
        punter_name?: string;
        start_date?: string;
        end_date?: string;
        sort_by?: components['schemas']['BetsSupportedSortColumns'];
        sort_direction?: components['schemas']['SupportedSortOrders'];
        limit?: number;
        offset?: number;
      };
      path: {
        punter_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['BookieBetSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Cancel Bet
   * @description Bookie refunds the stake of the specified bet
   */
  cancel_bet_bookie_punters_bets_cancel_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['CancelBet'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': Record<string, never>;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Incentives */
  get_incentives_bookie_punters_incentives_bonus_bets_get: {
    parameters: {
      query: {
        punter: string;
        limit?: number;
        offset?: number;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['BonusCreditResponse'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Punter Promotions */
  get_punter_promotions_bookie_punters_incentives_promotions_get: {
    parameters: {
      query: {
        punter_id: string;
        promo_type: components['schemas']['PromoType'];
        limit?: number;
        offset?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PunterPromotionsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Deposit Limits
   * @description Given a punter id, gets all deposit limit history for that punter,
   * including optional bookie id if bookie set deposit limit - *Daniel Morley*
   */
  get_deposit_limits_bookie_punters_limits_deposit_limit__punter_id__get: {
    parameters: {
      path: {
        punter_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['DepositLimitSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Set Deposit Limit
   * @description Sets a deposit limit by the bookie on behalf of a punter - *Daniel Morley*
   */
  set_deposit_limit_bookie_punters_limits_deposit_limit__punter_id__post: {
    parameters: {
      path: {
        punter_id: string;
      };
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DepositLimitSchema'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['UpdatePunter'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Deposit Limit
   * @description Given a punter id, gets the deposit limit for that punter,
   * including optional bookie id if bookie set deposit limit - *Daniel Morley*
   */
  get_deposit_limit_bookie_punters_limits_deposit_limit_current__punter_id__get: {
    parameters: {
      path: {
        punter_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['DepositLimitSchema'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Add Attachment
   * @description Adds attachment to specified note - Daniel Morley
   */
  add_attachment_bookie_punters_notes_attachments__note_id__post: {
    parameters: {
      path: {
        note_id: string;
      };
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AttachmentsToAdd'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['AddedAttachments'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Punter Notes */
  get_punter_notes_bookie_punters_notes_get: {
    parameters: {
      query: {
        punter_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['NoteSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Create Punter Note
   * @description Creates a punter note when sent a note in NewPunterNote format then returns that note --Aneurin Hall
   */
  create_punter_note_bookie_punters_notes_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['NewPunterNote'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['NoteSchema'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Delete Punter Note
   * @description Deletes a punter note given a punter id --Aneurin Hall
   */
  delete_punter_note_bookie_punters_notes_delete: {
    parameters: {
      query: {
        note_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': string;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Delete Attachment
   * @description When given an attachment id, attachment deleted from db
   */
  delete_attachment_bookie_punters_notes_attachment__attachment_id__delete: {
    parameters: {
      path: {
        attachment_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': string;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Update Punter Note
   * @description Updates a punter note when sent a note in NewPunterNote format then returns that note - Daniel Morley
   */
  update_punter_note_bookie_punters_notes__note_id__post: {
    parameters: {
      path: {
        note_id: string;
      };
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['NewPunterNote'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['NoteSchema'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Punter Sticky Note */
  get_punter_sticky_note_bookie_punters_punter_sticky_note__punter_id__get: {
    parameters: {
      path: {
        punter_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['StickyNoteSchema'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Update Punter Sticky Note
   * @description Upserts a punter profile sticky note when sent a note in StickyNoteUpdateSchema format then returns that note in StickyNoteSchema format
   */
  update_punter_sticky_note_bookie_punters_punter_sticky_note__punter_id__post: {
    parameters: {
      path: {
        punter_id: string;
      };
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['StickyNoteUpdateSchema'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['StickyNoteSchema'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Delete Punter Sticky Note
   * @description If such exists, sets the subject punter sticky note text to None (NULL), otherwise has no
   * effect if the punter does not have a sticky note.
   */
  delete_punter_sticky_note_bookie_punters_punter_sticky_note__punter_id__delete: {
    parameters: {
      path: {
        punter_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Add Punter Flag
   * @description Flags the subject Punter by where necessary adding a new flag table entry with a unique value of (punter_id, label)
   */
  add_punter_flag_bookie_punters_profile_add_flag_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['FlagInfo'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Delete Punter Flag
   * @description UnFlags the subject Punter removing an existing flag table entry with the unique value of (bookie_id, label)
   */
  delete_punter_flag_bookie_punters_profile_delete_flag_delete: {
    requestBody: {
      content: {
        'application/json': components['schemas']['FlagInfo'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Punter Profile
   * @description Checks to see if bookie on same platform as punter, if so, returns punter profile - Daniel Morley
   */
  get_punter_profile_bookie_punters_profile__punter_id__get: {
    parameters: {
      path: {
        punter_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PunterProfile'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Update Punter
   * @description Updates a punter profile as a bookie - Daniel Morley
   */
  update_punter_bookie_punters_profile_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdatePunterProfile'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['UpdatePunterProfileReturn'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Update Punter Status Exclude Permanently */
  update_punter_status_exclude_permanently_bookie_punters_profile_status_exclude_permanently_put: {
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdatePunterProfileStatusExcludePermanently'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Punter Metadata
   * @description Checks to see if bookie on same platform as punter, if so, returns punter metadata - Daniel Morley
   */
  get_punter_metadata_bookie_punters_profile__punter_id__meta_get: {
    parameters: {
      path: {
        punter_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Punter Search */
  punter_search_bookie_punters_search_get: {
    parameters: {
      query?: {
        query?: string;
        flag_filter?: components['schemas']['FlagFilterOption'];
        limit?: number;
        offset?: number;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PunterListObject'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Blacklist
   * @description Generate the Blacklist records from the supplied list of blacklisted punters
   * All existing blacklist records will be replaced by this new list
   */
  blacklist_bookie_punters_blacklist_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['BlacklistPayload'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Punter Stats
   * @description For the procurement of Stats for a given punter - Craig Ryan
   */
  punter_stats_bookie_punters_stats__punter_id__get: {
    parameters: {
      path: {
        punter_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PunterStats'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Punter Transactions
   * @description Get a list of transactions for a punter
   *     Notes:
   *         - If offset_timestamp is provided, it will be used instead of offset.
   */
  get_punter_transactions_bookie_punters_transactions_get: {
    parameters: {
      query: {
        punter_id: string;
        limit?: number;
        offset?: number;
        offset_utc_timestamp?: number;
        is_bonus?: boolean;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['SimplifiedBookiePunterTransaction'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Download Punter Transactions
   * @description For the punter requesting, returns a csv with all their transaction history.
   *
   * *Matt Balshaw*
   */
  download_punter_transactions_bookie_punters_transactions_download_all_get: {
    parameters: {
      query: {
        punter_id: string;
      };
    };
    responses: {
      /** @description Returns a CSV of the punters transactions */
      200: {
        content: {
          'application/json': unknown;
          'text/csv': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Punter Settings
   * @description Checks to see if bookie on same platform as punter, if so, returns punter settings
   */
  get_punter_settings_bookie_punters_punter_settings__punter_id__get: {
    parameters: {
      path: {
        punter_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PunterSettingsSchema'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Update Punter Settings
   * @description Updates a punters settings as a bookie
   */
  update_punter_settings_bookie_punters_punter_settings_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['PunterSettingsSchema'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PunterSettingsSchema'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Deposits
   * @description Get a list of deposits for a punter.
   */
  get_deposits_bookie_punters_deposits_get: {
    parameters: {
      query: {
        id: string;
        deposit_status?: components['schemas']['DepositStatuses'];
        offset?: string;
        limit?: number;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['DepositItemResponse'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Reconcile Deposit
   * @description Reconcile deposits for a punter.
   * Bookie can change the amount of the deposit.
   */
  reconcile_deposit_bookie_punters_deposits_reconcile_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['ReconcilePayload'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['DepositReconcileResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Sync Deposits */
  sync_deposits_bookie_punters_deposits_sync_post: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Fz Deposit List */
  get_fz_deposit_list_bookie_punters_deposits_fz_list_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Fz Deposit */
  get_fz_deposit_bookie_punters_deposits_fz__reference__get: {
    parameters: {
      path: {
        reference: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Punters Cards
   * @description Get all the cards for the punter in the database.
   */
  punters_cards_bookie_punters_cards__punter_id__get: {
    parameters: {
      path: {
        punter_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['CardItemResponse'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Update Card */
  update_card_bookie_punters_cards_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['BookieCardInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['CardItemResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Delete Card */
  delete_card_bookie_punters_cards_delete: {
    requestBody: {
      content: {
        'application/json': components['schemas']['BookieDeleteCardInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['CardItemResponse'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Banks
   * @description Returns all matching banks for a given Punter
   */
  get_banks_bookie_punters_banks__punter_id__get: {
    parameters: {
      path: {
        punter_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['api__endpoints__punter__account__bank__BankSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Delete Bank
   * @description Delete the matching Bank from a given Punter
   */
  delete_bank_bookie_punters_banks_delete: {
    requestBody: {
      content: {
        'application/json': components['schemas']['DeleteBankInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': Record<string, never>;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Save Myaffiliates */
  save_myaffiliates_bookie_punters_myaffiliates_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['SaveMyaffiliates'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['SaveMyaffiliates'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Punter Actions */
  punter_actions_bookie_settings_activity_log_punter_actions_get: {
    parameters: {
      query?: {
        punter_id?: string;
        start_date?: string;
        end_date?: string;
        activity_type?: string;
        limit?: number;
        offset?: number;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['ActionsSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Bookie Actions */
  bookie_actions_bookie_settings_activity_log_bookie_actions_get: {
    parameters: {
      query?: {
        start_date?: string;
        end_date?: string;
        bookie_id?: string;
        activity_type?: string;
        limit?: number;
        offset?: number;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['ActionsSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Bookies For Platform */
  bookies_for_platform_bookie_settings_activity_log_bookies_for_platform_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['BookieDisplayForSearch'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Global Exposure Limits */
  get_global_exposure_limits_bookie_settings_limits_global_exposure_limits_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['GlobalExposureLimitsSchema'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Update Global Exposure Limits */
  update_global_exposure_limits_bookie_settings_limits_global_exposure_limits_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['GlobalExposureLimitsSchema'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Bookie Profile */
  get_bookie_profile_bookie_settings_profile_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['BookieProfileResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Update Profile
   * @description Update the bookie profile,
   */
  update_profile_bookie_settings_profile_patch: {
    requestBody: {
      content: {
        'application/json': components['schemas']['BookieProfileUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['BookieProfileResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Terms Of Service
   * @description Retreives the terms of service for a platform from the database and returns them - Daniel Morley
   */
  get_terms_of_service_bookie_settings_system_terms_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['TermsOfService'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Update Terms Of Service
   * @description Updates the terms of service for a platform - Daniel Morley
   */
  update_terms_of_service_bookie_settings_system_terms_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['TermsOfService'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Privacy Policy
   * @description Retreives the privacy policy for a platform from the database and returns them - Daniel Morley
   */
  get_privacy_policy_bookie_settings_system_privacy_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PrivacyPolicy'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Update Privacy Policy
   * @description Updates the privacy policy for a platform - Daniel Morley
   */
  update_privacy_policy_bookie_settings_system_privacy_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['PrivacyPolicy'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Bank Details
   * @description Retreives the bank details for the bookie's platform from the database and returns them - *Daniel Morley*
   */
  get_bank_details_bookie_settings_system_bank_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['BankReturnSchema'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Update Platform Bank Details
   * @description Updates the bank details for a platform - *Daniel Morley*
   */
  update_platform_bank_details_bookie_settings_system_bank_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['api__meta__schemas__bookie_schemas__BankSchema'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Platform Contact Details */
  get_platform_contact_details_bookie_settings_system_contact_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Update Platform Contact Details
   * @description Updates the contact details for a platform - *Daniel Morley*
   */
  update_platform_contact_details_bookie_settings_system_contact_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['PlatformContact'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Update Permission Roles
   * @description Updates the roles that have a permission
   */
  update_permission_roles_bookie_settings_system_update_permission_roles_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['Permission'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get All Permissions
   * @description Retrieves all permissions and their assigned roles
   */
  get_all_permissions_bookie_settings_system_permissions_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['Permission'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get System Offerings
   * @description Retrieves system offerings
   */
  get_system_offerings_bookie_settings_system_offerings_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['Offerings'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Update System Offerings
   * @description Updates system offerings
   */
  update_system_offerings_bookie_settings_system_offerings_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['Offerings'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['Offerings'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Offerings Srm */
  get_offerings_srm_bookie_settings_system_offerings_srm_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['SrmOfferingDTO'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Update Offerings Srm */
  update_offerings_srm_bookie_settings_system_offerings_srm_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['SrmOfferingDTO'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['SrmOfferingDTO'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Bookie Profile */
  get_bookie_profile_bookie_options_punter_categories_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Update Storm Settings
   * @description Endpoint to ingest storm punter settings
   *
   * Its an all or nothing affair. To ensure absolute certainty of affected Punter Settings the return
   * verifies the mods by returning a list of punter_id
   *
   * Returns: a list of the supplied Punter_id values as list[str]
   */
  update_storm_settings_bookie_storm_load_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['StormSettingsPayload'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Update Storm Tokens
   * @description Endpoint to ingest tokens from storm
   *
   * Returns: a list of the supplied Punter_id values as list[str]
   */
  update_storm_tokens_bookie_storm_tokens_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['StormTokensPayload'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Update Storm Promos
   * @description Endpoint to ingest promotions from storm
   *
   * Returns: a list of the supplied Punter_id values as list[str]
   */
  update_storm_promos_bookie_storm_promotions_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['StormPromotionPayload'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Tableau Token */
  get_tableau_token_bookie_scoreboard_tableau_token_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['TableauToken'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Country And States
   * @description Given a race type (optional) return all locations (country and state) offered by the bookies platform - Craig
   * Ryan
   */
  get_country_and_states_bookie_trade_manager_by_racing_locations_get: {
    parameters: {
      query?: {
        race_type?: components['schemas']['RaceTypes'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['CountryStates'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Venue Name And Notifications
   * @description Given a race type, state, and country, return all the venues which the bookies' platform offers,
   * and indicate if the venue has any races - Matt Balshaw
   */
  get_venue_name_and_notifications_bookie_trade_manager_by_racing_venues_get: {
    parameters: {
      query?: {
        race_type?: components['schemas']['RaceTypes'];
        state?: string;
        country?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['VenueNameAndNotifications'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * By Racing
   * @description Generic endpoint for grabbing data for the by racing tab -- Aneurin Hall
   * params:
   * - race_type: (optional) filter by race_type
   * - state: (optional) filter by venue state (domestic only)
   * - country: (optional) filter by country (international only)
   * - venue_id: (optional) filter by a given venue UUID
   * - resulted: (optional) filter by whether results have been announced
   * - period_start: (optional) get dates after a certain datetime
   * - period_end: (optional) get dates before a certain datetime, if period_start not set defaults to now
   * - offset: the record to start from, default 0
   * - limit: the number of records to show on each page, default 20
   * - sort_by: the key to sort records by ("start_time" or "event_title")
   * - sort_direction: the direction to sort records by ("asc" or "desc"), default asc
   */
  by_racing_bookie_trade_manager_by_racing_get: {
    parameters: {
      query?: {
        race_type?: components['schemas']['RaceTypes'];
        state?: components['schemas']['States'];
        country?: string;
        venue_id?: string;
        resulted?: boolean;
        race_status?: components['schemas']['GeneralStatus'];
        start_date?: string;
        end_date?: string;
        offset?: number;
        limit?: number;
        sort_by?: components['schemas']['EventSupportedSortColumns'];
        sort_direction?: components['schemas']['SupportedSortOrders'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['TradeManagerEvent'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get All Sports
   * @description Returns all sports where the bookie offers at least one competition -- Matt Balshaw
   */
  get_all_sports_bookie_trade_manager_by_sport_sport_list_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['SportSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Competitions Tournaments For Sport
   * @description Given a sport id, returns all competitions and tournaments  -- Aneurin Hall
   */
  get_competitions_tournaments_for_sport_bookie_trade_manager_by_sport_competitions_tournaments_for_sport_get: {
    parameters: {
      query: {
        sport_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['CompetitionView'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get By Sport
   * @description Returns all matching events with default order by start_time asc with support for
   * offset paginated retrieval -- Dean Brown
   */
  get_by_sport_bookie_trade_manager_by_sport_get: {
    parameters: {
      query?: {
        sport_id?: string;
        competition_id?: string;
        tournament_id?: string;
        resulted?: boolean;
        start_date?: string;
        end_date?: string;
        has_bets?: boolean;
        sort_by?: components['schemas']['EventSupportedSortColumns'];
        sort_direction?: components['schemas']['SupportedSortOrders'];
        limit?: number;
        offset?: number;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['TradeManagerEvent'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Find An Event
   * @description Endpoint to grab events for the find an event tab
   *
   * - event_name: (optional) fulltext search the event name
   * - sport_id: (optional) filter by the UUID of a sport
   * - race_type: (optional) filter by race_type
   * - competition_id: (optional) filter by the UUID of a competition
   * - tournament_id: (optional) filter by the UUID of a tournament
   * - resulted: (optional) filter by whether results have been announced
   * - start_date: (optional) filter by a given date in YYYY-MM-DD format
   * - end_date: (optional) upper bound to get a date slice in YYYY-MM-DD format
   * - offset: the record to start from, default 0
   * - limit: the number of records to show on each page, default 20
   * - sort_by: the key to sort records by ("start_time" or "event_title")
   * - sort_direction: the direction to sort records by ("asc" or "desc"), default asc
   *
   * *Matt Balshaw*
   */
  find_an_event_bookie_trade_manager_find_an_event_get: {
    parameters: {
      query?: {
        event_name?: string;
        sport_id?: string;
        race_type?: components['schemas']['RaceTypes'];
        competition_id?: string;
        tournament_id?: string;
        resulted?: boolean;
        start_date?: string;
        end_date?: string;
        offset?: number;
        limit?: number;
        sort_by?: components['schemas']['EventSupportedSortColumns'];
        sort_direction?: components['schemas']['SupportedSortOrders'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['TradeManagerEvent'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Global Sport Margin
   * @description Gets the global margin from the platform table - Matt Balshaw
   */
  get_global_sport_margin_bookie_trade_manager_global_margins_global_sport_margin_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': number;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Change Global Sport Margin
   * @description Updates the global sport margin on the platform table - Matt Balshaw
   */
  change_global_sport_margin_bookie_trade_manager_global_margins_global_sport_margin_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['GlobalMarginModifierInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': number;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Global Race Margin
   * @description Gets the global race from the platform table - Matt Balshaw
   */
  get_global_race_margin_bookie_trade_manager_global_margins_global_race_margin_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': number;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Change Global Race Margin
   * @description Updates the global race margin on the platform table - Matt Balshaw
   */
  change_global_race_margin_bookie_trade_manager_global_margins_global_race_margin_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['GlobalMarginModifierInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': number;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Sport Margins
   * @description Returns a list of all modified sports for the bookies platform, with modified competitions nested into each
   * sport - Matt Balshaw
   */
  get_sport_margins_bookie_trade_manager_global_margins_sport_margins_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['GlobalSportModifier'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Edit Sport And Competition Margins
   * @description Frontend is going to send us a flat list of sports and competitions, and anything missing should be deleted -
   * Matt Balshaw
   */
  edit_sport_and_competition_margins_bookie_trade_manager_global_margins_sport_margins_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['SportModifierInput'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['GlobalSportModifier'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Race Margins
   * @description Returns a list of all modified race types for the bookies platform, with modified venues nested into each race
   * type - Matt Balshaw
   */
  get_race_margins_bookie_trade_manager_global_margins_race_margins_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['GlobalRaceTypeModifier'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Edit Race Type And Venue Margins
   * @description Frontend is going to send us a flat list of race types and venues with race type, and anything missing should
   * be deleted - Matt Balshaw
   */
  edit_race_type_and_venue_margins_bookie_trade_manager_global_margins_race_margins_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['RaceModifierInput'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['GlobalRaceTypeModifier'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Multi View */
  get_multi_view_bookie_trade_manager_multi_get: {
    parameters: {
      query?: {
        event_id?: string;
        limit?: number;
        offset?: number;
        is_multi_monitor?: boolean;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['MultiViewBetSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Next To Jump
   * @description Returns all matching events with default order by start_time asc with support for
   * cursor paginated retrieval from a next_start_time, optionally only for
   * one specific event type.
   *
   * Filters out any events not on this bookies platform.
   *
   * Ascending sort, so last_value is MIN value
   *
   * *Dean Brown*
   */
  get_next_to_jump_bookie_trade_manager_next_to_jump_get: {
    parameters: {
      query?: {
        event_type?: components['schemas']['EventTypes'];
        next_start_time?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['TradeManagerEvent'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Next Jump Races
   * @deprecated
   * @description Returns all the races ordered by next to jump first, optionally only for one specific race type.
   * Filters out any races not on this bookies platform, and any races that don't have the "normal" status
   *
   * *Matt Balshaw*
   */
  get_next_jump_races_bookie_trade_manager_next_to_jump_races_get: {
    parameters: {
      query?: {
        race_type?: components['schemas']['RaceTypes'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['RaceMetaData'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Race Data
   * @description Given a race id, returns all the data for that race including runners - Matt Balshaw
   */
  get_race_data_bookie_trade_manager_race_details_get: {
    parameters: {
      query: {
        race_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['BookieRaceObject'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Race Numbers For Venue
   * @description Given a race id get the venue its offered at and return the race numbers -- Samuel Flynn.
   */
  race_numbers_for_venue_bookie_trade_manager_race_details_race_numbers_for_venue_get: {
    parameters: {
      query: {
        race_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['RaceNumbersForVenues'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Edit Multiple Race Runner Margins */
  edit_multiple_race_runner_margins_bookie_trade_manager_race_details_runner_margins_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['RaceRunnerModifierInput'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['BookieRaceObject'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Bets For Runner
   * @description Given a race_runner UUID returns a list of bets associated with that RaceRunner -- Matt Balshaw
   */
  get_bets_for_runner_bookie_trade_manager_race_details_bets_for_runner_get: {
    parameters: {
      query: {
        race_runner: string;
        limit?: number;
        offset?: number;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['TradeManagerBetSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Runners For Race
   * @description Given a race_id returns a formatted list of runners, ordered by barrier number -- Matt Balshaw
   */
  get_runners_for_race_bookie_trade_manager_race_details_runners_get: {
    parameters: {
      query: {
        race_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['BookieRaceRunner'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Race Results
   * @description Given a race id, returns the runners who resulted in the race with their final odds
   *
   * Note: This is legit duplicated code from the endpoint punter/races/race-details/race-results
   *
   * I decided to duplicate the code to keep bookie & punter decoupled,
   * also because we may change this endpoint to return some bookie specific info
   *
   * *Matt Balshaw*
   */
  race_results_bookie_trade_manager_race_details_race_result_get: {
    parameters: {
      query: {
        race_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['RaceResultRow'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Settle Race */
  settle_race_bookie_trade_manager_race_details_settle_race_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['SettleRaceInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Race Markets */
  race_markets_bookie_trade_manager_race_details_race_markets_get: {
    parameters: {
      query: {
        race_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['MarketResponse'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Exotic Bets For Race
   * @description Given a race_id UUID returns a list of exotic bets associated with that Race
   */
  get_exotic_bets_for_race_bookie_trade_manager_race_details_bets_for_exotics_get: {
    parameters: {
      query: {
        race_id: string;
        limit?: number;
        offset?: number;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['TradeManagerBetSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Fptp Protest Override */
  fptp_protest_override_bookie_trade_manager_race_details_fptp_protest_override_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['FPTPProtestOverride'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Lock Price */
  lock_price_bookie_trade_manager_race_details_lock_price_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['LockPriceInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Force Price Type Approvals */
  force_price_type_approvals_bookie_trade_manager_race_details_force_price_type_approval_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['ForcePriceTypeApprovalPayload'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Update Price Types */
  update_price_types_bookie_trade_manager_race_details_update_price_types_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdatePriceTypesPayload'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['UpdatePriceTypesPayload'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Runner Status Update */
  runner_status_update_bookie_trade_manager_race_details_manual_runner_status_update_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['RunnerStatusUpdateInput'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Refresh Winter Race */
  refresh_winter_race_bookie_trade_manager_race_details_refresh_winter_race_get: {
    parameters: {
      query: {
        /** @description ID of the race */
        race_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Refresh Winter Meets */
  refresh_winter_meets_bookie_trade_manager_race_details_refresh_winter_meets_get: {
    parameters: {
      query: {
        /** @description ID of the race */
        race_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Race Status Update */
  race_status_update_bookie_trade_manager_race_details_manual_race_status_update_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['RaceStatusUpdateInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Update Match Settings */
  update_match_settings_bookie_trade_manager_race_details_races__race_id__settings_patch: {
    parameters: {
      path: {
        race_id: string;
      };
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RaceSettingsDTO'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['RaceSettingsDTO'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Matches Of Same Competition Tournament
   * @description Given a match UUID returns all matches in the same competition, or tournament if match has tournament -- Craig Ryan
   */
  matches_of_same_competition_tournament_bookie_trade_manager_sport_details_matches_of_same_competition_tournament_get: {
    parameters: {
      query: {
        match_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['api__endpoints__bookie__trade_manager__sport_details__MatchSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Match Data
   * @description Given a match id, returns all the data for that match - Craig Ryan
   */
  get_match_data_bookie_trade_manager_sport_details_match_get: {
    parameters: {
      query: {
        match_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['BookieMatchObject'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Refresh Winter Match */
  refresh_winter_match_bookie_trade_manager_sport_details_refresh_winter_match_get: {
    parameters: {
      query: {
        /** @description ID of the event */
        match_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Match Margin
   * @description Given a market id, update the margin --- Samuel Flynn.
   */
  match_margin_bookie_trade_manager_sport_details_match_margin_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['ModifierInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['ModifierResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Market Margin
   * @description Given a market id and modifier, update the margin on the market - Samuel Flynn.
   */
  market_margin_bookie_trade_manager_sport_details_market_margin_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['ModifierInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['MarketMarginResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Proposition Margin
   * @description Given a proposition id and modifier, update the margin on the proposition - Samuel Flynn.
   */
  proposition_margin_bookie_trade_manager_sport_details_proposition_margin_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['ModifierInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PropositionMarginResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Market Types For Match
   * @deprecated
   * @description Given a match UUID returns list containing market types (no order guarantees) -- Aneurin Hall
   */
  get_market_types_for_match_bookie_trade_manager_sport_details_market_types_for_match_get: {
    parameters: {
      query: {
        match_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': string[];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Markets For Match Market Type
   * @deprecated
   * @description given a match and a market type returns all markets and propositions -- Aneurin Hall
   */
  get_markets_for_match_market_type_bookie_trade_manager_sport_details_markets_for_match_market_type_get: {
    parameters: {
      query: {
        match_id: string;
        market_type: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['MatchView'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Propositions For Market Id */
  get_propositions_for_market_id_bookie_trade_manager_sport_details_proposition_for_market_get: {
    parameters: {
      query: {
        market_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PropsForMarket'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Bets For Market
   * @description Given a market UUID returns a list of details for each bets in the market.
   * This includes details of the punter that made the bet, the proposition type and the odds,
   * stake and status of the bet. - *Daniel Morley*
   */
  get_bets_for_market_bookie_trade_manager_sport_details_bets_for_market_get: {
    parameters: {
      query: {
        market_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['TradeManagerBetSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Market Groups
   * @description Given a match id returns all of the market groups - *Daniel Morley*
   */
  get_market_groups_bookie_trade_manager_sport_details_market_groups__match_id__get: {
    parameters: {
      path: {
        match_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['MarketGroupsSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Markets For Group Id
   * @description Given a match id and a market group id returns all of the markets in that group.
   * This endpoint replaces markets-for-match-market-type - *Daniel Morley*
   */
  get_markets_for_group_id_bookie_trade_manager_sport_details_markets_get: {
    parameters: {
      query: {
        match_id: string;
        market_group_id?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['MatchView'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Void Match */
  void_match_bookie_trade_manager_sport_details_void_match_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['MatchToVoid'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Void Market */
  void_market_bookie_trade_manager_sport_details_void_market_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['MarketToVoid'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Void Proposition */
  void_proposition_bookie_trade_manager_sport_details_void_proposition_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['PropositionToVoid'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Settle Sport Market */
  settle_sport_market_bookie_trade_manager_sport_details_settle_sport_market_propositions_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['SettleSportMarketInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Suspend Match */
  suspend_match_bookie_trade_manager_sport_details_suspend_match_patch: {
    requestBody: {
      content: {
        'application/json': components['schemas']['SuspendInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Suspend Proposition */
  suspend_proposition_bookie_trade_manager_sport_details_suspend_proposition_patch: {
    requestBody: {
      content: {
        'application/json': components['schemas']['SuspendInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Open Close Market */
  open_close_market_bookie_trade_manager_sport_details_open_close_market_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['CloseMatchMarketInput'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Open Close Proposition */
  open_close_proposition_bookie_trade_manager_sport_details_open_close_proposition_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['CloseMatchPropositionInput'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Match Markets */
  match_markets_bookie_trade_manager_sport_details_match_markets_get: {
    parameters: {
      query: {
        match_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['MarketResponse'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Set Ignore Winter Settlement For Sports */
  set_ignore_winter_settlement_for_sports_bookie_trade_manager_sport_details_set_ignore_winter_settlement_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['SetSportsIgnoreWinterSettlementInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Update Match Settings */
  update_match_settings_bookie_trade_manager_sport_details_matches__match_id__settings_patch: {
    parameters: {
      path: {
        match_id: string;
      };
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['MatchSettingsDTO'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['MatchSettingsDTO'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Add Sport */
  add_sport_bookie_trade_manager_market_creation_add_sport_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['AddSportInput'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Sports
   * @description Pagination is not applied because the whole result needs to be returned to FE
   */
  get_sports_bookie_trade_manager_market_creation_get_sport_get: {
    parameters: {
      query?: {
        sport_id?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['SportListObject'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Add Competition */
  add_competition_bookie_trade_manager_market_creation_add_competition_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['AddCompetitionInput'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Update Competition */
  update_competition_bookie_trade_manager_market_creation_update_competition_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateCompetitionInput'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Competitions
   * @description Pagination is not applied because the whole result needs to be returned to FE
   */
  get_competitions_bookie_trade_manager_market_creation_get_competition_get: {
    parameters: {
      query?: {
        sport_id?: string;
        competition_id?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['CompetitionListObject'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Add Match */
  add_match_bookie_trade_manager_market_creation_add_match_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['AddMatchInput'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Update Match */
  update_match_bookie_trade_manager_market_creation_update_match_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateMatchInput'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Matches
   * @description Pagination is not applied because the whole result needs to be returned to FE
   */
  get_matches_bookie_trade_manager_market_creation_get_match_get: {
    parameters: {
      query?: {
        match_id?: string;
        competition_id?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['MatchListObject'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Add Market Group */
  add_market_group_bookie_trade_manager_market_creation_add_market_group_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['AddMarketGroupInput'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Update Market Group */
  update_market_group_bookie_trade_manager_market_creation_update_market_group_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateMarketGroupInput'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Market Group
   * @description Pagination is not applied because the whole result needs to be returned to FE
   */
  get_market_group_bookie_trade_manager_market_creation_get_market_group_get: {
    parameters: {
      query?: {
        match_id?: string;
        market_group_id?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['MarketGroupListObject'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Add Market */
  add_market_bookie_trade_manager_market_creation_add_market_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['AddMarketInput'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Update Market */
  update_market_bookie_trade_manager_market_creation_update_market_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateMarketInput'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Market
   * @description Pagination is not applied because the whole result needs to be returned to FE
   */
  get_market_bookie_trade_manager_market_creation_get_market_get: {
    parameters: {
      query?: {
        limit?: number;
        offset?: number;
        match_id?: string;
        market_id?: string;
        is_manual?: boolean;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['MarketListObject'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Delete Market */
  delete_market_bookie_trade_manager_market_creation_delete_market_delete: {
    requestBody: {
      content: {
        'application/json': components['schemas']['DeleteMarketInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Add Proposition */
  add_proposition_bookie_trade_manager_market_creation_add_proposition_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['AddPropositionInput'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Update Proposition */
  update_proposition_bookie_trade_manager_market_creation_update_proposition_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdatePropositionInput'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Proposition
   * @description Pagination is not applied because the whole result needs to be returned to FE
   */
  get_proposition_bookie_trade_manager_market_creation_get_proposition_get: {
    parameters: {
      query?: {
        market_id?: string;
        proposition_id?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PropositionListObject'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Sport Market
   * @description Pagination is not applied because the whole result needs to be returned to FE
   */
  get_sport_market_bookie_trade_manager_market_creation_get_sport_market_get: {
    parameters: {
      query: {
        market_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['SportMarketListObject'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Sgmultis Monitor Stats */
  get_sgmultis_monitor_stats_bookie_trade_manager_sgmultis_get: {
    parameters: {
      query?: {
        resulted?: boolean;
        start_date?: string;
        end_date?: string;
        limit?: number;
        offset?: string;
        sort_by?: components['schemas']['SGMultiMonitorSortBy'];
        sort_order?: components['schemas']['SGMultiBetSortOrder'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['SGMultisMonitorResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Match Bets */
  get_match_bets_bookie_trade_manager_sgmultis_bets_get: {
    parameters: {
      query: {
        match_id: string;
        limit?: number;
        offset?: string;
        sort_by?: components['schemas']['SGMultiBetSortBy'];
        sort_order?: components['schemas']['SGMultiBetSortOrder'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['SGMultisBetsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Match Propositions */
  get_match_propositions_bookie_trade_manager_sgmultis_propositions_get: {
    parameters: {
      query: {
        match_id: string;
        limit?: number;
        offset?: string;
        sort_by?: components['schemas']['SGMultisPropositionSortBy'];
        sort_order?: components['schemas']['SGMultiBetSortOrder'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['SGMultisPropositionStatsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Match Combinations */
  get_match_combinations_bookie_trade_manager_sgmultis_combinations_get: {
    parameters: {
      query: {
        match_id: string;
        limit?: number;
        offset?: string;
        sort_by?: components['schemas']['SGMultisMatchCombinationsSortBy'];
        sort_order?: components['schemas']['SGMultiBetSortOrder'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['SGMultisCombinationStatsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Srmultis Monitor Stats */
  get_srmultis_monitor_stats_bookie_trade_manager_srmultis_get: {
    parameters: {
      query?: {
        resulted?: boolean;
        start_date?: string;
        end_date?: string;
        limit?: number;
        offset?: string;
        sort_by?: components['schemas']['SRMultiMonitorSortBy'];
        sort_order?: components['schemas']['SRMultiSortOrder'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['SRMultisMonitorResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Race Bets */
  get_race_bets_bookie_trade_manager_srmultis_bets_get: {
    parameters: {
      query: {
        race_id: string;
        limit?: number;
        offset?: string;
        sort_by?: components['schemas']['SRMultiRaceBetsSortBy'];
        sort_order?: components['schemas']['SRMultiBetSortOrder'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['SRMultisRaceBetsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Race Runners */
  get_race_runners_bookie_trade_manager_srmultis_runners_get: {
    parameters: {
      query: {
        race_id: string;
        limit?: number;
        offset?: string;
        sort_by?: components['schemas']['SRMultiRaceRunnersSortBy'];
        sort_order?: components['schemas']['SRMultiBetSortOrder'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['SRMultisRaceRunnerStatsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Race Combinations */
  get_race_combinations_bookie_trade_manager_srmultis_combinations_get: {
    parameters: {
      query: {
        race_id: string;
        limit?: number;
        offset?: string;
        sort_by?: components['schemas']['SRMultiRaceCombinationsSortBy'];
        sort_order?: components['schemas']['SRMultiBetSortOrder'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['SRMultisRaceCombinationStatsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Race Combination Punters */
  get_race_combination_punters_bookie_trade_manager_srmultis_combination_punters_get: {
    parameters: {
      query: {
        multi_uid: string;
        limit?: number;
        offset?: string;
        sort_by?: components['schemas']['SRMultiRaceCombinationsSortBy'];
        sort_order?: components['schemas']['SRMultiBetSortOrder'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['SRMultisRaceCombinationPunterStatsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get All Bets */
  get_all_bets_bookie_trade_manager_blended_all_bets_get: {
    parameters: {
      query: {
        race_id: string;
        limit?: number;
        offset?: string;
        sort_order?: components['schemas']['BetResultSortOrder'];
        sort_by?: components['schemas']['BetResultSortField'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['BlendedBetsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Runners */
  get_runners_bookie_trade_manager_blended_runners_get: {
    parameters: {
      query: {
        race_id: string;
        limit?: number;
        offset?: string;
        sort_order?: components['schemas']['BetResultSortOrder'];
        sort_by?: components['schemas']['BetResultSortField'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['BlendedRaceRunnerStatsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Combinations */
  get_combinations_bookie_trade_manager_blended_combinations_get: {
    parameters: {
      query: {
        race_id: string;
        limit?: number;
        offset?: string;
        sort_order?: components['schemas']['BetResultSortOrder'];
        sort_by?: components['schemas']['BetResultSortField'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['BlendedCombinationStatsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Combination Punters */
  get_combination_punters_bookie_trade_manager_blended_combination_punters_get: {
    parameters: {
      query: {
        multi_uid: string;
        limit?: number;
        offset?: string;
        sort_by?: components['schemas']['BetResultSortField'];
        sort_order?: components['schemas']['BetResultSortOrder'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['BlendedCombinationPunterStatsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Policies
   * @description Returns terms and conditions upload information
   */
  get_policies_bookie_uploads_policies__get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['UploadRequestOutput'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Upsert Policy
   * @description Returns terms and conditions upload information
   */
  upsert_policy_bookie_uploads_policies__post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['UploadRequestInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Delete Policy
   * @description Returns terms and conditions upload information
   */
  delete_policy_bookie_uploads_policies__upload_id__delete: {
    parameters: {
      path: {
        upload_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Bets */
  get_bets_bookie_regulator_bets_get: {
    parameters: {
      query?: {
        start_date?: string;
        end_date?: string;
        name?: string;
        email?: string;
        bet_id?: string;
        limit?: number;
        offset?: number;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Download Bets */
  download_bets_bookie_regulator_download_bets_get: {
    parameters: {
      query?: {
        start_date?: string;
        end_date?: string;
        name?: string;
        email?: string;
        bet_id?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Transactions */
  get_transactions_bookie_regulator_transactions_get: {
    parameters: {
      query: {
        start_date: string;
        end_date: string;
        name?: string;
        email?: string;
        limit?: number;
        offset?: number;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Download Aud Transactions
   * @description Returns a csv with all their transaction history.
   */
  download_aud_transactions_bookie_regulator_download_transactions_get: {
    parameters: {
      query: {
        start_date: string;
        end_date: string;
        name?: string;
        email?: string;
      };
    };
    responses: {
      /** @description Returns a CSV of the punters transactions */
      200: {
        content: {
          'application/json': unknown;
          'text/csv': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Upsert State
   * @description Uploads the banner's state into the blob store
   */
  upsert_state_bookie_banners_state_put: {
    requestBody: {
      content: {
        'application/json': components['schemas']['UploadRequestItem'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Upsert Images
   * @description Uploads the banner images into the blob store
   */
  upsert_images_bookie_banners_images_put: {
    requestBody: {
      content: {
        'application/json': components['schemas']['UploadRequestItem'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Upsert Side Nav
   * @description Uploads the side nav settings into the blob store
   */
  upsert_side_nav_bookie_cms_side_nav_put: {
    requestBody: {
      content: {
        'application/json': components['schemas']['UploadRequestItem'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Record Reset Password
   * @description Record if a Bookie logs in or logs out. --- Samuel Mcilwain.
   */
  record_reset_password_punter_account_record_reset_password_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['api__endpoints__punter__account__punter_account__ResetPasswordInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': boolean;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Record Punter Action */
  record_punter_action_punter_account_record_action_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['api__endpoints__punter__account__punter_account__RecordAction'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': boolean;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Punter Account Status
   * @description Uses a firebase token to either grab an existing punter account, or create and return one - Daniel Morley
   */
  punter_account_status_punter_account_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['FullPunter'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Update Punter
   * @description Updates a punter's profile - Daniel Morley
   */
  update_punter_punter_account_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdatePunter'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['UpdatePunter'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Punter Supported Bets */
  get_punter_supported_bets_punter_account_supported_bets_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PunterBetSupportSchema'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Deposit Limit
   * @description Returns the current deposit limit for the punter, along with the frequency and when it was last updated.
   * If there is a cooldown period active, this will also be returned along with the future limit - *Daniel Morley*
   */
  get_deposit_limit_punter_account_deposit_limit_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['DepositLimitReturn'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Set Deposit Limit
   * @description Sets a deposit limit for the punter is also the last onboarding step - Daniel Morley
   */
  set_deposit_limit_punter_account_deposit_limit_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['DepositLimitSchema'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['UpdatePunter'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Verify Punter
   * @description Initiates a verification session from the punter endpoint --Aneurin Hall
   */
  verify_punter_punter_account_verify_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['GreenIDVerificationSchema'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Punter Overview */
  punter_overview_punter_account_overview_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['Overview'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Bets For Race
   * @description Given a race_id UUID returns a list of bets associated with that Race for a specific punter
   */
  get_bets_for_race_punter_account_bets_for_race_get: {
    parameters: {
      query: {
        race_id: string;
        price_type?: components['schemas']['PriceType'][];
        bet_type?: components['schemas']['BetType'][];
        status?: components['schemas']['BetStatuses'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PunterAccountBetSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** My Bets */
  my_bets_punter_account_my_bets_get: {
    parameters: {
      query?: {
        states?: string[];
        limit?: number;
        offset?: number;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PunterBetSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** My Bets Counts */
  my_bets_counts_punter_account_my_bets_counts_get: {
    parameters: {
      query?: {
        states?: string;
        is_bonus?: boolean;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PagingSchema'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Bet Approvals Pending */
  get_bet_approvals_pending_punter_account_bet_requests_get: {
    parameters: {
      query?: {
        states?: string;
        requests?: string;
        limit?: number;
        offset?: string;
        sort_by?: components['schemas']['BetRequestsSupportedSortColumns'];
        sort_direction?: components['schemas']['SupportedSortOrders'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PunterBetRequestsPageSchema'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Withdraw Balance
   * @description Create a withdrawal request on the punter's account - Daniel Morley
   */
  withdraw_balance_punter_account_withdraw_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['WithdrawBalance'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['RequestedWithdrawView'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Delete Punter Withdrawal Request
   * @description Cancels/deletes a withdrawal request for the punter
   * but only if the request is still pending - *Daniel Morley*
   */
  delete_punter_withdrawal_request_punter_account_withdrawal__request_id__delete: {
    parameters: {
      path: {
        request_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * View Requested Withdrawals
   * @description Gets all of the current (not completely processed) withdrawal requests, ordered by date, most recent first - *Daniel Morley*
   */
  view_requested_withdrawals_punter_account_requested_withdrawals_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['RequestedWithdrawView'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Update Self Exclusion
   * @description Set self exclusion for the punter
   */
  update_self_exclusion_punter_account_self_exclusion_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateSelfExclusionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Close Account
   * @description Close customer account
   */
  close_account_punter_account_close_post: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Generate Zoho Token */
  generate_zoho_token_punter_account_zoho_token_get: {
    parameters: {
      query: {
        is_mobile: boolean;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['GenerateZohoTokenResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Preference
   * @description Retrieve punter preferencs
   */
  get_preference_punter_account_preference_get: {
    parameters: {
      query?: {
        preference_name?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PunterPreferenceSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Update Preference
   * @description Insert or update the punter preference
   */
  update_preference_punter_account_preference_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['PunterPreferenceSchema'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PunterPreferenceSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Banks
   * @description Returns all matching banks for a given Punter
   */
  get_banks_punter_bank_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['api__endpoints__punter__account__bank__BankSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Add New Bank */
  add_new_bank_punter_bank_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['NewBank'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['api__endpoints__punter__account__bank__BankSchema'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Download Punter Transactions
   * @description For the punter requesting, returns a csv with all their transaction history.
   *
   * *Matt Balshaw*
   */
  download_punter_transactions_punter_transactions_download_all_get: {
    responses: {
      /** @description Returns a CSV of the punters transactions */
      200: {
        content: {
          'application/json': unknown;
          'text/csv': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Punter Transactions
   * @description For the punter requesting, returns a list of their transactions.
   */
  get_punter_transactions_punter_transactions_get: {
    parameters: {
      query?: {
        offset?: number;
        limit?: number;
        is_bonus?: boolean;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PunterTransaction'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Limit Remaining
   * @description Return the punters remaning limit in cents. --- Samuel Mcilwain.
   */
  get_limit_remaining_punter_deposit_limit_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['RemainingLimitResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Fat Zebra Token
   * @description Return an oauth token for the frontend from fatzebra -- Samuel Flynn.
   */
  get_fat_zebra_token_punter_deposit_zebra_token_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['FatZebraOauthTokenResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Punters Cards
   * @description Get all the cards for the punter in the database.
   */
  punters_cards_punter_deposit_card_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['CardItemResponse'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Delete Card */
  delete_card_punter_deposit_card_delete: {
    requestBody: {
      content: {
        'application/json': components['schemas']['DeleteCardInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['CardItemResponse'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Create Deposit
   * @description Create a deposit in the database in which id is passed in from the frontend.
   */
  create_deposit_punter_deposit_create_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateDepositInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['DepositResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Update Deposit
   * @description Update a deposit in the database in which id is passed in from the frontend.
   * This will do an extra confirmation with Fat Zebra to ensure the deposit is valid.
   */
  update_deposit_punter_deposit_update_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateDepositStatusInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['DepositResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Pay
   * @description Attempt to pay with Fatzebra with a saved card_id
   *  and if successful then finalize the payment by crediting the punter account
   */
  pay_punter_deposit_pay_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['PayInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PayResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Put Session */
  put_session_punter_deposit_session_put: {
    requestBody: {
      content: {
        'application/json': components['schemas']['SessionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['SessionResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Patch Session */
  patch_session_punter_deposit_session_patch: {
    requestBody: {
      content: {
        'application/json': components['schemas']['SessionRequestPatch'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['SessionResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Payment Status */
  get_payment_status_punter_deposit_status_get: {
    parameters: {
      query: {
        deposit_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['DepositStatusResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Signup Punter
   * @description Signup a punter by creating the user in firebase, saving punter details in DB and initiating greenid check
   */
  signup_punter_punter_signup_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['SignupPunter'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['VerifiedPunter'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Customer Marketing
   * @description Returns all matching banks for a given Punter
   */
  get_customer_marketing_punter_marketing_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['MarketingSchema'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Create Or Update Customer Marketing */
  create_or_update_customer_marketing_punter_marketing_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['MarketingSchema'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['MarketingSchema'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Activity Statements */
  get_activity_statements_punter_statements_get: {
    parameters: {
      query?: {
        applied_from?: string;
        applied_to?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['ActivityStatementSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Promotions */
  get_promotions_punter_promotions_get: {
    parameters: {
      query: {
        promo_type: components['schemas']['PromoType'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['DepositMatchItem'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Claim Token
   * @description Claim a pending promo token
   */
  claim_token_punter_promotions_claim_token__token_id__post: {
    parameters: {
      path: {
        token_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['ClaimPromoTokenResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Submit Bet Slip */
  submit_bet_slip_punter_bet_slip_v2_submit_post: {
    requestBody: {
      content: {
        'application/json': (
          | components['schemas']['BetSlipSingleInputItem']
          | components['schemas']['BetSlipMultiInputItem']
          | components['schemas']['BetSlipExoticsInputItem']
          | components['schemas']['BetSlipComboMultiInputItem']
          | components['schemas']['BetSlipSGMultiInputItem']
          | components['schemas']['BetSlipSRMultiInputItem']
          | components['schemas']['BetSlipBlendedInputItem']
        )[];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['BetSubmissionConfirmation'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Build Bet Slip
   * @description Build a betslip
   */
  build_bet_slip_punter_bet_slip_v2_build_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['BetBuildInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['BetBuildResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Race Detail Runner List
   * @description given a race id returns a list of runners in RunnerListRow format --Aneurin Hall
   */
  race_detail_runner_list_punter_races_race_details_runner_list_get: {
    parameters: {
      query: {
        race_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['RunnerListRow'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Race Detail Other Races
   * @description given a race id returns a list of the other races at the same venue on the same day -- Matt Balshaw
   */
  race_detail_other_races_punter_races_race_details_other_races_get: {
    parameters: {
      query: {
        race_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['OtherRacesRow'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Race Detail Race Meta
   * @description given a race UUID returns the metadata for the race in RaceMetadata format  -- Aneurin Hall
   */
  race_detail_race_meta_punter_races_race_details_race_meta_get: {
    parameters: {
      query: {
        race_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['RaceMetaData'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Race Results
   * @description Given a race id, returns the runners who resulted in the race with their final odds
   *
   * *Matt Balshaw*
   */
  race_results_punter_races_race_details_race_result_get: {
    parameters: {
      query: {
        race_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['RaceResultRow'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Specific Propositions
   * @description Given a list of race proposition ids, returns the data for these single propositions.
   *
   * Does not return any propositions if the platform does not offer the venue.
   *
   * Will not return sport propositions.
   *
   * *Matt Balshaw*
   */
  get_specific_propositions_punter_races_race_details_specific_propositions_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['api__endpoints__punter__races__race_details__SpecificPropositionInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PropositionSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Markets
   * @description Return a list of markets for the specified race
   */
  get_markets_punter_races_race_details_markets_get: {
    parameters: {
      query: {
        race_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['MarketSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Races Venue List
   * @description Given a race type returns all venues offered on a platform with races for today, you may optionally send a
   * date in YYYY-MM-DD format to get results for a specific day. -- Samuel Flynn
   */
  races_venue_list_punter_races_venue_list_get: {
    parameters: {
      query: {
        race_type: components['schemas']['RaceTypes'];
        meeting_date?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['VenueListView'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Next To Jump
   * @description Return the next to jump races. --- Samuel Flynn.
   */
  next_to_jump_punter_races_next_to_jump_get: {
    parameters: {
      query?: {
        limit?: number;
        offset?: number;
        race_type?: components['schemas']['RaceTypes'];
        country_codes?: string[];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['NextRaceObject'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Next To Jump Cursor
   * @description Return the next to jump races with cursor pagination -- *Daniel Morley*
   */
  next_to_jump_cursor_punter_races_next_to_jump_cursor_get: {
    parameters: {
      query?: {
        limit?: number;
        race_type?: components['schemas']['RaceTypes'];
        next_start_time?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['NextRaceObject'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Market Groups
   * @description Given a match id returns all of the market groups for the match.
   */
  get_market_groups_punter_sports_sport_details_market_groups_get: {
    parameters: {
      query: {
        match_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['MarketGroupsPunterSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Markets
   * @description Given a match id, returns all the open markets for that match.
   *
   * Does not return markets if the platform does not offer the match.
   */
  get_markets_punter_sports_sport_details_markets_get: {
    parameters: {
      query: {
        match_id: string;
        market_group_id?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['MarketSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Propositions
   * @description Given a market id list, returns the propositions for that market with their odds.
   *
   * Does not return propositions if the platform does not offer the market.
   *
   * *Matt Balshaw*
   */
  get_propositions_punter_sports_sport_details_propositions_get: {
    parameters: {
      query?: {
        market_id?: string[];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PropositionSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Props
   * @description Given a market id list, returns the propositions for that market with their odds.
   *
   * Does not return propositions if the platform does not offer the market.
   *
   * *Matt Balshaw*
   */
  get_props_punter_sports_sport_details_props_get: {
    parameters: {
      query: {
        market_ids: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Specific Propositions
   * @description Given a list of sport proposition ids, returns the data for these single propositions.
   *
   * Does not return any propositions if the platform does not offer the market.
   *
   * Will not return race propositions.
   *
   * *Matt Balshaw*
   */
  get_specific_propositions_punter_sports_sport_details_specific_propositions_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['api__endpoints__punter__sports__sport_details__SpecificPropositionInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PropositionSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get All Sports
   * @description Returns all sports where the bookie offers at least one competition -- Aneurin Hall
   */
  get_all_sports_punter_sports_sport_list_get: {
    parameters: {
      query?: {
        sport_type?: components['schemas']['SportType'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['SportSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Filter Sports
   * @description Returns all matches ordered based on how soon match starts, ascending.
   * Will not return resulted matches
   * Will not return matches without open markets
   * *Rob Mcnamara*
   */
  filter_sports_punter_sports_next_to_jump_get: {
    parameters: {
      query?: {
        sport_name?: string;
        offset?: number;
        limit?: number;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['NextToJumpMatches'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Filter Sports Cursor
   * @description Returns all matches ordered based on how soon match starts, ascending with cursor pagination.
   * Will not return resulted matches -- *Daniel Morley*
   * Will not return matches without open markets
   */
  filter_sports_cursor_punter_sports_next_to_jump_cursor_get: {
    parameters: {
      query?: {
        sport_name?: string;
        limit?: number;
        next_start_time?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['api__meta__schemas__punter_schemas__MatchSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Pp Competitions Tournaments
   * @description Returns list of competitions and matches for a given sport, with it's corresponding sport id, name and icon -- Aneurin Hall, Jake McClay, Daniel Morley
   */
  pp_competitions_tournaments_punter_sports_competitions_tournaments_get: {
    parameters: {
      query: {
        sport_id: string;
        country?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Markets For Competition
   * @deprecated
   * @description Given a competition returns all markets ordered by next to start --Aneurin Hall
   */
  get_markets_for_competition_punter_sports_competition_markets_get: {
    parameters: {
      query: {
        competition_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['CompetitionMarketView'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Matches For Competition Or Tournament
   * @description Returns a list of matches in the future given either a competition or tournament id or both -- Matt Balshaw
   */
  matches_for_competition_or_tournament_punter_sports_matches_get: {
    parameters: {
      query?: {
        competition_id?: string;
        tournament_id?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['api__meta__schemas__punter_schemas__MatchSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Upcoming Matches By Time */
  get_upcoming_matches_by_time_punter_sports_upcoming_matches_by_time_get: {
    parameters: {
      query?: {
        limit?: number;
        sport_id?: string[];
        competition_id?: string[];
        main_market_types?: string;
        top_markets?: boolean;
        offset?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['UpcomingMatchesByTimeSchema'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Upcoming Matches Sport Order
   * @description Returns a list of matches grouped by sport including the main market and props for that market for each match
   */
  upcoming_matches_sport_order_punter_sports_upcoming_matches_group_by_sport_get: {
    parameters: {
      query?: {
        sport_id?: string[];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PunterSportSchema'][];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Sport And Race Offerings
   * @description Returns all sport and racing types offered by the platform - Daniel Morley
   */
  get_sport_and_race_offerings_punter_general_offerings_get: {
    parameters: {
      query?: {
        pc?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PlatformOfferings'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Terms Of Service
   * @description Returns the terms of service for a punter on the platform regardless of Punter singin - Daniel Morley
   */
  get_terms_of_service_punter_general_terms_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['TermsOfService'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Privacy Policy
   * @description Returns the privacy policy for a punter on the platform regardless of Punter singin - Daniel Morley
   */
  get_privacy_policy_punter_general_privacy_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['PrivacyPolicy'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Bookie Contact */
  get_bookie_contact_punter_general_contact_get: {
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['BookieContactUsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Content
   * @description Returns bookie managed content for a given page e.g. homepage
   */
  get_content_punter_content__page__get: {
    parameters: {
      path: {
        page: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['Sitecontent'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Srm Selection Price
   * @description Gets the price of selected propositions. Currently supports SGM pricing.
   */
  get_srm_selection_price_punter_pricing_srm_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['SrmPriceRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['SrmPriceResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Sgmulti Selection Price
   * @description Gets the price of selected propositions. Currently supports SGM pricing.
   */
  get_sgmulti_selection_price_punter_pricing_sgm_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['SGMultiPriceRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['SGMultiPriceResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Blended Selection Price
   * @description Gets the price of selected propositions.
   */
  get_blended_selection_price_punter_pricing_blended_post: {
    requestBody: {
      content: {
        'application/json': components['schemas']['BlendedPriceRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['BlendedPriceResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /**
   * Get Even Shot Prop
   * @description Uses the even-shot algorithm to decide the closest prop to $2.
   */
  get_even_shot_prop_punter_pricing_even_shot_get: {
    parameters: {
      query: {
        race_id: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['EvenShotPropResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
  /** Get Odds */
  get_odds_external_forsport_odds_get: {
    parameters: {
      query: {
        competitionIds: string;
        notBefore?: string;
        notAfter?: string;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        content: {
          'application/json': components['schemas']['ForsportOddsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['BetcloudErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: never;
    };
  };
};

export const ActionTypes = [
  'Withdrawal_Processed',
  'Withdrawal_Requested',
  'Margins_Update',
  'BookieProfile_Update',
  'update_bookie_roles',
  'update_permission_roles',
  'Authentication_Logout',
  'Authentication_Login',
  'Offerings_Enabled',
  'Offerings_Disabled',
  'PunterProfile_InfoUpdate',
  'Attachment_Added',
  'Attachment_Removed',
  'Note_Deleted',
  'Punter_Duplicate',
  'Blacklisted_Punter',
  'Authentication_ResetPassword',
  'Bet_Approvals_Approve',
  'Bet_Approvals_Reject',
  'Bet_Approvals_Request',
  'Bet_Approvals_Claim',
  'Registration_Initiated',
  'Registration_Completed',
  'Limits_DepositSet',
  'Limits_DepositUpdated',
  'Limits_DepositRemoved',
  'Verification_Success',
  'Verification_Failed',
  'Verification_DocumentRequired',
  'Verification_DocumentSuccess',
  'Verification_DocumentFailed',
  'PersonalInfo_Updated',
  'Bet_Slip_Submitted',
  'Bet_Placed',
  'Bet_Approved',
  'Bet_Rejected',
  'Bet_Slip_Rejected',
  'Bet_Voided',
  'TOSPP_Updated',
  'Withdrawal_Approved',
  'Withdrawal_Rejected',
  'Withdrawal_Transfer_Successful',
  'Withdrawal_Transfer_Unsucessful',
  'Withdrawals_Exported',
  'Withdrawal_Cancelled',
  'Withdrawal_Cancel_Failed',
  'Bank_Added',
  'Bank_Deleted',
  'Global_Bet_Limit_Updated',
  'Bank_Updated',
  'Account_Status_Updated',
  'Platform_Contact_Details_Updated',
  'upload_inserted',
  'upload_deleted',
  'upload_updated',
] as const;

export const AustralianStatesTerritories = [
  'Tasmania',
  'Victoria',
  'New South Wales',
  'Queensland',
  'South Australia',
  'Western Australia',
  'Northern Territory',
  'Australian Capital Territory',
] as const;

export const BetPlaceRejectionReason = [
  'OddsChange',
  'SGMultiOddsChange',
  'SRMultiOddsChange',
  'InsufficentFund',
  'PropositionClosed',
  'PropositionSuspended',
  'HighRisk',
  'AccountClosed',
  'ManualRejection',
  'UnknownError',
  'UnsupportedBetType',
  'UnavailableBetType',
  'NegativeStake',
  'FailMinimumStake',
  'PlaceBetInvalidFieldSize',
  'DuplicateRequest',
  'BetslipRejection',
  'AlreadyProcessedRequest',
  'SelectionExpansionRejection',
  'PropositionInvalidForBetType',
  'InsufficientLegsForMulti',
  'ExceededMaximumLegsForMulti',
  'MultipleLegsInEventForMulti',
  'InvalidProposition',
  'MaxStakeExceeded',
  'MultiNotAllowed',
  'AcrossMultipleEventsForSGMulti',
  'InvalidPriceType',
  'SGMultiNoPrice',
  'SGMultiUnavailable',
  'SRMultiUnavailable',
  'SGMultiMatchEventNotFound',
  'SRMultiNoPrice',
  'InvalidSRMultiSelection',
  'BonusNotAllowed',
  'BlendedUnavailable',
  'BlendedRaceEventNotFound',
  'EvenShotUnavailable',
  'ExceededMaximumBetsForEvenShot',
] as const;

export const BetPlaceStatus = [
  'Placed',
  'Rejected',
  'Pending',
  'ReducedStake',
] as const;

export const BetRequestAction = [
  'Approved',
  'Rejected',
  'Counter',
  'AcceptMBL',
] as const;

export const BetRequestType = ['Placement', 'Settlement'] as const;

export const BetRequestsSupportedSortColumns = [
  'created_at',
  'updated_at',
  'type',
  'odds',
  'stake',
  'status',
  'punter_name',
  'event_title',
  'event_subtitle',
  'event_start',
  'event_type',
  'event_icon',
  'event_exposure',
  'bet_payout',
  'bet_status',
  'bet_won',
] as const;

export const BetResultSortField = ['stake', 'exposure', 'bets_count'] as const;

export const BetResultSortOrder = ['asc', 'desc'] as const;

export const BetStatuses = [
  'pending',
  'settled',
  'voided',
  'cancelled',
  'cashed_out',
] as const;

export const BetSubType = [
  'Exacta',
  'Trifecta',
  'Quinella',
  'FirstFour',
] as const;

export const BetTokenStatus = ['pending', 'claimed'] as const;

export const BetTokenType = [
  'recovery',
  'spin-wheel',
  'odds-boost',
  'deposit-match',
] as const;

export const BetType = [
  'Single',
  'Multi',
  'SGMulti',
  'SRMulti',
  'ComboMulti',
  'Tote',
  'Exotics',
  'Blended',
] as const;

export const BetValidationErrors = [
  'betslip_retry_required',
  'betslip_insufficient_funds',
  'bet_insufficient_funds',
  'bet_changed_odds',
  'bet_invalid_proposition_id',
  'bet_invalid_proposition_name',
  'bet_proposition_closed',
  'bet_proposition_scratched',
  'bet_proposition_has_no_racerunner',
  'bet_proposition_with_insufficient_field_size',
] as const;

export const BetsSupportedSortColumns = [
  'created_at',
  'event_title',
  'event_subtitle',
  'punter_name',
  'bookie_name',
  'odds',
  'stake',
  'payout',
] as const;

export const ChannelType = ['IOSApp', 'AndroidApp', 'DesktopBrowser'] as const;

export const DepositStatuses = [
  'ManuallyApproved',
  'Pending',
  'Approved',
  'Declined',
  'Abandoned',
  'Cancelled',
  'Unknown',
] as const;

export const EventFrequencies = [1, 7, 14, 28, 365] as const;

export const EventSupportedSortColumns = [
  'start_time',
  'event_title',
  'total_bets',
  'turnover',
  'biggest_bet',
] as const;

export const EventTypes = ['Race', 'Match'] as const;

export const FlagFilterOption = [
  'allFlagged',
  'flaggedByMe',
  'flaggedByOthers',
] as const;

export const GeneralStatus = [
  'Open',
  'Closed',
  'Abandoned',
  'Removed',
  'Settled',
  'Voided',
  'Scratched',
  'Interim',
] as const;

export const LegacyPunterStatus = [
  'Normal',
  'Suspended_KYC',
  'Closed_Customer_Requested',
  'Temporary_Self_Exclusion',
  'Permanent_Self_Exclusion',
  'Temporary_Lockout',
  'Permanent_Lockout',
] as const;

export const MarketMoverTypes = [
  'Fire High Animation',
  'Fire Medium Animation',
  'Fire Low Animation',
  'Ice High Animation',
  'Ice Medium Animation',
  'Ice Low Animation',
] as const;

export const NoteTypes = [
  'Account Balance',
  'Dispute',
  'Verification',
  'Promo',
  'General',
  'Sticky',
] as const;

export const PriceType = [
  'starting',
  'fixed',
  'sgm',
  'srm',
  'tote_single_mid',
  'blended',
  'even_shot',
] as const;

export const PrimerPaymentType = ['FIRST_PAYMENT', 'ECOMMERCE'] as const;

export const PromoSource = ['csv', 'manual', 'storm', 'auto'] as const;

export const PromoStatus = ['pending', 'claimed', 'cancelled'] as const;

export const PromoType = [
  'deposit_match',
  'first_deposit_match',
  'bonus_bet',
  'money_back',
] as const;

export const PropositionOutcome = ['Winner', 'Loser', 'Top2', 'Top3'] as const;

export const PropositionResult = ['WINNER', 'LOSER', 'REFUND'] as const;

export const PropositionTypes = [
  'Win',
  'Place',
  'Exacta',
  'Trifecta',
  'Quinella',
  'FirstFour',
] as const;

export const PunterCategories = [
  'Newbie',
  'Sharp',
  'Promo Arber',
  'Player',
  'Recreational',
  'High Roller',
  'Approval Only',
  'Blacklist',
] as const;

export const PunterStatusReasons = [
  'Pending_Verification',
  'Customer_Requested',
  'Responsible_Gambling',
  'Fraud_Risk',
  'Duplicate_Account',
  'Business_Decision',
  'Blacklist',
  'Docs_Requested',
  'Betstop',
  'Cross_Brand_Exclusion',
  'None',
] as const;

export const PunterStatuses = [
  'Open',
  'Closed',
  'Suspended',
  'Locked_Temporary',
  'Locked_Permanent',
  'Exclusion_Temporary',
  'Exclusion_Permanent',
] as const;

export const RaceTypes = [
  'Horse Racing',
  'Greyhounds',
  'Harness Racing',
] as const;

export const SGMultiBetSortBy = ['stake', 'odds', 'exposure'] as const;

export const SGMultiBetSortOrder = ['asc', 'desc'] as const;

export const SGMultiMonitorSortBy = [
  'stake',
  'max_bet',
  'exposure',
  'start_time',
] as const;

export const SGMultisMatchCombinationsSortBy = [
  'stake',
  'odds',
  'exposure',
] as const;

export const SGMultisPropositionSortBy = ['stake', 'odds', 'exposure'] as const;

export const SRMultiBetSortOrder = ['asc', 'desc'] as const;

export const SRMultiMonitorSortBy = [
  'stake',
  'exposure',
  'start_time',
] as const;

export const SRMultiRaceBetsSortBy = ['stake', 'exposure'] as const;

export const SRMultiRaceCombinationsSortBy = ['stake', 'exposure'] as const;

export const SRMultiRaceRunnersSortBy = ['stake', 'exposure'] as const;

export const SRMultiSortOrder = ['asc', 'desc'] as const;

export const SportType = [
  'Promotional',
  'SportFutures',
  'RacingFutures',
] as const;

export const SrmTopSelection = ['Top1', 'Top2', 'Top3', 'Top4'] as const;

export const States = [
  'VIC',
  'NSW',
  'QLD',
  'SA',
  'TAS',
  'NT',
  'WA',
  'ACT',
] as const;

export const StormConfidence = ['Low', 'Medium', 'High'] as const;

export const SupportedSortOrders = ['asc', 'desc'] as const;

export const TokenType = ['recovery', 'spin-wheel', 'odds-boost'] as const;

export const TransactionTypes = [
  'Deposit',
  'Bet',
  'Winnings',
  'Bonus',
  'Withdrawal',
  'Void',
  'Adjustment',
  'Cancelled',
  'Credit',
] as const;

export const UploadType = ['policies', 'banner'] as const;

export const WithdrawalStatus = [
  'Pending',
  'Cancelled',
  'Rejected',
  'Approved',
  'Processed',
  'Error',
] as const;

export const WithdrawalStatusEnum = [
  'Pending',
  'Cancelled',
  'Rejected',
  'Approved',
  'Processed',
  'Error',
] as const;
